import {
  Card,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
  Label,
  Alert,
  UncontrolledTooltip,
} from "reactstrap";

import * as XLSX from "xlsx";

import "react-calendar/dist/Calendar.css";
import { api } from "../../../../api";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const VendorManagement = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  // Removed Stock Report search bar state
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedVendorFilter, setSelectedVendorFilter] = useState("");
  const [selectedProductFilter, setSelectedProductFilter] = useState("");
  const [productFilterDropdownOpen, setProductFilterDropdownOpen] = useState(false);
  const [vendorSearchQuery, setVendorSearchQuery] = useState("");
  const [productSearchQuery, setProductSearchQuery] = useState("");
  
  // New state for vendor_to_store table
  const [vendorToStoreData, setVendorToStoreData] = useState([]);
  const [deliveryStockData, setDeliveryStockData] = useState([]);
  const [selectedProductStock, setSelectedProductStock] = useState(0);

  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [alertType, setAlertType] = useState("success"); // "success" or "error"
  const [materialDeliveryForm, setMaterialDeliveryForm] = useState({
    vendor_id: "",
    vendor_product_id: "",
    selectedProductName: "", // New field to store selected product name
    p_id: "",
    quantity_delivered: "",
    delivery_date: "",
    material_tracking_number: "",
    delivered_to: "",
    cost: "",
  });

  // Project Report states
  const [projectReports, setProjectReports] = useState([]);
  const [filteredProjectReports, setFilteredProjectReports] = useState([]);
  const [projectReportLoading, setProjectReportLoading] = useState(false);
  const [projectReportGenerating, setProjectReportGenerating] = useState(false);
  const [projectReportMessage, setProjectReportMessage] = useState('');
  const [projectReportMessageType, setProjectReportMessageType] = useState('');
  
  // Project Report filter states
  const [selectedProjectReportProject, setSelectedProjectReportProject] = useState('');
  const [selectedProjectReportVendor, setSelectedProjectReportVendor] = useState('');
  const [projectReportProductSearch, setProjectReportProductSearch] = useState('');
  const [projectReportProjectSearch, setProjectReportProjectSearch] = useState('');
  const [projectReportProjectDropdownOpen, setProjectReportProjectDropdownOpen] = useState(false);
  const [projectReportVendorDropdownOpen, setProjectReportVendorDropdownOpen] = useState(false);
  
  // Project Report pagination states
  const [projectReportCurrentPage, setProjectReportCurrentPage] = useState(1);
  const [projectReportEntriesPerPage, setProjectReportEntriesPerPage] = useState(10);
  const [projectReportEntriesDropdownOpen, setProjectReportEntriesDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("viewItemsVM.php?company_id=" + Cookies.get('company_id'));
        const products = response.data.products;
        setOriginalData(products); // Store original data
        setFilteredData(products); // Initially set filtered data to original data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Fetch store to vendor data
  useEffect(() => {
    const fetchStoreToVendorData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`returnToVendor.php?company_id=${company_id}`);
        if (response.data && response.data.status === 'success') {
          const data = response.data.records || [];
          setStoreToVendorData(data);
          setFilteredStoreToVendorData(data);
        }
      } catch (error) {
        console.error("Error fetching store to vendor data:", error);
        setStoreToVendorData([]);
        setFilteredStoreToVendorData([]);
      }
    };

    fetchStoreToVendorData();
  }, []);

  // Fetch vendor to store data
  useEffect(() => {
    const fetchVendorToStoreData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`vendorToStore.php?company_id=${company_id}`);
        console.log("Vendor to store API response:", response.data);
        
        if (response.data && response.data.status === 'success') {
          const data = response.data.records || [];
          console.log("Setting vendor to store data:", data);
          setVendorToStoreData(data);
          setFilteredVendorToStoreData(data);
        } else {
          console.log("No success status, setting empty arrays");
          setVendorToStoreData([]);
          setFilteredVendorToStoreData([]);
        }
      } catch (error) {
        console.error("Error fetching vendor to store data:", error);
        setVendorToStoreData([]);
        setFilteredVendorToStoreData([]);
      }
    };

    fetchVendorToStoreData();
  }, []);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteIconClick = (item_id) => {
    setItemToDelete(item_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete("viewItemsVM.php?company_id=" + Cookies.get('company_id'), {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ vendor_product_id: itemToDelete }),
      });
      console.log(response.data);
      
      // Show success message instead of reloading
      setSuccessMessage('Stock deleted successfully!');
      setShowSuccessAlert(true);
      setShowDeleteConfirmation(false);
      
      // Remove the deleted item from the data
      const updatedData = filteredData.filter(item => item.vendor_product_id !== itemToDelete);
      setFilteredData(updatedData);
      setOriginalData(updatedData);
      
      // Reset form
      setItemToDelete(null);
      
      // Hide success alert after 3 seconds
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);
      
    } catch (error) {
      console.error("Error deleting item:", error);
      setShowDeleteConfirmation(false);
    }
  };

  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showRoleModal2, setShowRoleModal2] = useState(false);
  const [showRoleModal3, setShowRoleModal3] = useState(false);
  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
    // Clear alert message and field errors when modal is opened or closed
    if (!showRoleModal) {
      setAlertMessage("");
      setFieldErrors({
        vendor_name: "",
        product_name: "",
        total_stock: "",
        available_stock: "",
        cost: ""
      });
      
      
    }
  };
  const toggleRole2 = () => {
    setShowRoleModal2(!showRoleModal2);
  };
  const toggleRole3 = () => {
    setShowRoleModal3(!showRoleModal3);
  };

  const [role, setrole] = useState();

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);



  // Store to Vendor (Return STOCK) states
  const [storeToVendorData, setStoreToVendorData] = useState([]);
  const [showReturnToVendorModal, setShowReturnToVendorModal] = useState(false);
  const [returnToVendorForm, setReturnToVendorForm] = useState({
    vendor_id: "",
    product_id: "",
    quantity_returned: "",
    return_date: "",
    return_reason: ""
  });

  // Store to Vendor filter states
  const [selectedStoreToVendorVendor, setSelectedStoreToVendorVendor] = useState("");
  const [storeToVendorStartDate, setStoreToVendorStartDate] = useState("");
  const [storeToVendorEndDate, setStoreToVendorEndDate] = useState("");
  const [storeToVendorVendorFilterDropdownOpen, setStoreToVendorVendorFilterDropdownOpen] = useState(false);
  const [filteredStoreToVendorData, setFilteredStoreToVendorData] = useState([]);
  const [storeToVendorCurrentPage, setStoreToVendorCurrentPage] = useState(1);
  const [storeToVendorEntriesToShow, setStoreToVendorEntriesToShow] = useState(5);
  const [storeToVendorShowEntriesDropdownOpen, setStoreToVendorShowEntriesDropdownOpen] = useState(false);
  const [storeToVendorTotalPages, setStoreToVendorTotalPages] = useState(1);

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [dataToShow, setDataToShow] = useState([]);
  const [dataToShow2, setDataToShow2] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredData.length / entriesToShow);

  useEffect(() => {
    setDataToShow(
      filteredData.slice(
        (currentPage - 1) * entriesToShow,
        currentPage * entriesToShow
      )
    );
  }, [entriesToShow, currentPage, filteredData]);

  // Update total pages when filtered data changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when data changes
  }, [filteredData]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? filteredData.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "stock_list";

    const formattedData = dataToShow.map((item) => ({
      "Product Id": item.vendor_name,
      "Product Name": item.product_name,

      "Current Stock(Quantity)": item.available_stock,
      "Total Stock": item.total_stock,
      Cost: item.cost,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Product Id",
        "Product Name",
        "Current Stock(Quantity)",
        "Total Stock",
        "Cost",
      ],
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock List");

    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => {
        ws[key].s = headerCellStyle;
      });

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const excelData = new Blob([excelBuffer], { type: fileType });

    const excelUrl = URL.createObjectURL(excelData);

    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };


  const [addstock2, setAddStock2] = useState({
    product_name: "",
    quantity_delivered: "",
    delivery_date: "",
    delivered_to_name: "",
    product_cost: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddStock((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setAddStock2((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // Clear alert message when user starts typing
    if (alertMessage) {
      setAlertMessage("");
    }
    // Clear field-specific error when user types
    if (fieldErrors[name]) {
      setFieldErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
    
    // Real-time validation for required fields
    if (name === 'vendor_name' || name === 'product_name') {
      if (value.trim() === '') {
        setFieldErrors(prev => ({
          ...prev,
          [name]: `${name === 'vendor_name' ? 'Vendor name' : 'Product name'} is required`
        }));
      } else {
        setFieldErrors(prev => ({
          ...prev,
          [name]: ""
        }));
      }
    }
    
    // Real-time validation for numeric fields
    if (name === 'total_stock' || name === 'available_stock' || name === 'cost') {
      const numValue = parseFloat(value);
      if (value !== '' && numValue < 0) {
        setFieldErrors(prev => ({
          ...prev,
          [name]: `Value must be greater than or equal to 0`
        }));
      } else if (name === 'available_stock' && addstock.total_stock && numValue > parseFloat(addstock.total_stock)) {
        setFieldErrors(prev => ({
          ...prev,
          [name]: `Available stock cannot exceed total stock (${addstock.total_stock})`
        }));
      }
      
      // If total stock changes, re-validate available stock
      if (name === 'total_stock' && addstock.available_stock) {
        const availableStock = parseFloat(addstock.available_stock);
        if (numValue < availableStock) {
          setFieldErrors(prev => ({
            ...prev,
            available_stock: `Available stock cannot exceed total stock (${numValue})`
          }));
        } else {
          // Clear available stock error if it's now valid
          setFieldErrors(prev => ({
            ...prev,
            available_stock: ""
          }));
        }
      }
    }
    
    console.log(addstock);
  };

  const [addstock, setAddStock] = useState({
    vendor_name: "",
    product_name: "",
    total_stock: 0,
    available_stock: 0,
    cost: "",
    delivery_date: "",
  });

  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  
  // Individual field validation states
  const [fieldErrors, setFieldErrors] = useState({
    vendor_name: "",
    product_name: "",
    total_stock: "",
    available_stock: "",
    cost: "",
    delivery_date: ""
  });

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    // Clear previous field errors
    setFieldErrors({
      vendor_name: "",
      product_name: "",
      total_stock: "",
      available_stock: "",
      cost: "",
      delivery_date: ""
    });
    
    let hasErrors = false;
    const newFieldErrors = { ...fieldErrors };
  
    // Validate vendor name
    if (!addstock.vendor_name) {
      newFieldErrors.vendor_name = "Vendor name is required";
      hasErrors = true;
    }
    
    // Validate product name
    if (!addstock.product_name) {
      newFieldErrors.product_name = "Product name is required";
      hasErrors = true;
    }
    
    // Validate total stock
    if (parseFloat(addstock.total_stock) < 0) {
      newFieldErrors.total_stock = "Total stock cannot be negative";
      hasErrors = true;
    }
    
    // Validate available stock
    if (parseFloat(addstock.available_stock) < 0) {
      newFieldErrors.available_stock = "Available stock cannot be negative";
      hasErrors = true;
    }
    
    // Validate cost
    if (parseFloat(addstock.cost) < 0) {
      newFieldErrors.cost = "Cost cannot be negative";
      hasErrors = true;
    }
    
    // Validate delivery date
    if (!addstock.delivery_date) {
      newFieldErrors.delivery_date = "Delivery date is required";
      hasErrors = true;
    } else {
      // Ensure date is in YYYY-MM-DD format
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(addstock.delivery_date)) {
        newFieldErrors.delivery_date = "Invalid date format. Please use YYYY-MM-DD";
        hasErrors = true;
      }
    }
    
    // Validate that available stock doesn't exceed total stock
    if (parseFloat(addstock.available_stock) > parseFloat(addstock.total_stock)) {
      newFieldErrors.available_stock = "Available stock cannot exceed total stock";
      hasErrors = true;
    }
    
    if (hasErrors) {
      setFieldErrors(newFieldErrors);
      return;
    }
  
    // Prepare data to send
    const formDataToSend = {
      vendor_name: addstock.vendor_name,
      product_name: addstock.product_name,
      total_stock: addstock.total_stock,
      available_stock: addstock.available_stock,
      cost: addstock.cost,
      company_id: Cookies.get('company_id'), // Added company_id to POST body
    };
    

  
    try {
      const response = await api.post("additemsVM.php?company_id=" + Cookies.get('company_id'), formDataToSend);
      if (response.data.status === "success") {
        // Also create a record in vendor_to_store table for tracking initial delivery
        try {
          const vendorToStoreData = {
            vendor_id: addstock.vendor_name, // Using vendor_name as vendor_id for now
            vendor_name: addstock.vendor_name,
            product_name: addstock.product_name,
            initial_quantity: addstock.total_stock,
            cost_per_unit: addstock.cost,
            delivery_date: addstock.delivery_date, // Use selected delivery date
            company_id: Cookies.get('company_id')
          };
          
          await api.post("vendorToStore.php", vendorToStoreData);
          console.log("Vendor to store record created successfully");
        } catch (error) {
          console.error("Error creating vendor to store record:", error);
          // Don't fail the main operation if this fails
        }
        
        // Show different messages based on whether product was created or updated
        if (response.data.action === "updated") {
          setSuccessMessage(`Product stock updated successfully! Previous stock: ${response.data.previous_available_stock}, New stock: ${response.data.new_available_stock}`);
        } else {
          setSuccessMessage("New product added successfully!");
        }
        setShowSuccessAlert(true);
        setAlertMessage(""); // Clear any alert messages
        setFieldErrors({
          vendor_name: "",
          product_name: "",
          total_stock: "",
          available_stock: "",
          cost: "",
          delivery_date: ""
        });
        setAddStock({
          vendor_name: "",
          product_name: "",
          total_stock: 0,
          available_stock: 0,
          cost: "",
          delivery_date: "",
        });

        toggleRole(); // Close the modal
        // Refresh vendor to store data
        try {
          const company_id = Cookies.get('company_id');
          const response = await api.get(`vendorToStore.php?company_id=${company_id}`);
          if (response.data && response.data.status === 'success') {
            setVendorToStoreData(response.data.records || []);
          }
        } catch (error) {
          console.error("Error refreshing vendor to store data:", error);
        }
        
        // Auto-hide success message after 3 seconds
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 3000);
      } else {
        setAlertMessage(response.data.message || "Error adding product");
      }
    } catch (error) {
      setAlertMessage("Error submitting data. Please try again.");
      console.error("Error submitting data:", error);
    }
  };
  const handleFormSubmit2 = async (event) => {
    event.preventDefault(); // Prevent default browser form submission

    // Basic validation check (optional, but good practice)
    if (!addstock2.product_name) {
      alert("Please select a product.");
      return;
    }

    const formDataToSend = {
      product_name: addstock2.product_name,
      quantity_delivered: addstock2.quantity_delivered,
      delivery_date: addstock2.delivery_date,
      delivered_to_name: addstock2.delivered_to_name,
      product_cost: addstock2.product_cost,
    };

    console.log("Submitting data:", formDataToSend); // Log data before sending

    try {
      const response = await api.post("addDeliveryStock.php?company_id=" + Cookies.get('company_id'), formDataToSend);
      console.log("Data sent successfully:", response.data);
      alert("Delivery stock added successfully!"); // User feedback
      // Consider resetting the form instead of reloading the whole page for better UX
      // setAddStock({
      //   product_name: "",
      //   quantity_delivered: "",
      //   delivery_date: "",
      //   delivered_client: "",
      //   cost: "",
      // });
      window.location.reload(); // Reloads the page as per original code
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Error submitting data. Please check the console for details."); // User feedback on error
    }
  };

  useEffect(() => {
    let filtered = [...originalData];
    
    // Apply vendor filter first
    if (selectedVendorFilter) {
      filtered = filtered.filter(item => String(item.vendor_id) === String(selectedVendorFilter));
    }
    
    // Apply product filter
    if (selectedProductFilter) {
      filtered = filtered.filter(item => item.product_name === selectedProductFilter);
    }
    
    setFilteredData(filtered);
    // Reset to first page when filters change
    setCurrentPage(1);
  }, [selectedVendorFilter, selectedProductFilter, originalData]);

  const [projectDropdownOpen2, setProjectDropdownOpen2] = useState(false);
  const [projectDropdownOpen3, setProjectDropdownOpen3] = useState(false);
  const [projectDropdownOpen4, setProjectDropdownOpen4] = useState(false);

  const toggleProjectDropdown2 = () => {
    setProjectDropdownOpen2(!projectDropdownOpen2);
  };
  const toggleProjectDropdown3 = () => {
    setProjectDropdownOpen3(!projectDropdownOpen3);
    // Clear search when closing dropdown
    if (projectDropdownOpen3) {
      setVendorSearchQuery("");
    }
  };

  const toggleProductFilterDropdown = () => {
    setProductFilterDropdownOpen(!productFilterDropdownOpen);
    // Clear search when closing dropdown
    if (productFilterDropdownOpen) {
      setProductSearchQuery("");
    }
  };

  // Get unique product names for the filter dropdown
  const getUniqueProducts = () => {
    if (!Array.isArray(originalData)) return [];
    const uniqueProducts = [...new Set(originalData.map(item => item.product_name).filter(Boolean))];
    return uniqueProducts.sort();
  };

  // Handle vendor selection and clear search
  const handleVendorFilter = (vendorId) => {
    setSelectedVendorFilter(vendorId);
    setVendorSearchQuery(""); // Clear search when selecting a vendor
  };

  // Handle product selection and clear search
  const handleProductFilter = (productName) => {
    setSelectedProductFilter(productName);
    setProductSearchQuery(""); // Clear search when selecting a product
  };
  const toggleProjectDropdown4 = () => {
    setProjectDropdownOpen4(!projectDropdownOpen4);
  };


  const handleRequestOptionChange = (e) => {
    setRequestOption(e.target.value);
    if (e.target.value === "single") {
      toggleRole();
    } else if (e.target.value === "multiple") {
      toggleModalImport();
    }
  };
  const [requestOption, setRequestOption] = useState("");
  const toggleModalAdd = () => setModalAdd(!modalAdd);
  const [modalAdd, setModalAdd] = useState(false);
  const [importedFile, setImportedFile] = useState(null);
  const emp_id = Cookies.get("token") || Cookies.get("emp_id");

  const [reqmaterial, setReqmaterial] = useState({
    emp_id: emp_id || "",
    p_id: "",
    files: [],
    g_m_id: "",
  });

  const handleImportFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImportedFileDetails({
        fileName: file.name,
        uploadTime: new Date().toLocaleTimeString(),
      });
      setUploadMessage({ type: "", text: "" }); // Clear previous messages
    } else {
      setSelectedFile(null);
      setImportedFileDetails(null);
    }
  };

  const [modalImport, setModalImport] = useState(false); // State to control modal visibility
  const [selectedFile, setSelectedFile] = useState(null); // State to hold the File object
  const [importedFileDetails, setImportedFileDetails] = useState(null); // State for display info
  const [isUploading, setIsUploading] = useState(false); // State for loading indicator
  const [uploadMessage, setUploadMessage] = useState({ type: "", text: "" }); // State for feedback

  const toggleModalImport = () => {
    setModalImport(!modalImport);
    // Reset states when opening or closing modal
    if (!modalImport) {
      setSelectedFile(null);
      setImportedFileDetails(null);
      setSelectedVendor('');
      
      setUploadMessage({ type: "", text: "" });
      setIsUploading(false);
    }
  };

  // Handle file selection

  // Handle form submission

  const [selectedVendor, setSelectedVendor] = useState("");

  const [selectedDeliveryDateForImport, setSelectedDeliveryDateForImport] = useState("");
  const handleImportSubmit = async (event) => {
    event.preventDefault();
  
    if (!selectedFile || !selectedVendor || !selectedDeliveryDateForImport) {
      setUploadMessage({
        type: "danger",
        text: "Please select a vendor, delivery date, and file to import.",
      });
      return;
    }
  
    setIsUploading(true);
    setUploadMessage({
      type: "primary",
      text: "Uploading and processing file...",
    });
  
    const formData = new FormData();
    formData.append("excel_file", selectedFile);
    formData.append("vendor_id", selectedVendor);

    formData.append("delivery_date", selectedDeliveryDateForImport);
    formData.append("company_id", Cookies.get('company_id'));
  
    try {
      const response = await api.post("importExcelVM.php?company_id=" + Cookies.get('company_id'), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.data.status === "success") {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || "Stocks imported successfully!";
        
        // Add details about skipped rows if any (legacy support)
        if (response.data.skipped_rows && response.data.skipped_rows.length > 0) {
          detailedMessage += ` Skipped ${response.data.skipped_rows.length} rows with invalid data.`;
        }
        if (response.data.updated_ids && response.data.updated_ids.length > 0) {
          detailedMessage += ` Updated ${response.data.updated_ids.length} existing products with additional stock.`;
        }
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setSelectedFile(null);
        setImportedFileDetails(null);
        setSelectedVendor('');
        setSelectedDeliveryDateForImport('');
        // Page will reload when user clicks OK button
      } else {
        setSuccessMessage(`Import failed: ${response.data.message || "Unknown error from server."}`);
        setAlertType("error");
        setShowSuccessAlert(true);
        setSelectedFile(null);
        setImportedFileDetails(null);
        setSelectedVendor('');
        setSelectedDeliveryDateForImport('');
      }
    } catch (error) {
      setSuccessMessage(`An error occurred during upload: ${error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
      setSelectedFile(null);
      setImportedFileDetails(null);
      setSelectedVendor('');
      setSelectedDeliveryDateForImport('');
    } finally {
      setIsUploading(false);
    }
  };

  //   Vendor Detail Dropdown
  const [materialShow, setMaterialShow] = useState([]);
  const [project, setproject] = useState([]);
  const [vendorData, setVendorData] = useState({
    vendor_name: "",
    vendor_address: "",
    vendor_number: "",
    vendor_email: "",
    vendor_website: "",
  });

  const handleVendorInputChange = (e) => {
    const { name, value } = e.target;
    setVendorData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleVendorSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await api.post("addVendor.php?company_id=" + Cookies.get('company_id'), vendorData);

      if (response.data.status === "success") {
        alert(response.data.message);
        toggleRole3(); // Close modal
        // Reset form
        setVendorData({
          vendor_name: "",
          vendor_address: "",
          vendor_number: "",
          vendor_email: "",
          vendor_website: "",
        });
      } else {
        alert(response.data.message || "Error adding vendor");
      }
    } catch (error) {
      console.error("Error submitting vendor data:", error);
      alert("Failed to add vendor. Please try again.");
    }
  };

  const [showMaterialDeliveryModal, setShowMaterialDeliveryModal] = useState(false);
  const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
  const [filteredMaterialDeliveryData, setFilteredMaterialDeliveryData] = useState([]);

  useEffect(() => {
    const fetchMaterialDeliveryData = async () => {
      try {
        const response = await api.get("vendorDeliveryStock.php?company_id=" + Cookies.get('company_id'));
        const products = response.data.data || response.data;
        
        // Ensure products is an array
        const productsArray = Array.isArray(products) ? products : [];
        setMaterialDeliveryData(productsArray);
        setFilteredMaterialDeliveryData(productsArray);
      } catch (error) {
        console.error("Error fetching material delivery data:", error);
        setMaterialDeliveryData([]);
        setFilteredMaterialDeliveryData([]);
      }
    };

    fetchMaterialDeliveryData();
  }, []);

  const toggleMaterialDeliveryModal = () => {
    setShowMaterialDeliveryModal(!showMaterialDeliveryModal);
    // Clear search fields when modal is opened or closed
    if (!showMaterialDeliveryModal) {
      setMaterialDeliveryModalProjectSearch("");
      setMaterialDeliveryModalProductSearch("");
    }
  };

  // Fetch projects first
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await api.get("viewProjectDetails.php?company_id=" + Cookies.get('company_id'));
        let projectData = [];
        if (Array.isArray(response.data)) {
          projectData = response.data;
        } else if (response.data.projects) {
          projectData = response.data.projects;
        }
        
        // Sort projects by p_id in descending order (newest first)
        const sortedProjects = projectData.sort((a, b) => {
          const idA = parseInt(a.p_id) || 0;
          const idB = parseInt(b.p_id) || 0;
          return idB - idA; // Descending order (newest first)
        });
        
        setProjects(sortedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
      }
    };
    fetchProjects();
  }, []);

  // Fetch vendors
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await api.get('addVendor.php?company_id=' + Cookies.get('company_id'));
        if (response.data.status === 'success') {
          setVendors(response.data.vendors);
        }
      } catch (error) {
        console.error('Error fetching vendors:', error);
        setVendors([]);
      }
    };
    fetchVendors();
  }, []);

  // Fetch delivery stock data
  useEffect(() => {
    const fetchDeliveryStockData = async () => {
      try {
        const response = await api.get("vendorDeliveryStock.php?company_id=" + Cookies.get('company_id'));
        const data = response.data.data || response.data;
        
        // Ensure data is an array
        const dataArray = Array.isArray(data) ? data : [];
        setDeliveryStockData(dataArray);
      } catch (error) {
        console.error("Error fetching delivery stock data:", error);
        setDeliveryStockData([]);
      }
    };
    fetchDeliveryStockData();
  }, []);

  // Update the product selection effect
  useEffect(() => {
    if (materialDeliveryForm.vendor_product_id) {
      // Find selected product's stock
      const selectedProduct = originalData.find(
        item => String(item.vendor_product_id) === String(materialDeliveryForm.vendor_product_id)
      );
      if (selectedProduct) {
        setSelectedProductStock(selectedProduct.available_stock);
      }

      // Only reset project selection when product changes
      setMaterialDeliveryForm(prev => ({
        ...prev,
        p_id: ""
      }));
    } else {
      // Clear stock when no product is selected
      setSelectedProductStock(0);
    }
  }, [materialDeliveryForm.vendor_product_id, originalData]);

  const handleMaterialDeliveryInputChange = (e) => {
    const { name, value } = e.target;
    setMaterialDeliveryForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    
    // Handle vendor change
    if (name === 'vendor_id') {
      setMaterialDeliveryModalProductSearch("");
      
      // When vendor is selected, find the corresponding vendor_product_id
      if (value && materialDeliveryForm.selectedProductName) {
        const selectedProduct = originalData.find(item => 
          item.product_name === materialDeliveryForm.selectedProductName && 
          String(item.vendor_id) === String(value)
        );
        
        if (selectedProduct) {
          setMaterialDeliveryForm(prev => ({
            ...prev,
            vendor_product_id: selectedProduct.vendor_product_id
          }));
        }
      } else {
        // Clear vendor_product_id if vendor is cleared
        setMaterialDeliveryForm(prev => ({
          ...prev,
          vendor_product_id: ""
        }));
      }
    }
    
    // Clear project search when product changes
    if (name === 'vendor_product_id') {
      setMaterialDeliveryModalProjectSearch("");
      setMaterialDeliveryForm(prev => ({
        ...prev,
        p_id: ""
      }));
    }
  };

  const [showMaterialDeliverySuccess, setShowMaterialDeliverySuccess] = useState(false);
  const [materialDeliverySuccessMsg, setMaterialDeliverySuccessMsg] = useState("");

  const handleMaterialDeliverySubmit = async (event) => {
    event.preventDefault();
    if (!materialDeliveryForm.vendor_id || !materialDeliveryForm.vendor_product_id || !materialDeliveryForm.p_id || !materialDeliveryForm.quantity_delivered || !materialDeliveryForm.material_tracking_number || !materialDeliveryForm.delivered_to || !materialDeliveryForm.cost) {
      alert("Please fill all required fields.");
      return;
    }
    try {
      const payload = {
        ...materialDeliveryForm,
        company_id: Cookies.get('company_id'), // Ensure company_id is sent
      };
      const response = await api.post("vendorDeliveryStock.php?company_id=" + Cookies.get('company_id'), payload);
      if (response.data.status === "success") {
        setMaterialDeliverySuccessMsg("Material delivery added successfully!");
        setShowMaterialDeliverySuccess(true);
        toggleMaterialDeliveryModal(); // Close the input modal
        // Reset form
        setMaterialDeliveryForm({
          vendor_id: "",
          vendor_product_id: "",
          selectedProductName: "",
          p_id: "",
          quantity_delivered: "",
          delivery_date: "",
          material_tracking_number: "",
          delivered_to: "",
          cost: "",
        });
        // Clear search fields
        setMaterialDeliveryModalProjectSearch("");
        setMaterialDeliveryModalProductSearch("");
      } else {
        alert(response.data.message || "Error submitting material delivery.");
      }
    } catch (error) {
      alert("Error submitting data. Please check the console for details.");
      console.error("Error submitting data:", error);
    }
  };

  // Add state for projects
  const [selectedProject, setSelectedProject] = useState("");

  // Add handlers for filters
  const handleFilterChange = (projectId, vendorId) => {
    setSelectedProject(projectId);
    setSelectedVendorFilter(vendorId);
    let filtered = materialDeliveryData;
    if (projectId) {
      filtered = filtered.filter((item) => String(item.project_id) === String(projectId));
    }
    if (vendorId) {
      filtered = filtered.filter((item) => String(item.vendor_id) === String(vendorId));
    }
    setFilteredMaterialDeliveryData(filtered);
  };

  // Add state for dropdown open/close
  const [vendorDropdownOpen, setVendorDropdownOpen] = useState(false);

  const toggleVendorDropdown = () => setVendorDropdownOpen((prev) => !prev);
  const toggleDeliveryProjectDropdown = () => setDeliveryProjectDropdownOpen((prev) => !prev);
  const toggleDeliveryVendorDropdown = () => setDeliveryVendorDropdownOpen((prev) => !prev);

  // Add new state for Vendor Material Delivery filters and pagination
  const [selectedDeliveryProject, setSelectedDeliveryProject] = useState("");
  const [selectedDeliveryVendor, setSelectedDeliveryVendor] = useState("");
  const [deliveryEntriesToShow, setDeliveryEntriesToShow] = useState(5);
  const [deliveryCurrentPage, setDeliveryCurrentPage] = useState(1);

  // Ensure filteredMaterialDeliveryData is always an array
  const safeFilteredMaterialDeliveryData = Array.isArray(filteredMaterialDeliveryData) ? filteredMaterialDeliveryData : [];

  // Compute paginated data for Vendor Material Delivery
  const paginatedDeliveryData = safeFilteredMaterialDeliveryData.slice(
    (deliveryCurrentPage - 1) * deliveryEntriesToShow,
    deliveryCurrentPage * deliveryEntriesToShow
  );
  const deliveryTotalPages = Math.ceil(safeFilteredMaterialDeliveryData.length / deliveryEntriesToShow);

  // Update filter handler for Vendor Material Delivery
  const handleDeliveryFilterChange = (projectId, vendorId) => {
    setSelectedDeliveryProject(projectId);
    setSelectedDeliveryVendor(vendorId);
    applyDeliveryFilters(projectId, vendorId, selectedDeliveryProduct, deliveryStartDate, deliveryEndDate);
  };

  // Toggle function for delivery product filter dropdown
  const toggleDeliveryProductFilterDropdown = () => {
    setDeliveryProductFilterDropdownOpen(!deliveryProductFilterDropdownOpen);
    // Clear search when closing dropdown
    if (deliveryProductFilterDropdownOpen) {
      setDeliveryProductSearch("");
    }
  };

  // Function to handle delivery product filter
  const handleDeliveryProductFilter = (productName) => {
    setSelectedDeliveryProduct(productName);
    setDeliveryProductSearch(""); // Clear search when selecting a product
    applyDeliveryFilters(selectedDeliveryProject, selectedDeliveryVendor, productName, deliveryStartDate, deliveryEndDate);
  };

  // Function to handle delivery date filters
  const handleDeliveryDateFilter = (startDate, endDate) => {
    setDeliveryStartDate(startDate);
    setDeliveryEndDate(endDate);
    applyDeliveryFilters(selectedDeliveryProject, selectedDeliveryVendor, selectedDeliveryProduct, startDate, endDate);
  };

  // Function to apply all delivery filters
  const applyDeliveryFilters = (projectId, vendorId, productName, startDate, endDate) => {
    if (!Array.isArray(materialDeliveryData)) {
      setFilteredMaterialDeliveryData([]);
      setDeliveryCurrentPage(1);
      setTotalItemsDelivered(0);
      return;
    }
    let filtered = materialDeliveryData;

    // Filter by project
    if (projectId) {
      filtered = filtered.filter(item => String(item.p_id) === String(projectId));
    }

    // Filter by vendor
    if (vendorId) {
      filtered = filtered.filter(item => String(item.vendor_id) === String(vendorId));
    }

    // Filter by product name
    if (productName) {
      filtered = filtered.filter(item => item.product_name === productName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const deliveryDate = new Date(item.delivery_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return deliveryDate >= start && deliveryDate <= end;
      });
    }

    setFilteredMaterialDeliveryData(filtered);
    setDeliveryCurrentPage(1);

    // Calculate total items delivered only when specific filters are applied
    if (productName || startDate || endDate) {
      const total = filtered.reduce((sum, item) => sum + parseInt(item.quantity_delivered || 0), 0);
      setTotalItemsDelivered(total);
    } else {
      setTotalItemsDelivered(0);
    }
  };

  const handleDeliveryEntriesChange = (value) => {
    setDeliveryEntriesToShow(value === "All" ? safeFilteredMaterialDeliveryData.length : Number(value));
    setDeliveryCurrentPage(1);
  };

  const deliveryPrevPage = () => {
    if (deliveryCurrentPage > 1) {
      setDeliveryCurrentPage(deliveryCurrentPage - 1);
    }
  };
  const deliveryNextPage = () => {
    if (deliveryCurrentPage < deliveryTotalPages) {
      setDeliveryCurrentPage(deliveryCurrentPage + 1);
    }
  };

  const [deliveryShowEntriesDropdownOpen, setDeliveryShowEntriesDropdownOpen] = useState(false);
  const [deliveryProjectDropdownOpen, setDeliveryProjectDropdownOpen] = useState(false);
  const [deliveryVendorDropdownOpen, setDeliveryVendorDropdownOpen] = useState(false);

  // New state variables for Vendor Material Delivery filters
  const [selectedDeliveryProduct, setSelectedDeliveryProduct] = useState("");
  const [deliveryStartDate, setDeliveryStartDate] = useState("");
  const [deliveryEndDate, setDeliveryEndDate] = useState("");
  const [deliveryProductFilterDropdownOpen, setDeliveryProductFilterDropdownOpen] = useState(false);
  const [deliveryProductSearch, setDeliveryProductSearch] = useState("");
  const [totalItemsDelivered, setTotalItemsDelivered] = useState(0);

  // Vendor Material Return states (update to use new backend)
  const [vendorReturnData, setVendorReturnData] = useState([]);
  const [filteredVendorReturnData, setFilteredVendorReturnData] = useState([]);
  const [showVendorReturnModal, setShowVendorReturnModal] = useState(false);
  const [vendorReturnForm, setVendorReturnForm] = useState({
    vendor_id: "",
    vendor_product_id: "",
    p_id: "",
    selectedProductName: "", // New field to store selected product name
    returned_quantity: "",
    return_date: "",
    material_tracking_number: "",
    returned_by: '',
    yet_to_returned: '',
  });
  const [selectedReturnProject, setSelectedReturnProject] = useState("");
  const [selectedReturnVendor, setSelectedReturnVendor] = useState("");
  const [returnShowEntriesDropdownOpen, setReturnShowEntriesDropdownOpen] = useState(false);
  const [returnEntriesToShow, setReturnEntriesToShow] = useState(5);
  const [returnCurrentPage, setReturnCurrentPage] = useState(1);
  const [returnProjectDropdownOpen, setReturnProjectDropdownOpen] = useState(false);
  const [returnVendorDropdownOpen, setReturnVendorDropdownOpen] = useState(false);
  
  // New state variables for Vendor Return Modal dropdowns
  const [vendorReturnModalProductDropdownOpen, setVendorReturnModalProductDropdownOpen] = useState(false);
  const [vendorReturnModalProductSearch, setVendorReturnModalProductSearch] = useState("");
  const [vendorReturnModalProjectDropdownOpen, setVendorReturnModalProjectDropdownOpen] = useState(false);
  const [vendorReturnModalProjectSearch, setVendorReturnModalProjectSearch] = useState("");
  
  const [showReturnDeleteConfirmation, setShowReturnDeleteConfirmation] = useState(false);
  const [returnToDelete, setReturnToDelete] = useState(null);

  // New state variables for Vendor Material Return filters
  const [selectedReturnProduct, setSelectedReturnProduct] = useState("");
  const [returnStartDate, setReturnStartDate] = useState("");
  const [returnEndDate, setReturnEndDate] = useState("");
  const [returnProductFilterDropdownOpen, setReturnProductFilterDropdownOpen] = useState(false);
  const [returnProductSearch, setReturnProductSearch] = useState("");
  const [totalItemsReturned, setTotalItemsReturned] = useState(0);
  const [totalYetToReturn, setTotalYetToReturn] = useState(0);

  // New state variables for Vendor to Store filters
  const [selectedVendorToStoreVendor, setSelectedVendorToStoreVendor] = useState("");
  const [selectedVendorToStoreProduct, setSelectedVendorToStoreProduct] = useState("");
  const [vendorToStoreStartDate, setVendorToStoreStartDate] = useState("");
  const [vendorToStoreEndDate, setVendorToStoreEndDate] = useState("");
  const [vendorToStoreVendorDropdownOpen, setVendorToStoreVendorDropdownOpen] = useState(false);
  const [vendorToStoreProductDropdownOpen, setVendorToStoreProductDropdownOpen] = useState(false);
  const [vendorToStoreEntriesDropdownOpen, setVendorToStoreEntriesDropdownOpen] = useState(false);
  const [vendorToStoreEntriesToShow, setVendorToStoreEntriesToShow] = useState(5);
  const [filteredVendorToStoreData, setFilteredVendorToStoreData] = useState([]);
  const [vendorToStoreCurrentPage, setVendorToStoreCurrentPage] = useState(1);
  const [vendorToStoreProductSearch, setVendorToStoreProductSearch] = useState("");
  const [vendorToStoreVendorSearch, setVendorToStoreVendorSearch] = useState("");

  // Fetch Vendor Material Return data from vendorReturnStock.php
  useEffect(() => {
    const fetchVendorReturnData = async () => {
      try {
        const response = await api.get("vendorReturnStock.php?company_id=" + Cookies.get('company_id'));
        const returns = response.data.data || response.data;
        
        // Ensure returns is an array and sort by return_id in descending order (newest first)
        const returnsArray = Array.isArray(returns) ? returns : [];
        const sortedReturns = returnsArray.sort((a, b) => {
          const idA = parseInt(a.return_id) || 0;
          const idB = parseInt(b.return_id) || 0;
          return idB - idA; // Descending order (newest first)
        });
        setVendorReturnData(sortedReturns);
        setFilteredVendorReturnData(sortedReturns);
      } catch (error) {
        console.error("Error fetching vendor return data:", error);
        setVendorReturnData([]);
        setFilteredVendorReturnData([]);
      }
    };
    fetchVendorReturnData();
  }, []);

  // Get unique product names from vendor material delivery data
  const getUniqueDeliveryProducts = () => {
    if (!Array.isArray(materialDeliveryData)) {
      return [];
    }
    const uniqueProducts = [...new Set(materialDeliveryData.map(item => item.product_name))];
    return uniqueProducts.filter(product => product); // Remove empty/null values
  };

  // Get unique product names from vendor material return data
  const getUniqueReturnProducts = () => {
    if (!Array.isArray(vendorReturnData)) {
      return [];
    }
    const uniqueProducts = [...new Set(vendorReturnData.map(item => item.product_name))];
    return uniqueProducts.filter(product => product); // Remove empty/null values
  };

  // Initialize total items delivered to 0 when data loads
  useEffect(() => {
    setTotalItemsDelivered(0);
  }, [materialDeliveryData]);

  // Initialize total items returned and yet to return to 0 when data loads
  useEffect(() => {
    setTotalItemsReturned(0);
    setTotalYetToReturn(0);
  }, [vendorReturnData]);

  // Filter handler for Vendor Material Return
  const handleReturnFilterChange = (projectId, vendorId) => {
    setSelectedReturnProject(projectId);
    setSelectedReturnVendor(vendorId);
    applyReturnFilters(projectId, vendorId, selectedReturnProduct, returnStartDate, returnEndDate);
  };

  // Toggle function for return product filter dropdown
  const toggleReturnProductFilterDropdown = () => {
    setReturnProductFilterDropdownOpen(!returnProductFilterDropdownOpen);
    // Clear search when closing dropdown
    if (returnProductFilterDropdownOpen) {
      setReturnProductSearch("");
    }
  };

  // Function to handle return product filter
  const handleReturnProductFilter = (productName) => {
    setSelectedReturnProduct(productName);
    setReturnProductSearch(""); // Clear search when selecting a product
    applyReturnFilters(selectedReturnProject, selectedReturnVendor, productName, returnStartDate, returnEndDate);
  };

  // Function to handle return date filters
  const handleReturnDateFilter = (startDate, endDate) => {
    setReturnStartDate(startDate);
    setReturnEndDate(endDate);
    applyReturnFilters(selectedReturnProject, selectedReturnVendor, selectedReturnProduct, startDate, endDate);
  };

  // Function to apply all return filters
  const applyReturnFilters = (projectId, vendorId, productName, startDate, endDate) => {
    if (!Array.isArray(vendorReturnData)) {
      setFilteredVendorReturnData([]);
      setReturnCurrentPage(1);
      setTotalItemsReturned(0);
      setTotalYetToReturn(0);
      return;
    }
    let filtered = vendorReturnData;

    // Filter by project
    if (projectId) {
      filtered = filtered.filter(item => String(item.p_id) === String(projectId));
    }

    // Filter by vendor
    if (vendorId) {
      filtered = filtered.filter(item => String(item.vendor_id) === String(vendorId));
    }

    // Filter by product name
    if (productName) {
      filtered = filtered.filter(item => item.product_name === productName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const returnDate = new Date(item.return_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return returnDate >= start && returnDate <= end;
      });
    }

    setFilteredVendorReturnData(filtered);
    setReturnCurrentPage(1);

    // Calculate totals only when specific filters are applied
    if (productName || startDate || endDate) {
      const totalReturned = filtered.reduce((sum, item) => sum + parseInt(item.returned_quantity || 0), 0);
      const totalYetToReturn = filtered.reduce((sum, item) => sum + parseInt(item.yet_to_returned || 0), 0);
      setTotalItemsReturned(totalReturned);
      setTotalYetToReturn(totalYetToReturn);
    } else {
      setTotalItemsReturned(0);
      setTotalYetToReturn(0);
    }
  };

  const handleReturnEntriesChange = (value) => {
    setReturnEntriesToShow(value === "All" ? safeFilteredVendorReturnData.length : Number(value));
    setReturnCurrentPage(1);
  };

  // Ensure filteredVendorReturnData is always an array
  const safeFilteredVendorReturnData = Array.isArray(filteredVendorReturnData) ? filteredVendorReturnData : [];
  
  const returnPaginatedData = safeFilteredVendorReturnData.slice(
    (returnCurrentPage - 1) * returnEntriesToShow,
    returnCurrentPage * returnEntriesToShow
  );
  const returnTotalPages = Math.ceil(safeFilteredVendorReturnData.length / returnEntriesToShow);
  const returnPrevPage = () => {
    if (returnCurrentPage > 1) setReturnCurrentPage(returnCurrentPage - 1);
  };
  const returnNextPage = () => {
    if (returnCurrentPage < returnTotalPages) setReturnCurrentPage(returnCurrentPage + 1);
  };

  // Transaction Logs pagination handlers will be moved after state declaration
  const toggleVendorReturnModal = () => {
    setShowVendorReturnModal((prev) => !prev);
    if (!showVendorReturnModal) {
      // Reset form when opening modal
      setVendorReturnForm({
        vendor_id: "",
        vendor_product_id: "",
        p_id: "",
        selectedProductName: "",
        returned_quantity: "",
        return_date: "",
        material_tracking_number: "",
        returned_by: '',
        yet_to_returned: '',
      });
      // Reset dropdown states
      setVendorReturnModalProductSearch("");
    }
  };

  // Toggle function for vendor return modal project dropdown
  const toggleVendorReturnModalProjectDropdown = () => {
    setVendorReturnModalProjectDropdownOpen(!vendorReturnModalProjectDropdownOpen);
    if (vendorReturnModalProjectDropdownOpen) {
      setVendorReturnModalProjectSearch("");
    }
  };

  const toggleReturnProjectDropdown = () => setReturnProjectDropdownOpen((prev) => !prev);
  const toggleReturnVendorDropdown = () => setReturnVendorDropdownOpen((prev) => !prev);

  // Vendor to Store filter functions
  const getUniqueVendorToStoreVendors = () => {
    if (!Array.isArray(vendorToStoreData)) {
      return [];
    }
    const uniqueVendors = [...new Set(vendorToStoreData.map(item => item.vendor_name))];
    return uniqueVendors.filter(vendor => vendor); // Remove empty/null values
  };

  const getUniqueVendorToStoreProducts = () => {
    if (!Array.isArray(vendorToStoreData)) {
      return [];
    }
    const uniqueProducts = [...new Set(vendorToStoreData.map(item => item.product_name))];
    return uniqueProducts.filter(product => product).sort(); // Remove empty/null values and sort
  };

  const handleVendorToStoreVendorFilter = (vendorName) => {
    setSelectedVendorToStoreVendor(vendorName);
    setVendorToStoreVendorSearch(""); // Clear search when selecting a vendor
    applyVendorToStoreFilters(vendorName, selectedVendorToStoreProduct, vendorToStoreStartDate, vendorToStoreEndDate);
  };

  const toggleVendorToStoreVendorDropdown = () => {
    setVendorToStoreVendorDropdownOpen(!vendorToStoreVendorDropdownOpen);
    // Clear search when closing dropdown
    if (vendorToStoreVendorDropdownOpen) {
      setVendorToStoreVendorSearch("");
    }
  };

  const handleVendorToStoreProductFilter = (productName) => {
    setSelectedVendorToStoreProduct(productName);
    setVendorToStoreProductSearch(""); // Clear search when selecting a product
    applyVendorToStoreFilters(selectedVendorToStoreVendor, productName, vendorToStoreStartDate, vendorToStoreEndDate);
  };

  const toggleVendorToStoreProductDropdown = () => {
    setVendorToStoreProductDropdownOpen(!vendorToStoreProductDropdownOpen);
    // Clear search when closing dropdown
    if (vendorToStoreProductDropdownOpen) {
      setVendorToStoreProductSearch("");
    }
  };

  const handleVendorToStoreDateFilter = (startDate, endDate) => {
    setVendorToStoreStartDate(startDate);
    setVendorToStoreEndDate(endDate);
    applyVendorToStoreFilters(selectedVendorToStoreVendor, selectedVendorToStoreProduct, startDate, endDate);
  };

  const applyVendorToStoreFilters = (vendorName, productName, startDate, endDate) => {
    console.log("Applying vendor to store filters:", { vendorName, productName, startDate, endDate });
    console.log("Current vendorToStoreData:", vendorToStoreData);
    
    if (!Array.isArray(vendorToStoreData)) {
      console.log("vendorToStoreData is not an array, setting empty filtered data");
      setFilteredVendorToStoreData([]);
      setVendorToStoreCurrentPage(1);
      return;
    }
    let filtered = vendorToStoreData;

    // Filter by vendor
    if (vendorName) {
      filtered = filtered.filter(item => item.vendor_name === vendorName);
    }

    // Filter by product
    if (productName) {
      filtered = filtered.filter(item => item.product_name === productName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const deliveryDate = new Date(item.delivery_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return deliveryDate >= start && deliveryDate <= end;
      });
    }

    console.log("Filtered data result:", filtered);
    setFilteredVendorToStoreData(filtered);
    setVendorToStoreCurrentPage(1);
  };

  const handleVendorToStoreEntriesChange = (value) => {
    setVendorToStoreEntriesToShow(value === "All" ? safeFilteredVendorToStoreData.length : Number(value));
    setVendorToStoreCurrentPage(1);
  };

  // Ensure filteredVendorToStoreData is always an array
  const safeFilteredVendorToStoreData = Array.isArray(filteredVendorToStoreData) ? filteredVendorToStoreData : [];
  
  // Debug logging for filteredVendorToStoreData
  useEffect(() => {
    console.log("filteredVendorToStoreData changed:", filteredVendorToStoreData);
    console.log("Type of filteredVendorToStoreData:", typeof filteredVendorToStoreData);
    console.log("Is array:", Array.isArray(filteredVendorToStoreData));
  }, [filteredVendorToStoreData]);
  
  const vendorToStorePaginatedData = safeFilteredVendorToStoreData.slice(
    (vendorToStoreCurrentPage - 1) * vendorToStoreEntriesToShow,
    vendorToStoreCurrentPage * vendorToStoreEntriesToShow
  );

  const vendorToStoreTotalPages = Math.ceil(safeFilteredVendorToStoreData.length / vendorToStoreEntriesToShow);

  const vendorToStorePrevPage = () => {
    if (vendorToStoreCurrentPage > 1) setVendorToStoreCurrentPage(vendorToStoreCurrentPage - 1);
  };

  const vendorToStoreNextPage = () => {
    if (vendorToStoreCurrentPage < vendorToStoreTotalPages) setVendorToStoreCurrentPage(vendorToStoreCurrentPage + 1);
  };

  // Store to Vendor filter functions
  const getUniqueStoreToVendorVendors = () => {
    if (!Array.isArray(storeToVendorData)) {
      return [];
    }
    const uniqueVendors = [...new Set(storeToVendorData.map(item => item.vendor_name))];
    return uniqueVendors.filter(vendor => vendor); // Remove empty/null values
  };

  const handleStoreToVendorVendorFilter = (vendorName) => {
    setSelectedStoreToVendorVendor(vendorName);
    applyStoreToVendorFilters(vendorName, storeToVendorStartDate, storeToVendorEndDate);
  };

  const handleStoreToVendorDateFilter = (startDate, endDate) => {
    setStoreToVendorStartDate(startDate);
    setStoreToVendorEndDate(endDate);
    applyStoreToVendorFilters(selectedStoreToVendorVendor, startDate, endDate);
  };

  const applyStoreToVendorFilters = (vendorName, startDate, endDate) => {
    if (!Array.isArray(storeToVendorData)) {
      setFilteredStoreToVendorData([]);
      setStoreToVendorCurrentPage(1);
      return;
    }
    let filtered = storeToVendorData;

    // Filter by vendor
    if (vendorName) {
      filtered = filtered.filter(item => item.vendor_name === vendorName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const returnDate = new Date(item.return_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return returnDate >= start && returnDate <= end;
      });
    }

    setFilteredStoreToVendorData(filtered);
    setStoreToVendorCurrentPage(1);
  };



  const handleStoreToVendorEntriesChange = (value) => {
    setStoreToVendorEntriesToShow(value === "All" ? filteredStoreToVendorData.length : Number(value));
    setStoreToVendorCurrentPage(1);
  };

  // Helper function to get delivered quantity
  const getDeliveredQuantity = (trackingNumber, vendorProductId, projectId) => {
    if (!trackingNumber || !vendorProductId || !projectId || !Array.isArray(deliveryStockData)) return 0;
    
    const deliveryRecord = deliveryStockData.find(item => 
      item.material_tracking_number === trackingNumber &&
      item.vendor_product_id === parseInt(vendorProductId) &&
      item.p_id === parseInt(projectId)
    );
    
    return deliveryRecord ? deliveryRecord.quantity_delivered || 0 : 0;
  };

  const handleVendorReturnInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === 'return_date' && value.length === 4) {
      // If only year is selected, set a default month and day
      newValue = `${value}-01-01`;
    }
    
    setVendorReturnForm((prev) => {
      const updatedForm = {
        ...prev,
        [name]: newValue,
      };
      
      // Clear dependent fields when project, product, or vendor changes
      if (name === 'p_id') {
        updatedForm.selectedProductName = "";
        updatedForm.vendor_id = "";
        updatedForm.material_tracking_number = "";
        updatedForm.vendor_product_id = "";
        updatedForm.yet_to_returned = "";
      } else if (name === 'selectedProductName') {
        updatedForm.vendor_id = "";
        updatedForm.material_tracking_number = "";
        updatedForm.vendor_product_id = "";
        updatedForm.yet_to_returned = "";
      } else if (name === 'vendor_id') {
        updatedForm.material_tracking_number = "";
        updatedForm.vendor_product_id = "";
        updatedForm.yet_to_returned = "";
      }
      
      // Auto-calculate yet_to_returned when returned_quantity, material_tracking_number, vendor_id, selectedProductName, or p_id changes
      if ((name === 'returned_quantity' || name === 'material_tracking_number' || name === 'vendor_id' || name === 'selectedProductName' || name === 'p_id') && 
          updatedForm.material_tracking_number && updatedForm.vendor_id && updatedForm.selectedProductName && updatedForm.p_id) {
        
        // Find the vendor_product_id based on selected product, vendor, and project from delivery records
        const selectedVendorProduct = deliveryStockData.find(item => 
          item.product_name === updatedForm.selectedProductName &&
          String(item.vendor_id) === String(updatedForm.vendor_id) &&
          String(item.p_id) === String(updatedForm.p_id)
        );
        
        if (selectedVendorProduct) {
        const deliveredQuantity = getDeliveredQuantity(
          updatedForm.material_tracking_number, 
            selectedVendorProduct.vendor_product_id, 
          updatedForm.p_id
        );
        
        // Calculate previously returned quantity for this tracking number
        const previouslyReturned = vendorReturnData
          .filter(item => item.material_tracking_number === updatedForm.material_tracking_number)
          .reduce((sum, item) => sum + parseInt(item.returned_quantity || 0), 0);
        
        // Calculate remaining quantity that can still be returned
        const remainingQty = Math.max(0, deliveredQuantity - previouslyReturned);
        
        // Calculate yet to return based on current return quantity
        const currentReturned = parseFloat(updatedForm.returned_quantity) || 0;
        const yetToReturn = Math.max(0, remainingQty - currentReturned);
        
        updatedForm.yet_to_returned = yetToReturn.toString();
        }
      }
      
      return updatedForm;
    });
  };

  const [showMaterialReturnSuccess, setShowMaterialReturnSuccess] = useState(false);
  const [materialReturnSuccessMsg, setMaterialReturnSuccessMsg] = useState("");

  const handleVendorReturnSubmit = async (event) => {
    event.preventDefault();
    
    // Validate that all required fields are selected
    if (!vendorReturnForm.p_id) {
      alert("Please select a project.");
      return;
    }
    
    if (!vendorReturnForm.selectedProductName) {
      alert("Please select a product.");
      return;
    }
    
    if (!vendorReturnForm.vendor_id) {
      alert("Please select a vendor.");
      return;
    }
    
    if (!vendorReturnForm.material_tracking_number) {
      alert("Please select a material tracking number.");
      return;
    }
    
    // Find the vendor_product_id based on selected product, vendor, and project from delivery records
    const selectedVendorProduct = deliveryStockData.find(item => 
      item.product_name === vendorReturnForm.selectedProductName &&
      String(item.vendor_id) === String(vendorReturnForm.vendor_id) &&
      String(item.p_id) === String(vendorReturnForm.p_id)
    );
    
    if (!selectedVendorProduct) {
      alert("Please select a valid combination of product, vendor, and project that has delivery records.");
      return;
    }
    
    // Update the form with the found vendor_product_id
    const updatedForm = {
      ...vendorReturnForm,
      vendor_product_id: selectedVendorProduct.vendor_product_id
    };
    
    // === FRONTEND VALIDATION ===
    const deliveredQuantity = getDeliveredQuantity(
      updatedForm.material_tracking_number,
      updatedForm.vendor_product_id,
      updatedForm.p_id
    );
    const quantityReturned = parseInt(updatedForm.returned_quantity) || 0;
    const yetToReturned = parseInt(updatedForm.yet_to_returned) || 0;
    
    // Calculate previously returned quantity for this tracking number
    const previouslyReturned = vendorReturnData
      .filter(item => item.material_tracking_number === updatedForm.material_tracking_number)
      .reduce((sum, item) => sum + parseInt(item.returned_quantity || 0), 0);
    
    // Calculate remaining quantity that can still be returned
    const remainingQty = Math.max(0, deliveredQuantity - previouslyReturned);
    
    // Validate that returned quantity doesn't exceed remaining quantity
    if (quantityReturned > remainingQty) {
      alert(
        `Returned quantity (${quantityReturned}) cannot exceed remaining quantity (${remainingQty})! Total delivered: ${deliveredQuantity}, Previously returned: ${previouslyReturned}`
      );
      return;
    }
    
    // Validate that yet to return is correctly calculated
    const expectedYetToReturn = remainingQty - quantityReturned;
    if (yetToReturned !== expectedYetToReturn) {
      alert(
        `Yet to Return calculation error. Expected: ${expectedYetToReturn}, Got: ${yetToReturned}`
      );
      return;
    }
    // === END FRONTEND VALIDATION ===
    
    // Date validation removed - users can select any date for returns
    
    // Ensure return_date is in YYYY-MM-DD format
    let formattedReturnDate = vendorReturnForm.return_date;
    if (formattedReturnDate instanceof Date) {
      formattedReturnDate = formattedReturnDate.toISOString().split('T')[0];
    } else if (typeof formattedReturnDate === 'string') {
      if (/^\d{4}$/.test(formattedReturnDate)) {
        // Only year provided, convert to YYYY-01-01
        formattedReturnDate = `${formattedReturnDate}-01-01`;
      } else if (formattedReturnDate.length === 10 && formattedReturnDate.includes('/')) {
        // Convert from MM/DD/YYYY to YYYY-MM-DD
        const [mm, dd, yyyy] = formattedReturnDate.split('/');
        formattedReturnDate = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
      }
    }
    // Debug log
    console.log('Submitting return_date:', vendorReturnForm.return_date, 'Formatted:', formattedReturnDate);
    // Prepare payload with formatted date
    const payload = {
      ...updatedForm,
      return_date: formattedReturnDate,
      company_id: Cookies.get('company_id'),
    };
    try {
      const response = await api.post("vendorReturnStock.php?company_id=" + Cookies.get('company_id'), payload);
      if (response.data.status === "success") {
        setMaterialReturnSuccessMsg("Return material added successfully!");
        setShowMaterialReturnSuccess(true);
        toggleVendorReturnModal(); // Close the input modal
        // Reset form
        setVendorReturnForm({
          vendor_id: "",
          vendor_product_id: "",
          p_id: "",
          selectedProductName: "",
          returned_quantity: "",
          return_date: "",
          material_tracking_number: "",
          returned_by: '',
          yet_to_returned: '',
        });
        // Reset dropdown states
        setVendorReturnModalProductSearch("");
        // Don't reload immediately, let user see success message
      } else {
        alert(response.data.message || "Error submitting return material.");
      }
    } catch (error) {
      alert("Error submitting return material.");
      console.error("Error submitting return material:", error);
    }
  };

  // Delete feature for Vendor Material Return
  const handleReturnDeleteIconClick = (return_id) => {
    setReturnToDelete(return_id);
    setShowReturnDeleteConfirmation(true);
  };
  const handleReturnDeleteConfirmation = async () => {
    try {
      const response = await api.delete("vendorReturnStock.php?company_id=" + Cookies.get('company_id'), {
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          return_id: returnToDelete,
          company_id: Cookies.get('company_id')
        })
      });

      if (response.data.status === 'success') {
        // Show success message with restored quantity info
        const restoredQuantity = response.data.restored_quantity;
        const successMessage = `Return record deleted successfully! Stock restored: ${restoredQuantity} units removed from inventory.`;
        
        setSuccessMessage(successMessage);
        setShowSuccessAlert(true);
        
      setShowReturnDeleteConfirmation(false);
      setReturnToDelete(null);
        
        // Refresh both return data and vendor products data
        const [returnResponse, vendorProductsResponse] = await Promise.all([
          api.get("vendorReturnStock.php?company_id=" + Cookies.get('company_id')),
          api.get("vendorToStore.php?company_id=" + Cookies.get('company_id'))
        ]);
        
        const returns = returnResponse.data.data || returnResponse.data;
        const vendorProducts = vendorProductsResponse.data.data || vendorProductsResponse.data;
        
      setVendorReturnData(returns);
      setFilteredVendorReturnData(returns);
        setVendorToStoreData(vendorProducts);
        setFilteredVendorToStoreData(vendorProducts);
        
        // Auto-hide success message after 3 seconds
        setTimeout(() => {
          setShowSuccessAlert(false);
        }, 3000);
      } else {
        throw new Error(response.data.message || 'Unknown error occurred');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Error deleting return record.";
      alert(errorMessage);
      setShowReturnDeleteConfirmation(false);
      setReturnToDelete(null);
    }
  };

  // Add state for delete confirmation
  const [showDeliveryDeleteConfirmation, setShowDeliveryDeleteConfirmation] = useState(false);
  const [deliveryToDelete, setDeliveryToDelete] = useState(null);

  const handleDeliveryDeleteIconClick = (delivery_id) => {
    setDeliveryToDelete(delivery_id);
    setShowDeliveryDeleteConfirmation(true);
  };

  const handleDeliveryDeleteConfirmation = async () => {
    try {
      const response = await api.delete('vendorDeliveryStock.php', {
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          delivery_id: deliveryToDelete,
          company_id: Cookies.get('company_id')
        })
      });

      if (response.data.status === 'success') {
        // Show success message with restored quantity info
        const restoredQuantity = response.data.restored_quantity;
        const successMessage = `Delivery deleted successfully! Stock restored: ${restoredQuantity} units added back to inventory.`;
        
        // Set success message state (you may need to add this state)
        setSuccessMessage(successMessage);
        setShowSuccessAlert(true);
        
      setShowDeliveryDeleteConfirmation(false);
      setDeliveryToDelete(null);
        
        // Refresh both delivery data and vendor products data
        const [deliveryResponse, vendorProductsResponse] = await Promise.all([
          api.get("vendorDeliveryStock.php?company_id=" + Cookies.get('company_id')),
          api.get("vendorToStore.php?company_id=" + Cookies.get('company_id'))
        ]);
        
        const deliveryProducts = deliveryResponse.data.data || deliveryResponse.data;
        const vendorProducts = vendorProductsResponse.data.data || vendorProductsResponse.data;
        
        setMaterialDeliveryData(deliveryProducts);
        setFilteredMaterialDeliveryData(deliveryProducts);
        setVendorToStoreData(vendorProducts);
        setFilteredVendorToStoreData(vendorProducts);
        
        // Auto-hide success message after 3 seconds
        setTimeout(() => {
          setShowSuccessAlert(false);
        }, 3000);
      } else {
        throw new Error(response.data.message || 'Unknown error occurred');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Error deleting delivery record.";
      alert(errorMessage);
      setShowDeliveryDeleteConfirmation(false);
      setDeliveryToDelete(null);
    }
  };

  // State for filtered projects and tracking numbers in the return modal
  const [filteredReturnProjects, setFilteredReturnProjects] = useState([]);
  const [filteredReturnTrackingNumbers, setFilteredReturnTrackingNumbers] = useState([]);

  // When product is selected, filter projects and tracking numbers
  useEffect(() => {
    if (vendorReturnForm.vendor_product_id && Array.isArray(deliveryStockData)) {
      // Get all deliveries for the selected product
      const deliveriesForProduct = deliveryStockData.filter(
        (item) => String(item.vendor_product_id) === String(vendorReturnForm.vendor_product_id)
      );
      // Get unique projects for this product
      const uniqueProjects = Array.from(
        new Map(deliveriesForProduct.map(item => [item.p_id, { p_id: item.p_id, p_name: item.p_name }])).values()
      );
      setFilteredReturnProjects(uniqueProjects);
      // If a project is already selected, filter tracking numbers for both product and project
      if (vendorReturnForm.p_id) {
        const trackingNumbers = deliveriesForProduct
          .filter(item => String(item.p_id) === String(vendorReturnForm.p_id))
          .map(item => item.material_tracking_number)
          .filter((v, i, a) => v && a.indexOf(v) === i);
        setFilteredReturnTrackingNumbers(trackingNumbers);
      } else {
        // Otherwise, show all tracking numbers for the product
        const trackingNumbers = deliveriesForProduct
          .map(item => item.material_tracking_number)
          .filter((v, i, a) => v && a.indexOf(v) === i);
        setFilteredReturnTrackingNumbers(trackingNumbers);
      }
    } else {
      setFilteredReturnProjects([]);
      setFilteredReturnTrackingNumbers([]);
    }
  }, [vendorReturnForm.vendor_product_id, vendorReturnForm.p_id, deliveryStockData]);

  // Ensure returnPaginatedData is always an array
  const safeReturnPaginatedData = Array.isArray(returnPaginatedData) ? returnPaginatedData : [];

  // Add state for delivery and return search queries
  const [deliverySearchQuery, setDeliverySearchQuery] = useState("");
  const [returnSearchQuery, setReturnSearchQuery] = useState("");

  // Add state for project search queries in dropdowns
  const [deliveryProjectSearch, setDeliveryProjectSearch] = useState("");
  const [returnProjectSearch, setReturnProjectSearch] = useState("");
  const [materialDeliveryModalProjectDropdownOpen, setMaterialDeliveryModalProjectDropdownOpen] = useState(false);
  const [materialDeliveryModalProjectSearch, setMaterialDeliveryModalProjectSearch] = useState("");
  
  // Product dropdown states for Material Delivery modal
  const [materialDeliveryModalProductDropdownOpen, setMaterialDeliveryModalProductDropdownOpen] = useState(false);
  const [materialDeliveryModalProductSearch, setMaterialDeliveryModalProductSearch] = useState("");

  // Filter logic for Vendor Material Delivery
  useEffect(() => {
    if (!Array.isArray(materialDeliveryData)) {
      setFilteredMaterialDeliveryData([]);
      return;
    }
    
    if (deliverySearchQuery === "") {
      setFilteredMaterialDeliveryData(materialDeliveryData);
    } else {
      const filteredResults = materialDeliveryData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.vendor_name && item.vendor_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(deliverySearchQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(deliverySearchQuery.toLowerCase()))
      );
      setFilteredMaterialDeliveryData(filteredResults);
    }
  }, [deliverySearchQuery, materialDeliveryData]);

  // Filter logic for Vendor Material Return
  useEffect(() => {
    if (!Array.isArray(vendorReturnData)) {
      setFilteredVendorReturnData([]);
      return;
    }
    
    if (returnSearchQuery === "") {
      setFilteredVendorReturnData(vendorReturnData);
    } else {
      const filteredResults = vendorReturnData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.vendor_name && item.vendor_name.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(returnSearchQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(returnSearchQuery.toLowerCase()))
      );
      setFilteredVendorReturnData(filteredResults);
    }
  }, [returnSearchQuery, vendorReturnData]);

  // Pagination for Transaction Logs will be moved after state declaration

  // 1. Add state for Material Delivery dropdown and modal
  const [materialDeliveryDropdownOpen, setMaterialDeliveryDropdownOpen] = useState(false);
  const [showMultiMaterialDeliveryModal, setShowMultiMaterialDeliveryModal] = useState(false);
  const [multiMaterialDelivery, setMultiMaterialDelivery] = useState({
    p_id: '',
    vendor_id: '',
    delivered_to: '',
    delivery_date: '',
    file: null,
  });
  const [multiMaterialDeliveryMessage, setMultiMaterialDeliveryMessage] = useState({ type: '', text: '' });
  const [isMultiMaterialDeliveryUploading, setIsMultiMaterialDeliveryUploading] = useState(false);
  
  // Searchable dropdown states for Multiple Material Delivery modal
  const [multiMaterialDeliveryProjectDropdownOpen, setMultiMaterialDeliveryProjectDropdownOpen] = useState(false);
  const [multiMaterialDeliveryProjectSearch, setMultiMaterialDeliveryProjectSearch] = useState("");
  const [multiMaterialDeliveryVendorDropdownOpen, setMultiMaterialDeliveryVendorDropdownOpen] = useState(false);
  const [multiMaterialDeliveryVendorSearch, setMultiMaterialDeliveryVendorSearch] = useState("");

  const toggleMaterialDeliveryDropdown = () => setMaterialDeliveryDropdownOpen(prev => !prev);
  const handleMaterialDeliveryOption = (option) => {
    if (option === 'single') {
      toggleMaterialDeliveryModal();
    } else if (option === 'multiple') {
      setShowMultiMaterialDeliveryModal(true);
      // Clear search fields when opening modal
      setMultiMaterialDeliveryProjectSearch("");
      setMultiMaterialDeliveryVendorSearch("");
    }
    setMaterialDeliveryDropdownOpen(false);
  };

  const handleMultiMaterialDeliveryChange = (e) => {
    const { name, value, files } = e.target;
    setMultiMaterialDelivery(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    setMultiMaterialDeliveryMessage({ type: '', text: '' });
    
    // Clear search fields when selections change
    if (name === 'p_id') {
      setMultiMaterialDeliveryProjectSearch("");
    } else if (name === 'vendor_id') {
      setMultiMaterialDeliveryVendorSearch("");
    }
  };

  const handleMultiMaterialDeliverySubmit = async (e) => {
    e.preventDefault();
    if (!multiMaterialDelivery.p_id || !multiMaterialDelivery.vendor_id || !multiMaterialDelivery.delivered_to || !multiMaterialDelivery.delivery_date || !multiMaterialDelivery.file) {
      setMultiMaterialDeliveryMessage({ type: 'danger', text: 'Please fill in all required fields.' });
      return;
    }
    setIsMultiMaterialDeliveryUploading(true);
    setMultiMaterialDeliveryMessage({ type: 'primary', text: 'Uploading and processing file...' });
    const formData = new FormData();
    formData.append('p_id', multiMaterialDelivery.p_id);
    formData.append('delivered_to', multiMaterialDelivery.delivered_to);
    formData.append('delivery_date', multiMaterialDelivery.delivery_date);
    formData.append('vendor_id', multiMaterialDelivery.vendor_id); // Ensure vendor_id is sent
    formData.append('company_id', Cookies.get('company_id'));
    formData.append('excel_file', multiMaterialDelivery.file);
    try {
      const response = await api.post('bulkVendorDeliveryImport.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data && response.data.status === 'success') {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || 'Material delivery imported successfully!';
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setShowMultiMaterialDeliveryModal(false);
        // Clear search fields
        setMultiMaterialDeliveryProjectSearch("");
        setMultiMaterialDeliveryVendorSearch("");
        // Page will reload when user clicks OK button
      } else {
        setSuccessMessage(response.data.message || 'Failed to upload file.');
        setAlertType("error");
        setShowSuccessAlert(true);
        setShowMultiMaterialDeliveryModal(false);
        // Clear search fields
        setMultiMaterialDeliveryProjectSearch("");
        setMultiMaterialDeliveryVendorSearch("");
      }
    } catch (error) {
      setSuccessMessage(`Error uploading file: ${error.response?.data?.message || error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
      setShowMultiMaterialDeliveryModal(false);
      // Clear search fields
      setMultiMaterialDeliveryProjectSearch("");
      setMultiMaterialDeliveryVendorSearch("");
    } finally {
      setIsMultiMaterialDeliveryUploading(false);
    }
  };

  // 1. Add state for return material dropdown and modal
  const [returnMaterialDropdownOpen, setReturnMaterialDropdownOpen] = useState(false);
  const [showMultiReturnModal, setShowMultiReturnModal] = useState(false);
  const [multiReturn, setMultiReturn] = useState({
    p_id: '',
    vendor_id: '',
    returned_by: '',
    return_date: '',
    file: null,
  });
  const [multiReturnMessage, setMultiReturnMessage] = useState({ type: '', text: '' });
  const [isMultiReturnUploading, setIsMultiReturnUploading] = useState(false);
  const [multiReturnClients, setMultiReturnClients] = useState([]);
  
  // Searchable dropdown states for Multiple Return Materials modal
  const [multiReturnProjectDropdownOpen, setMultiReturnProjectDropdownOpen] = useState(false);
  const [multiReturnProjectSearch, setMultiReturnProjectSearch] = useState("");
  const [multiReturnVendorDropdownOpen, setMultiReturnVendorDropdownOpen] = useState(false);
  const [multiReturnVendorSearch, setMultiReturnVendorSearch] = useState("");

  // Add state for return to vendor dropdown and modal
  const [returnToVendorDropdownOpen, setReturnToVendorDropdownOpen] = useState(false);
  const [showMultiReturnToVendorModal, setShowMultiReturnToVendorModal] = useState(false);
  const [multiReturnToVendor, setMultiReturnToVendor] = useState({
    vendor_id: '',
    return_date: '',
    file: null,
  });
  const [multiReturnToVendorMessage, setMultiReturnToVendorMessage] = useState({ type: '', text: '' });
  const [isMultiReturnToVendorUploading, setIsMultiReturnToVendorUploading] = useState(false);

  // Transaction Logs states
  // const [transactionLogs, setTransactionLogs] = useState([]);
  // const [filteredTransactionLogs, setFilteredTransactionLogs] = useState([]);
  // const [transactionLogsEntriesToShow, setTransactionLogsEntriesToShow] = useState(10);
  // const [transactionLogsCurrentPage, setTransactionLogsCurrentPage] = useState(1);
  // const [transactionLogsShowEntriesDropdownOpen, setTransactionLogsShowEntriesDropdownOpen] = useState(false);
  // const [paginatedTransactionLogs, setPaginatedTransactionLogs] = useState([]);
  // const [transactionLogsTotalPages, setTransactionLogsTotalPages] = useState(1);

  // 2. Handle dropdown and modal toggles
  const toggleReturnMaterialDropdown = () => setReturnMaterialDropdownOpen(prev => !prev);
  const handleReturnMaterialOption = (option) => {
    if (option === 'single') {
      setShowVendorReturnModal(true); // Show the existing single return modal
    } else if (option === 'multiple') {
      setShowMultiReturnModal(true);
      // Clear search fields when opening modal
      setMultiReturnProjectSearch("");
      setMultiReturnVendorSearch("");
    }
    setReturnMaterialDropdownOpen(false);
  };

  // Handle return to vendor dropdown and modal toggles
  const toggleReturnToVendorDropdown = () => setReturnToVendorDropdownOpen(prev => !prev);
  const handleReturnToVendorOption = (option) => {
    if (option === 'single') {
      setShowReturnToVendorModal(true); // Show the existing single return to vendor modal
    } else if (option === 'multiple') {
      setShowMultiReturnToVendorModal(true);
    }
    setReturnToVendorDropdownOpen(false);
  };

  // 3. Handle project/vendor selection and filter delivered_to
  const handleMultiReturnProjectChange = (e) => {
    const projectId = e.target.value;
    setMultiReturn(prev => ({ ...prev, p_id: projectId, returned_by: '' }));
    // Clear project search
    setMultiReturnProjectSearch("");
    // Find all delivered_to for this project and selected vendor
    const clients = [
      ...new Set(
        materialDeliveryData
          .filter(item => String(item.p_id) === String(projectId) && (!multiReturn.vendor_id || String(item.vendor_id) === String(multiReturn.vendor_id)))
          .map(item => item.delivered_to_name || item.delivered_to)
          .filter(Boolean)
      )
    ];
    console.log('Project change - Found clients:', clients, 'for project:', projectId);
    setMultiReturnClients(clients);
  };
  
  const handleMultiReturnVendorChange = (e) => {
    const vendorId = e.target.value;
    setMultiReturn(prev => ({ ...prev, vendor_id: vendorId, returned_by: '' }));
    // Clear vendor search
    setMultiReturnVendorSearch("");
    // Find all delivered_to for this vendor and selected project
    const clients = [
      ...new Set(
        materialDeliveryData
          .filter(item => String(item.vendor_id) === String(vendorId) && (!multiReturn.p_id || String(item.p_id) === String(multiReturn.p_id)))
          .map(item => item.delivered_to_name || item.delivered_to)
          .filter(Boolean)
      )
    ];
    console.log('Vendor change - Found clients:', clients, 'for vendor:', vendorId);
    setMultiReturnClients(clients);
  };
  const handleMultiReturnChange = (e) => {
    const { name, value, files } = e.target;
    setMultiReturn(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    setMultiReturnMessage({ type: '', text: '' });
    
    // If project or vendor changed, refresh client list
    if (name === 'p_id' || name === 'vendor_id') {
      refreshMultiReturnClients();
    }
  };
  
  // Function to refresh client list based on current project and vendor selection
  const refreshMultiReturnClients = () => {
    if (multiReturn.p_id && multiReturn.vendor_id) {
      const clients = [
        ...new Set(
          materialDeliveryData
            .filter(item => 
              String(item.p_id) === String(multiReturn.p_id) && 
              String(item.vendor_id) === String(multiReturn.vendor_id)
            )
            .map(item => item.delivered_to_name || item.delivered_to)
            .filter(Boolean)
        )
      ];
      console.log('Refreshing clients - Found:', clients, 'for project:', multiReturn.p_id, 'vendor:', multiReturn.vendor_id);
      setMultiReturnClients(clients);
    }
  };

  // 4. Handle multi return submit
  const handleMultiReturnSubmit = async (e) => {
    e.preventDefault();
    if (!multiReturn.p_id || !multiReturn.vendor_id || !multiReturn.returned_by || !multiReturn.return_date || !multiReturn.file) {
      setMultiReturnMessage({ type: 'danger', text: 'Please fill in all required fields.' });
      return;
    }

    // Date validation removed - users can select any date for returns
    setIsMultiReturnUploading(true);
    setMultiReturnMessage({ type: 'primary', text: 'Uploading and processing file...' });
    const formData = new FormData();
    formData.append('p_id', multiReturn.p_id);
    formData.append('vendor_id', multiReturn.vendor_id);
    formData.append('returned_by', multiReturn.returned_by);
    formData.append('return_date', multiReturn.return_date);
    formData.append('company_id', Cookies.get('company_id'));
    formData.append('excel_file', multiReturn.file);
    try {
      const response = await api.post('bulkVendorReturnImport.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data && response.data.status === 'success') {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || 'Return materials imported successfully!';
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setShowMultiReturnModal(false);
        // Clear search fields
        setMultiReturnProjectSearch("");
        setMultiReturnVendorSearch("");
        // Page will reload when user clicks OK button
      } else {
        setSuccessMessage(response.data.message || 'Failed to upload file.');
        setAlertType("error");
        setShowSuccessAlert(true);
        setShowMultiReturnModal(false);
        // Clear search fields
        setMultiReturnProjectSearch("");
        setMultiReturnVendorSearch("");
      }
    } catch (error) {
      setSuccessMessage(`Error uploading file: ${error.response?.data?.message || error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
      setShowMultiReturnModal(false);
      // Clear search fields
      setMultiReturnProjectSearch("");
      setMultiReturnVendorSearch("");
    } finally {
      setIsMultiReturnUploading(false);
    }
  };

  // Add a function to filter clients for the single return modal
  const getSingleReturnClients = () => {
    if (!vendorReturnForm.vendor_id || !vendorReturnForm.p_id) return [];
    
    const clients = [
      ...new Set(
        materialDeliveryData
          .filter(item => 
            String(item.vendor_id) === String(vendorReturnForm.vendor_id) && 
            String(item.p_id) === String(vendorReturnForm.p_id)
          )
          .map(item => item.delivered_to_name || item.delivered_to)
          .filter(Boolean)
      )
    ];
    return clients;
  };
  
  // Add useEffect to refresh client list when modal opens
  useEffect(() => {
    if (showMultiReturnModal && multiReturn.p_id && multiReturn.vendor_id) {
      refreshMultiReturnClients();
    }
  }, [showMultiReturnModal, multiReturn.p_id, multiReturn.vendor_id]);

  // Update Store to Vendor total pages when filtered data changes
  useEffect(() => {
    setStoreToVendorTotalPages(Math.ceil(filteredStoreToVendorData.length / storeToVendorEntriesToShow));
  }, [filteredStoreToVendorData, storeToVendorEntriesToShow]);

  // Handle multiple return to vendor functionality
  const handleMultiReturnToVendorChange = (e) => {
    const { name, value, files } = e.target;
    setMultiReturnToVendor(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    setMultiReturnToVendorMessage({ type: '', text: '' });
  };

  const handleMultiReturnToVendorSubmit = async (e) => {
    e.preventDefault();
    if (!multiReturnToVendor.vendor_id || !multiReturnToVendor.return_date || !multiReturnToVendor.file) {
      setMultiReturnToVendorMessage({ type: 'danger', text: 'Please fill in all required fields.' });
      return;
    }

    setIsMultiReturnToVendorUploading(true);
    setMultiReturnToVendorMessage({ type: 'primary', text: 'Uploading and processing file...' });
    
    const formData = new FormData();
    formData.append('vendor_id', multiReturnToVendor.vendor_id);
    formData.append('return_date', multiReturnToVendor.return_date);
    formData.append('company_id', Cookies.get('company_id'));
    formData.append('excel_file', multiReturnToVendor.file);
    
    try {
      const response = await api.post('bulkStoreToVendorReturnImport.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      if (response.data && response.data.status === 'success') {
        setMultiReturnToVendorMessage({ type: 'success', text: response.data.message });
        setShowMultiReturnToVendorModal(false);
        setTimeout(() => {
          setMultiReturnToVendorMessage({ type: '', text: '' });
          window.location.reload();
        }, 2000);
      } else {
        setMultiReturnToVendorMessage({ type: 'danger', text: response.data.message || 'Failed to upload file.' });
      }
    } catch (error) {
      console.error('Multi Return to Vendor Submit - Error:', error);
      setMultiReturnToVendorMessage({ type: 'danger', text: `Error uploading file: ${error.response?.data?.message || error.message}` });
    } finally {
      setIsMultiReturnToVendorUploading(false);
    }
  };
  
  // Debug: Log materialDeliveryData structure
  useEffect(() => {
    if (showMultiReturnModal) {
      console.log('Material Delivery Data:', materialDeliveryData);
      console.log('Multi Return State:', multiReturn);
    }
  }, [showMultiReturnModal]);

  // Download function for Vendor Material Delivery
  const handleDownloadDelivery = () => {
    if (!Array.isArray(filteredMaterialDeliveryData) || filteredMaterialDeliveryData.length === 0) {
      alert("No data available to download");
      return;
    }
    const formattedData = filteredMaterialDeliveryData.map((item, idx) => ({
      "Item ID": idx + 1,
      "Product Name": item.product_name,
      "Quantity Delivered": item.quantity_delivered,
      "Delivered Date": item.delivery_date ? item.delivery_date.split(' ')[0] : '',
      "Delivered Vendor": item.vendor_name,
      "Delivered To": item.delivered_to,
      "Project": item.p_name,
      "Tracking ID": item.material_tracking_number,
      "Delivery Cost": item.delivery_cost,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Item ID",
        "Product Name",
        "Quantity Delivered",
        "Delivered Date",
        "Delivered Vendor",
        "Delivered To",
        "Project",
        "Tracking ID",
        "Delivery Cost",
      ],
    });

    // Apply header styling
    const headerCellStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "D86F89" } },
      alignment: { horizontal: "center" },
    };

    // Apply header styling to all header cells
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1'].forEach((key) => {
      if (ws[key]) {
        ws[key].s = headerCellStyle;
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendor Material Delivery");

    // Generate filename with current date
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    const filename = `Vendor_Material_Delivery_${dateStr}.xlsx`;

    XLSX.writeFile(wb, filename);
  };

  // Download function for Vendor to Store (ADD STOCK)
  const handleDownloadVendorToStore = () => {
    if (!Array.isArray(filteredVendorToStoreData) || filteredVendorToStoreData.length === 0) {
      alert("No data available to download");
      return;
    }
    
    // Use the filtered vendor_to_store table data
    const transactionLog = filteredVendorToStoreData.map((item, idx) => ({
      "S.No": idx + 1,
      "Vendor Name": item.vendor_name,
      "Product Name": item.product_name,
      "Quantity Delivered": item.initial_quantity, // This is the ORIGINAL quantity from the transaction log
      "Cost per Unit": item.cost_per_unit,
      "Date": item.delivery_date,
    }));

    const ws = XLSX.utils.json_to_sheet(transactionLog, {
      header: [
        "S.No",
        "Vendor Name",
        "Product Name",
        "Quantity Delivered",
        "Cost per Unit",
        "Date",
      ],
    });

    // Apply header styling
    const headerCellStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "D86F89" } },
      alignment: { horizontal: "center" },
    };

    // Apply header styling to all header cells
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'].forEach((key) => {
      if (ws[key]) {
        ws[key].s = headerCellStyle;
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendor to Store");

    // Generate filename with current date
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    const filename = `Vendor_to_Store_${dateStr}.xlsx`;

    XLSX.writeFile(wb, filename);
  };

  // Download function for Store to Vendor (Return STOCK)
  const handleDownloadStoreToVendor = () => {
    if (!Array.isArray(filteredStoreToVendorData) || filteredStoreToVendorData.length === 0) {
      alert("No data available to download");
      return;
    }
    const formattedData = filteredStoreToVendorData.map((item, idx) => ({
      "Item ID": idx + 1,
      "Vendor Name": item.vendor_name,
      "Product Name": item.product_name,

      "Quantity Returned": item.quantity_returned,
      "Return Date": item.return_date,
      "Return Reason": item.return_reason || 'N/A',
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Item ID",
        "Vendor Name",
        "Product Name",
        "Quantity Returned",
        "Return Date",
        "Return Reason",
      ],
    });

    // Apply header styling
    const headerCellStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "D86F89" } },
      alignment: { horizontal: "center" },
    };

    // Apply header styling to all header cells
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'].forEach((key) => {
      if (ws[key]) {
        ws[key].s = headerCellStyle;
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Store to Vendor");

    // Generate filename with current date
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    const filename = `Store_to_Vendor_${dateStr}.xlsx`;

    XLSX.writeFile(wb, filename);
  };

  // Download function for Vendor Material Return
  const handleDownloadReturn = () => {
    if (!Array.isArray(filteredVendorReturnData) || filteredVendorReturnData.length === 0) {
      alert("No data available to download");
      return;
    }
    const formattedData = filteredVendorReturnData.map((item, idx) => ({
      "Item ID": idx + 1,
      "Product Name": item.product_name,
      "Returned Quantity": item.returned_quantity,
      "Yet To Return": item.yet_to_return,
      "Return Date": item.return_date,
      "Vendor Name": item.vendor_name,
      "Project Name": item.p_name,
      "Material Tracking Number": item.material_tracking_number,
      "Returned By": item.returned_by,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Item ID",
        "Product Name",
        "Returned Quantity",
        "Yet To Return",
        "Return Date",
        "Vendor Name",
        "Project Name",
        "Material Tracking Number",
        "Returned By",
      ],
    });

    // Apply header styling
    const headerCellStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "D86F89" } },
      alignment: { horizontal: "center" },
    };

    // Apply header styling to all header cells
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1'].forEach((key) => {
      if (ws[key]) {
        ws[key].s = headerCellStyle;
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendor Material Return");

    // Generate filename with current date
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0];
    const filename = `Vendor_Material_Return_${dateStr}.xlsx`;

    XLSX.writeFile(wb, filename);
  };

  // Transaction Logs helper functions
  // const getTransactionTypeBadge = (transactionType) => { ... }
  // const getTransactionTypeLabel = (transactionType) => { ... }
  // const handleDownloadTransactionLogs = () => { ... }

  // Project selection functions for stock import




  // Store to Vendor (Return STOCK) functions
  const handleReturnToVendorInputChange = (e) => {
    const { name, value } = e.target;
    
    // Reset dependent fields when vendor or project changes
    if (name === 'vendor_id' || name === 'project_id') {
      setReturnToVendorForm(prev => ({
        ...prev,
        [name]: value,
        product_id: "", // Reset product selection
        quantity_returned: "" // Reset quantity
      }));
    } else {
      setReturnToVendorForm(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleReturnToVendorSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Form submission started');
    console.log('Form data:', returnToVendorForm);
    console.log('Validation check:', {
      hasVendor: !!returnToVendorForm.vendor_id,
      hasProduct: !!returnToVendorForm.product_id,
      hasQuantity: !!returnToVendorForm.quantity_returned,
      hasDate: !!returnToVendorForm.return_date
    });
    
    if (!returnToVendorForm.vendor_id || !returnToVendorForm.product_id || 
        !returnToVendorForm.quantity_returned || !returnToVendorForm.return_date) {
      alert("Please fill in all required fields");
      return;
    }

    if (parseFloat(returnToVendorForm.quantity_returned) <= 0) {
      alert("Quantity returned must be greater than 0");
      return;
    }

    // Date validation removed - users can select any date for returns

    // Validate quantity against available stock
    const selectedProduct = originalData.find(item => item.vendor_product_id === returnToVendorForm.product_id);
    if (selectedProduct) {
      const availableStock = parseInt(selectedProduct.available_stock);
      const returnQuantity = parseInt(returnToVendorForm.quantity_returned);
      
      if (returnQuantity > availableStock) {
        alert(`Cannot return ${returnQuantity} units. Only ${availableStock} units are available for this product.`);
        return;
      }
    }

    try {
      const company_id = Cookies.get('company_id');
      const response = await api.post('returnToVendor.php', {
        ...returnToVendorForm,
        company_id
      });

      if (response.data.status === 'success') {
        setSuccessMessage('Stock returned to vendor successfully!');
        setShowSuccessAlert(true);
        setShowReturnToVendorModal(false);
        
        // Reset form
        setReturnToVendorForm({
          vendor_id: "",
          product_id: "",
          quantity_returned: "",
          return_date: "",
          return_reason: ""
        });

        // Refresh data
        window.location.reload();
      } else {
        alert(response.data.message || 'Failed to return stock to vendor');
      }
    } catch (error) {
      console.error('Error returning stock to vendor:', error);
      alert('Error returning stock to vendor');
    }
  };

  const handleDeleteReturnToVendor = async (id) => {
    if (window.confirm('Are you sure you want to delete this return to vendor record?')) {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.delete('returnToVendor.php', {
          data: { id, company_id }
        });

        if (response.data.status === 'success') {
          // Show success message with restored quantity info
          const restoredQuantity = response.data.restored_quantity;
          const successMessage = `Return to vendor record deleted successfully! Stock restored: ${restoredQuantity} units added back to inventory.`;
          
          setSuccessMessage(successMessage);
          setShowSuccessAlert(true);
          
          // Remove from local state
          setStoreToVendorData(prev => prev.filter(item => item.id !== id));
          setFilteredStoreToVendorData(prev => prev.filter(item => item.id !== id));
          
          // Refresh vendor products data to show updated stock
          const vendorProductsResponse = await api.get("vendorToStore.php?company_id=" + company_id);
          const vendorProducts = vendorProductsResponse.data.data || vendorProductsResponse.data;
          setVendorToStoreData(vendorProducts);
          setFilteredVendorToStoreData(vendorProducts);
          
          // Auto-hide success message after 3 seconds
          setTimeout(() => {
            setShowSuccessAlert(false);
          }, 3000);
        } else {
          alert(response.data.message || 'Failed to delete record');
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Error deleting record';
        alert(errorMessage);
        console.error('Error deleting return to vendor record:', error);
      }
    }
  };

  // Project Report functions
  const loadProjectReports = async () => {
    setProjectReportLoading(true);
    try {
      const params = { company_id: Cookies.get('company_id') };
      // Don't send filter parameters to backend - do filtering on frontend
      
      const response = await api.get('/projectReport.php', { params });
      
      if (response.data.status === 'success') {
        console.log('📊 Project Reports loaded:', response.data.reports);
        console.log('Sample report data:', response.data.reports?.slice(0, 2));
        setProjectReports(response.data.reports || []);
        setProjectReportMessage('');
      } else {
        setProjectReportMessage(response.data.message || 'Error loading reports');
        setProjectReportMessageType('danger');
      }
    } catch (error) {
      console.error('Error loading project reports:', error);
      setProjectReportMessage('Error loading reports: ' + error.message);
      setProjectReportMessageType('danger');
    }
    setProjectReportLoading(false);
  };

  const generateProjectReport = async () => {
    setProjectReportGenerating(true);
    setProjectReportMessage('');
    
    try {
      const response = await api.post('/projectReport.php', {
        company_id: Cookies.get('company_id'),
        project_id: selectedProjectReportProject || null
      });
      
      if (response.data.status === 'success') {
        setProjectReportMessage(`Report generated successfully! ${response.data.records_created} records created.`);
        setProjectReportMessageType('success');
        await loadProjectReports(); // Reload the reports
      } else {
        setProjectReportMessage(response.data.message || 'Error generating report');
        setProjectReportMessageType('danger');
      }
    } catch (error) {
      console.error('Error generating project report:', error);
      setProjectReportMessage('Error generating report: ' + error.message);
      setProjectReportMessageType('danger');
    }
    setProjectReportGenerating(false);
  };

  const applyProjectReportFilters = () => {
    let filtered = [...projectReports];

    console.log('🔍 Project Report Filter Debug:');
    console.log('Total reports:', projectReports.length);
    console.log('Selected vendor:', selectedProjectReportVendor, 'Type:', typeof selectedProjectReportVendor);
    console.log('Selected project:', selectedProjectReportProject);
    console.log('Product search:', projectReportProductSearch);
    console.log('All reports data:', projectReports);

    if (selectedProjectReportProject) {
      filtered = filtered.filter(report => String(report.p_id) === String(selectedProjectReportProject));
      console.log('After project filter:', filtered.length);
    }

    if (selectedProjectReportVendor) {
      console.log('Applying vendor filter for:', selectedProjectReportVendor);
      console.log('Sample report vendor IDs:', projectReports.slice(0, 3).map(r => ({ 
        id: r.vendor_id, 
        name: r.vendor_name,
        idType: typeof r.vendor_id,
        idValue: r.vendor_id
      })));
      
      const beforeFilter = filtered.length;
      filtered = filtered.filter(report => {
        // Try multiple comparison methods to ensure it works
        const reportVendorId = String(report.vendor_id).trim();
        const selectedVendorId = String(selectedProjectReportVendor).trim();
        const matches = reportVendorId === selectedVendorId;
        
        console.log(`Report ${report.report_id}: vendor_id='${reportVendorId}' (${typeof report.vendor_id}), selected='${selectedVendorId}' (${typeof selectedProjectReportVendor}), matches=${matches}`);
        console.log(`Report details:`, report);
        return matches;
      });
      console.log(`Vendor filter: ${beforeFilter} -> ${filtered.length} records`);
    }

    if (projectReportProductSearch && projectReportProductSearch.trim()) {
      const searchTerm = projectReportProductSearch.toLowerCase().trim();
      console.log('🔍 Applying product search filter for term:', searchTerm);
      console.log('🔍 Before product search - filtered count:', filtered.length);
      console.log('🔍 Sample products before filter:', filtered.slice(0, 3).map(r => r.product_name));
      
      filtered = filtered.filter(report => {
        const productName = report.product_name.toLowerCase();
        const matches = productName.includes(searchTerm);
        console.log(`🔍 Product "${report.product_name}" matches "${searchTerm}": ${matches}`);
        return matches;
      });
      console.log('🔍 After product search filter:', filtered.length);
      console.log('🔍 Sample products after filter:', filtered.slice(0, 3).map(r => r.product_name));
    }

    console.log('Final filtered results:', filtered.length);
    console.log('Setting filteredProjectReports to:', filtered);
    setFilteredProjectReports(filtered);
    setProjectReportCurrentPage(1); // Reset to first page when filters change
  };

  const clearProjectReportFilters = () => {
    setSelectedProjectReportProject('');
    setSelectedProjectReportVendor('');
    setProjectReportProductSearch('');
    setProjectReportProjectSearch('');
  };

  const exportProjectReportToCSV = () => {
    const headers = ['S.No', 'Project Name', 'Product Name', 'Vendor Name', 'Delivered Quantity', 'Returned Quantity', 'Yet to Return'];
    const csvContent = [
      headers.join(','),
      ...filteredProjectReports.map((report, index) => [
        index + 1,
        `"${report.project_name}"`,
        `"${report.product_name}"`,
        `"${report.vendor_name}"`,
        report.delivered_quantity,
        report.returned_quantity,
        report.yet_to_return
      ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `project_report_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  // Project Report pagination functions
  const handleProjectReportEntriesChange = (value) => {
    setProjectReportEntriesPerPage(value);
    setProjectReportCurrentPage(1);
  };

  const projectReportPrevPage = () => {
    if (projectReportCurrentPage > 1) {
      setProjectReportCurrentPage(projectReportCurrentPage - 1);
    }
  };

  const projectReportNextPage = () => {
    const totalPages = Math.ceil(filteredProjectReports.length / projectReportEntriesPerPage);
    if (projectReportCurrentPage < totalPages) {
      setProjectReportCurrentPage(projectReportCurrentPage + 1);
    }
  };

  // Load project reports on component mount
  useEffect(() => {
    loadProjectReports();
  }, []);

  // Apply filters whenever filter states change
  useEffect(() => {
    applyProjectReportFilters();
  }, [projectReports, selectedProjectReportProject, selectedProjectReportVendor, projectReportProductSearch]);

  // Calculate paginated data for Project Report
  const projectReportPaginatedData = filteredProjectReports.slice(
    (projectReportCurrentPage - 1) * projectReportEntriesPerPage,
    projectReportCurrentPage * projectReportEntriesPerPage
  );

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          {alertVisible && (
            <Alert color="success" toggle={() => setAlertVisible(false)}>
              {alertMessage}
            </Alert>
          )}
          {showSuccessAlert && (
            <Alert 
              color="success" 
              isOpen={showSuccessAlert}
              toggle={() => setShowSuccessAlert(false)}
              style={{ marginBottom: '20px' }}
            >
              <strong>Success!</strong> {successMessage}
            </Alert>
          )}

          {/* Stock Report */}
          <Row className="mt-4">
            <Col xl="12">
              <Card className="shadow">
                <CardBody style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Stock Report</h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>

                          {/* Search Bar */}
                          {/* Stock Report top search removed as requested */}



                          {/* Select Vendors Dropdown */}
                          <div>
                            <Dropdown isOpen={projectDropdownOpen3} toggle={toggleProjectDropdown3}>
                              <DropdownToggle caret>
                                {selectedVendorFilter
                                  ? vendors.find(v => v.vendor_id === selectedVendorFilter)?.vendor_name || "Select Vendors"
                                  : "Select Vendors"}
                              </DropdownToggle>
                              <DropdownMenu right style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                                {/* Search Bar */}
                                <div className="mb-2">
                                  <Input
                                    type="text"
                                    placeholder="Search vendors..."
                                    value={vendorSearchQuery || ''}
                                    onChange={(e) => setVendorSearchQuery(e.target.value)}
                                    style={{ fontSize: '13px', height: '32px' }}
                                  />
                                </div>
                                <DropdownItem onClick={() => handleVendorFilter('')} style={{ padding: '6px 12px', fontSize: '13px' }}>
                                  All Vendors
                                </DropdownItem>
                                {(() => {
                                  const filteredVendors = vendors.filter(vendor => 
                                    !vendorSearchQuery || 
                                    vendor.vendor_name.toLowerCase().includes(vendorSearchQuery.toLowerCase())
                                  );
                                  const displayedVendors = filteredVendors.slice(0, 5);
                                  
                                  return (
                                    <>
                                      {filteredVendors.length > 0 ? (
                                        displayedVendors.map((vendor) => (
                                          <DropdownItem
                                            key={vendor.vendor_id}
                                            onClick={() => handleVendorFilter(vendor.vendor_id)}
                                            style={{ padding: '6px 12px', fontSize: '13px' }}
                                          >
                                            {vendor.vendor_name}
                                          </DropdownItem>
                                        ))
                                      ) : (
                                        <DropdownItem disabled>No Vendors Available</DropdownItem>
                                      )}
                                      {filteredVendors.length > 5 && (
                                        <DropdownItem disabled style={{ fontSize: '12px', fontStyle: 'italic', textAlign: 'center' }}>
                                          Scroll down for more vendors...
                                        </DropdownItem>
                                      )}
                                    </>
                                  );
                                })()}
                              </DropdownMenu>
                            </Dropdown>
                          </div>

                          {/* Select Products Dropdown */}
                          <div>
                            <Dropdown isOpen={productFilterDropdownOpen} toggle={toggleProductFilterDropdown}>
                              <DropdownToggle caret>
                                {selectedProductFilter || "Select Products"}
                              </DropdownToggle>
                              <DropdownMenu right style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                                {/* Search Bar */}
                                <div className="mb-2">
                                  <Input
                                    type="text"
                                    placeholder="Search products..."
                                    value={productSearchQuery || ''}
                                    onChange={(e) => setProductSearchQuery(e.target.value)}
                                    style={{ fontSize: '13px', height: '32px' }}
                                  />
                                </div>
                                <DropdownItem onClick={() => handleProductFilter('')} style={{ padding: '6px 12px', fontSize: '13px' }}>
                                  All Products
                                </DropdownItem>
                                {(() => {
                                  const filteredProducts = getUniqueProducts().filter(product => 
                                    !productSearchQuery || 
                                    product.toLowerCase().includes(productSearchQuery.toLowerCase())
                                  );
                                  const displayedProducts = filteredProducts.slice(0, 5);
                                  
                                  return (
                                    <>
                                      {filteredProducts.length > 0 ? (
                                        displayedProducts.map((product) => (
                                          <DropdownItem
                                            key={product}
                                            onClick={() => handleProductFilter(product)}
                                            style={{ padding: '6px 12px', fontSize: '13px' }}
                                          >
                                            {product}
                                          </DropdownItem>
                                        ))
                                      ) : (
                                        <DropdownItem disabled>No Products Available</DropdownItem>
                                      )}
                                      {filteredProducts.length > 5 && (
                                        <DropdownItem disabled style={{ fontSize: '12px', fontStyle: 'italic', textAlign: 'center' }}>
                                          Scroll down for more products...
                                        </DropdownItem>
                                      )}
                                    </>
                                  );
                                })()}
                              </DropdownMenu>
                            </Dropdown>
                          </div>

                          {/* Show Entries Dropdown */}
                          <div>
                            <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
                              <DropdownToggle caret>
                                Show Entries:{" "}
                                {entriesToShow === filteredData.length ? "All" : entriesToShow}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                                <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                                <DropdownItem onClick={() => handleEntriesChange(50)}>50</DropdownItem>
                                <DropdownItem onClick={() => handleEntriesChange("All")}>All</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>

                          {/* Download Button */}
                          <div>
                            <button
                              className="btn"
                              onClick={handleDownload}
                              style={{
                                backgroundColor: '#d86f89',
                                borderColor: '#d86f89',
                                color: 'black',
                                fontWeight: 'bold',
                                padding: '0.5rem 1.25rem',
                                borderRadius: '0.375rem',
                                minWidth: '130px'
                              }}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Vendor Name</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Current Stock(Quantity)</th>
                        <th scope="col">Total Stock</th>
                        <th scope="col">Cost</th>
                        {/* <th scope="col">Action</th> */}
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {dataToShow.map((item, index) => (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>{item.vendor_name}</td>
                          <td>{item.product_name}</td>
                          <td>{item.available_stock}</td>
                          <td>{item.total_stock}</td>
                          <td>{item.cost}</td>
                          {/* <td
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            Edit and Delete options are hidden during stock addition
                            <span style={{ color: '#6c757d', fontStyle: 'italic' }}>
                              Actions disabled
                            </span>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <nav className="mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-muted">
                        Showing {((currentPage - 1) * entriesToShow) + 1} to {Math.min(currentPage * entriesToShow, filteredData.length)} of {filteredData.length} entries
                        {/* Search summary removed */}
                      </div>
                      <ul className="pagination justify-content-center mb-0">
                        <li className="page-item">
                          <a
                            href="#"
                            className="page-link text-primary"
                            onClick={prePage}
                            disabled={currentPage === 1}
                          >
                            Prev
                          </a>
                        </li>
                        <li className="page-item">
                          <a
                            href="#"
                            className="page-link text-primary"
                            onClick={nextPage}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          {/* Vendor to Store (ADD STOCK) Table */}
          <Row className="mt-4">
            <Col xl="12">
              <Card className="shadow">
                <CardBody style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Vendor To Store </h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>
                          {/* Download Button */}
                                      <Button
                            className="btn btn-success"
                            onClick={() => handleDownloadVendorToStore()}
                            style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                          >
                            Download
                                      </Button>

                          {/* Add Stock Dropdown */}
                            <Dropdown isOpen={projectDropdownOpen2} toggle={toggleProjectDropdown2}>
                            <DropdownToggle
                              style={{
                                backgroundColor: "#d86f89",
                                borderColor: "#d86f89",
                                color: "black",
                                fontWeight: 600,
                                borderRadius: '0.375rem',
                                boxShadow: 'none',
                                padding: '0.5rem 1.25rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5em'
                              }}
                              caret
                            >
                              Add Stock
                            </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => handleRequestOptionChange({ target: { value: "single" } })}>
                                <i className="fas fa-plus mr-2"></i>
                                  Add Single Stock
                                </DropdownItem>
                                <DropdownItem onClick={() => handleRequestOptionChange({ target: { value: "multiple" } })}>
                                <i className="fas fa-upload mr-2"></i>
                                  Add Multiple Stocks
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                      </div>
                    </Row>

                  </CardHeader>

                  {/* Filters Section */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="3">
                        <Label className="form-control-label">Vendor Name Filter:</Label>
                        <Dropdown isOpen={vendorToStoreVendorDropdownOpen} toggle={toggleVendorToStoreVendorDropdown}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedVendorToStoreVendor || "Select Vendor"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search vendors..."
                                value={vendorToStoreVendorSearch || ''}
                                onChange={(e) => setVendorToStoreVendorSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem onClick={() => handleVendorToStoreVendorFilter('')} style={{ padding: '6px 12px', fontSize: '13px' }}>
                              All Vendors
                            </DropdownItem>
                            {(() => {
                              const filteredVendors = getUniqueVendorToStoreVendors().filter(vendor => 
                                !vendorToStoreVendorSearch || 
                                vendor.toLowerCase().includes(vendorToStoreVendorSearch.toLowerCase())
                              );
                              const displayedVendors = filteredVendors.slice(0, 5);
                              
                              return (
                                <>
                                  {filteredVendors.length > 0 ? (
                                    displayedVendors.map((vendor) => (
                                      <DropdownItem
                                        key={vendor}
                                        onClick={() => handleVendorToStoreVendorFilter(vendor)}
                                        style={{ padding: '6px 12px', fontSize: '13px' }}
                                      >
                                        {vendor}
                                      </DropdownItem>
                                    ))
                                  ) : (
                                    <DropdownItem disabled>No Vendors Available</DropdownItem>
                                  )}
                                  {filteredVendors.length > 5 && (
                                    <DropdownItem disabled style={{ fontSize: '12px', fontStyle: 'italic', textAlign: 'center' }}>
                                      Scroll down for more vendors...
                                    </DropdownItem>
                                  )}
                                </>
                              );
                            })()}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Product Name Filter:</Label>
                        <Dropdown isOpen={vendorToStoreProductDropdownOpen} toggle={toggleVendorToStoreProductDropdown}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedVendorToStoreProduct || "Select Product"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search products..."
                                value={vendorToStoreProductSearch || ''}
                                onChange={(e) => setVendorToStoreProductSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem onClick={() => handleVendorToStoreProductFilter('')} style={{ padding: '6px 12px', fontSize: '13px' }}>
                              All Products
                            </DropdownItem>
                            {(() => {
                              const filteredProducts = getUniqueVendorToStoreProducts().filter(product => 
                                !vendorToStoreProductSearch || 
                                product.toLowerCase().includes(vendorToStoreProductSearch.toLowerCase())
                              );
                              const displayedProducts = filteredProducts.slice(0, 5);
                              
                              return (
                                <>
                                  {filteredProducts.length > 0 ? (
                                    displayedProducts.map((product) => (
                                      <DropdownItem
                                        key={product}
                                        onClick={() => handleVendorToStoreProductFilter(product)}
                                        style={{ padding: '6px 12px', fontSize: '13px' }}
                                      >
                                        {product}
                                      </DropdownItem>
                                    ))
                                  ) : (
                                    <DropdownItem disabled>No Products Available</DropdownItem>
                                  )}
                                  {filteredProducts.length > 5 && (
                                    <DropdownItem disabled style={{ fontSize: '12px', fontStyle: 'italic', textAlign: 'center' }}>
                                      Scroll down for more products...
                                    </DropdownItem>
                                  )}
                                </>
                              );
                            })()}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">Start Date:</Label>
                        <Input
                          type="date"
                          value={vendorToStoreStartDate}
                          onChange={(e) => handleVendorToStoreDateFilter(e.target.value, vendorToStoreEndDate)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">End Date:</Label>
                        <Input
                          type="date"
                          value={vendorToStoreEndDate}
                          onChange={(e) => handleVendorToStoreDateFilter(vendorToStoreStartDate, e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">Show Entries:</Label>
                        <Dropdown isOpen={vendorToStoreEntriesDropdownOpen} toggle={() => setVendorToStoreEntriesDropdownOpen(!vendorToStoreEntriesDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {vendorToStoreEntriesToShow === safeFilteredVendorToStoreData.length ? "All" : vendorToStoreEntriesToShow}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%' }}>
                            <DropdownItem onClick={() => handleVendorToStoreEntriesChange(5)}>5</DropdownItem>
                            <DropdownItem onClick={() => handleVendorToStoreEntriesChange(10)}>10</DropdownItem>
                            <DropdownItem onClick={() => handleVendorToStoreEntriesChange(50)}>50</DropdownItem>
                            <DropdownItem onClick={() => handleVendorToStoreEntriesChange("All")}>All</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                    </Row>
                    {/* <Row className="mt-3">
                      <Col className="text-center">
                        <Button color="primary" size="sm" onClick={() => applyVendorToStoreFilters(selectedVendorToStoreVendor, vendorToStoreStartDate, vendorToStoreEndDate)}>
                          Apply Filters
                        </Button>
                      </Col>
                    </Row> */}
                  </div>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Vendor Name</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity Delivered</th>
                        <th scope="col">Cost per Unit</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {vendorToStorePaginatedData.length === 0 ? (
                        <tr>
                          <td colSpan="6" style={{ color: '#888', fontWeight: 'bold' }}>
                            No vendor stock transactions found
                          </td>
                        </tr>
                      ) : (
                        vendorToStorePaginatedData.map((item, index) => (
                          <tr key={item.id}>
                            <th scope="row">{(vendorToStoreCurrentPage - 1) * vendorToStoreEntriesToShow + index + 1}</th>
                            <td>{item.vendor_name}</td>
                            <td>{item.product_name}</td>
                            <td>
                              <span style={{ 
                                fontWeight: 'bold', 
                                color: '#28a745',
                                fontSize: '1.1em'
                              }}>
                                {item.initial_quantity}
                              </span>
                            </td>
                            <td>
                              <span style={{ 
                                fontWeight: 'bold', 
                                color: '#dc3545',
                                fontSize: '1.1em'
                              }}>
                                ₹{item.cost_per_unit}
                              </span>
                            </td>
                            <td>{item.delivery_date}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  
                  {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((vendorToStoreCurrentPage - 1) * vendorToStoreEntriesToShow) + 1} to {Math.min(vendorToStoreCurrentPage * vendorToStoreEntriesToShow, safeFilteredVendorToStoreData.length)} of {safeFilteredVendorToStoreData.length} entries
                    </div>
                  </div>

                  {/* Pagination */}
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={vendorToStorePrevPage}
                          disabled={vendorToStoreCurrentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={vendorToStoreNextPage}
                          disabled={vendorToStoreCurrentPage === vendorToStoreTotalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Store to Vendor (Return STOCK) Table */}
          <Row className="mt-4">
            <Col xl="12">
              <Card className="shadow">
                <CardBody style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Store to Vendor </h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>
                          {/* Add Return to Vendor Dropdown */}
                          <Dropdown isOpen={returnToVendorDropdownOpen} toggle={toggleReturnToVendorDropdown}>
                            <DropdownToggle
                              style={{
                                backgroundColor: "#d86f89",
                                borderColor: "#d86f89",
                                color: "black",
                                fontWeight: 600,
                                borderRadius: '0.375rem',
                                boxShadow: 'none',
                                padding: '0.5rem 1.25rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5em'
                              }}
                              caret
                            >
                              Return to Vendor
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleReturnToVendorOption('single')}>
                                <i className="fas fa-plus mr-2"></i>
                                Add Single Return to Vendor
                              </DropdownItem>
                              <DropdownItem onClick={() => handleReturnToVendorOption('multiple')}>
                                <i className="fas fa-upload mr-2"></i>
                                Add Multiple Returns to Vendor
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                          {/* Download Button */}
                          <Button
                            className="btn btn-success"
                            onClick={() => handleDownloadStoreToVendor()}
                            style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                          >
                            Download
                          </Button>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  {/* Filters Section */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="3">
                        <Label className="form-control-label">Vendor Name Filter:</Label>
                        <Dropdown isOpen={storeToVendorVendorFilterDropdownOpen} toggle={() => setStoreToVendorVendorFilterDropdownOpen(!storeToVendorVendorFilterDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedStoreToVendorVendor || "Select Vendor"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%' }}>
                            <DropdownItem onClick={() => handleStoreToVendorVendorFilter("")}>All Vendors</DropdownItem>
                            {getUniqueStoreToVendorVendors().map((vendor) => (
                              <DropdownItem key={vendor} onClick={() => handleStoreToVendorVendorFilter(vendor)}>
                                {vendor}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Start Date:</Label>
                        <Input
                          type="date"
                          value={storeToVendorStartDate}
                          onChange={(e) => handleStoreToVendorDateFilter(e.target.value, storeToVendorEndDate)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">End Date:</Label>
                        <Input
                          type="date"
                          value={storeToVendorEndDate}
                          onChange={(e) => handleStoreToVendorDateFilter(storeToVendorStartDate, e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Show Entries:</Label>
                        <Dropdown isOpen={storeToVendorShowEntriesDropdownOpen} toggle={() => setStoreToVendorShowEntriesDropdownOpen(!storeToVendorShowEntriesDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {storeToVendorEntriesToShow === filteredStoreToVendorData.length ? "All" : storeToVendorEntriesToShow}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%' }}>
                            <DropdownItem onClick={() => handleStoreToVendorEntriesChange(5)}>5</DropdownItem>
                            <DropdownItem onClick={() => handleStoreToVendorEntriesChange(10)}>10</DropdownItem>
                            <DropdownItem onClick={() => handleStoreToVendorEntriesChange(50)}>50</DropdownItem>
                            <DropdownItem onClick={() => handleStoreToVendorEntriesChange("All")}>All</DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                    </Row>
                  </div>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Vendor Name</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity Returned</th>
                        <th scope="col">Return Date</th>
                        <th scope="col">Return Reason</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {filteredStoreToVendorData.length === 0 ? (
                        <tr>
                          <td colSpan="7" style={{ color: '#888', fontWeight: 'bold' }}>
                            No returns to vendor found
                          </td>
                        </tr>
                      ) : (
                        filteredStoreToVendorData
                          .slice(
                            (storeToVendorCurrentPage - 1) * storeToVendorEntriesToShow,
                            storeToVendorCurrentPage * storeToVendorEntriesToShow
                          )
                          .map((item, index) => (
                            <tr key={item.id || index}>
                              <th scope="row">
                                {(storeToVendorCurrentPage - 1) * storeToVendorEntriesToShow + index + 1}
                              </th>
                              <td>{item.vendor_name}</td>
                              <td>{item.product_name}</td>
                              <td>{item.quantity_returned}</td>
                              <td>{item.return_date}</td>
                              <td>{item.return_reason || 'N/A'}</td>
                              <td>
                                <Tippy content="Delete">
                                  <i
                                    className="fa fa-trash"
                                    style={{
                                      fontSize: "23px",
                                      color: "red",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleDeleteReturnToVendor(item.id)}
                                  ></i>
                                </Tippy>
                              </td>
                            </tr>
                          ))
                      )}
                    </tbody>
                  </Table>

                  {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((storeToVendorCurrentPage - 1) * storeToVendorEntriesToShow) + 1} to {Math.min(storeToVendorCurrentPage * storeToVendorEntriesToShow, filteredStoreToVendorData.length)} of {filteredStoreToVendorData.length} entries
                    </div>
                  </div>

                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (storeToVendorCurrentPage > 1) {
                              setStoreToVendorCurrentPage(storeToVendorCurrentPage - 1);
                            }
                          }}
                          disabled={storeToVendorCurrentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (storeToVendorCurrentPage < Math.ceil(filteredStoreToVendorData.length / storeToVendorEntriesToShow)) {
                              setStoreToVendorCurrentPage(storeToVendorCurrentPage + 1);
                            }
                          }}
                          disabled={storeToVendorCurrentPage === Math.ceil(filteredStoreToVendorData.length / storeToVendorEntriesToShow)}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>


          {/* Vendor Material Delivery */}
                    <Row className="mt-4">
            <Col xl="12">

    {/* Main Card */}
              <Card className="shadow">
                <CardBody style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Vendor Material Delivery</h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>
                          {/* Project Filter */}
                          <Dropdown isOpen={projectDropdownOpen4} toggle={toggleProjectDropdown4}>
                            <DropdownToggle caret color="secondary">
                              {selectedDeliveryProject
                                ? (projects.find((p) => String(p.p_id) === String(selectedDeliveryProject))?.p_name || "Select Project")
                                : "Select Project"}
                            </DropdownToggle>
                            <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                              {/* Search Bar Inside Dropdown */}
                              <div className="mb-2">
                                <Input
                                  type="text"
                                  placeholder="Search projects..."
                                  value={deliveryProjectSearch || ''}
                                  onChange={(e) => setDeliveryProjectSearch(e.target.value)}
                                  style={{ fontSize: '13px', height: '32px' }}
                                />
                              </div>
                              <DropdownItem onClick={() => handleDeliveryFilterChange("", selectedDeliveryVendor)} style={{ padding: '6px 12px', fontSize: '13px' }}>
                                All Projects
                              </DropdownItem>
                              {projects
                                .filter(project => 
                                  !deliveryProjectSearch || 
                                  project.p_name.toLowerCase().includes(deliveryProjectSearch.toLowerCase())
                                )
                                .map((project) => (
                                  <DropdownItem 
                                    key={project.p_id} 
                                    onClick={() => handleDeliveryFilterChange(project.p_id, selectedDeliveryVendor)}
                                    style={{ padding: '6px 12px', fontSize: '13px' }}
                                  >
                                    {project.p_name}
                                  </DropdownItem>
                                ))}
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Vendor Filter */}
                          <Dropdown isOpen={vendorDropdownOpen} toggle={toggleVendorDropdown}>
                            <DropdownToggle caret color="secondary">
                              {selectedDeliveryVendor
                                ? (vendors.find((v) => String(v.vendor_id) === String(selectedDeliveryVendor))?.vendor_name || "Select Vendor")
                                : "Select Vendor"}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleDeliveryFilterChange(selectedDeliveryProject, "")}>All Vendors</DropdownItem>
                              {vendors.map((vendor) => (
                                <DropdownItem key={vendor.vendor_id} onClick={() => handleDeliveryFilterChange(selectedDeliveryProject, vendor.vendor_id)}>
                                  {vendor.vendor_name}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Show Entries */}
                          <Dropdown isOpen={deliveryShowEntriesDropdownOpen} toggle={() => setDeliveryShowEntriesDropdownOpen(prev => !prev)}>
                            <DropdownToggle caret>
                              Show Entries: {deliveryEntriesToShow === safeFilteredMaterialDeliveryData.length ? "All" : deliveryEntriesToShow}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleDeliveryEntriesChange(5)}>5</DropdownItem>
                              <DropdownItem onClick={() => handleDeliveryEntriesChange(10)}>10</DropdownItem>
                              <DropdownItem onClick={() => handleDeliveryEntriesChange(50)}>50</DropdownItem>
                              <DropdownItem onClick={() => handleDeliveryEntriesChange("All")}>All</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Download */}
                          <Button
                            className="btn btn-success"
                            onClick={handleDownloadDelivery}
                            style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                          >
                            Download
                          </Button>
                          
                          {/* Add Material Delivery */}
                          <Dropdown isOpen={materialDeliveryDropdownOpen} toggle={toggleMaterialDeliveryDropdown}>
                            <DropdownToggle
                              style={{
                                backgroundColor: "#d86f89",
                                borderColor: "#d86f89",
                                color: "black",
                                fontWeight: 600,
                                borderRadius: '0.375rem',
                                boxShadow: 'none',
                                padding: '0.5rem 1.25rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5em'
                              }}
                              caret
                            >
                              Add Material Delivery
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleMaterialDeliveryOption('single')}>
                                Add Single Material Delivery
                              </DropdownItem>
                              <DropdownItem onClick={() => handleMaterialDeliveryOption('multiple')}>
                                Add Multiple Material Delivery
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  {/* Filters Section for Vendor Material Delivery */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="3">
                        <Label className="form-control-label">Product Name Filter:</Label>
                        <Dropdown isOpen={deliveryProductFilterDropdownOpen} toggle={toggleDeliveryProductFilterDropdown}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedDeliveryProduct || "Select Product"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search products..."
                                value={deliveryProductSearch || ''}
                                onChange={(e) => setDeliveryProductSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem onClick={() => handleDeliveryProductFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                              All Products
                            </DropdownItem>
                            {getUniqueDeliveryProducts()
                              .filter(product => 
                                !deliveryProductSearch || 
                                product.toLowerCase().includes(deliveryProductSearch.toLowerCase())
                              )
                              .map((product) => (
                                <DropdownItem 
                                  key={product} 
                                  onClick={() => handleDeliveryProductFilter(product)}
                                  style={{ padding: '6px 12px', fontSize: '13px' }}
                                >
                                  {product}
                                </DropdownItem>
                              ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Start Date:</Label>
                        <Input
                          type="date"
                          value={deliveryStartDate}
                          onChange={(e) => handleDeliveryDateFilter(e.target.value, deliveryEndDate)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">End Date:</Label>
                        <Input
                          type="date"
                          value={deliveryEndDate}
                          onChange={(e) => handleDeliveryDateFilter(deliveryStartDate, e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Total Items Delivered:</Label>
                        <div className="form-control" style={{
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          padding: '0.375rem 0.75rem',
                          borderRadius: '0.375rem',
                          fontWeight: 'bold',
                          color: '#495057'
                        }}>
                          {totalItemsDelivered}
                        </div>
                      </Col>
                    </Row>
                  </div>

        {/* Table */}
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Quantity Delivered</th>
                        <th scope="col">Delivered Date</th>
                        <th scope="col">Delivered Vendor</th>
              <th scope="col">Delivered To</th>
                        <th scope="col">Project</th>
                        <th scope="col">Tracking ID</th>
              <th scope="col">Delivery Cost</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {paginatedDeliveryData.map((item, index) => (
                        <tr key={item.delivery_id || index}>
                <th scope="row">
                  {(deliveryCurrentPage - 1) * deliveryEntriesToShow + index + 1}
                </th>
                          <td>{item.product_name}</td>
                          <td>{item.quantity_delivered}</td>
                <td>{item.delivery_date ? item.delivery_date.split(' ')[0] : ''}</td>
                          <td>{item.vendor_name}</td>
                <td>{item.delivered_to}</td>
                          <td>{item.p_name}</td>
                          <td>{item.material_tracking_number}</td>
                <td>{item.delivery_cost}</td>
                          <td>
                            <i
                              className="fa fa-trash"
                    id={`delete-material-delivery-${item.delivery_id}`}
                    style={{ fontSize: "23px", color: "red", cursor: "pointer" }}
                              onClick={() => handleDeliveryDeleteIconClick(item.delivery_id)}
                            ></i>
                  <UncontrolledTooltip placement="top" target={`delete-material-delivery-${item.delivery_id}`}>
                    Delete Material Delivery
                  </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

        {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((deliveryCurrentPage - 1) * deliveryEntriesToShow) + 1} to {Math.min(deliveryCurrentPage * deliveryEntriesToShow, safeFilteredMaterialDeliveryData.length)} of {safeFilteredMaterialDeliveryData.length} entries
                    </div>
                  </div>

        {/* Pagination */}
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={deliveryPrevPage}
                          disabled={deliveryCurrentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={deliveryNextPage}
                          disabled={deliveryCurrentPage === deliveryTotalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>

          
          {/* Vendor Material Return */}
          <Row className="mt-4">
            <Col xl="12">

    {/* Card and Table Section */}
    <Card className="shadow" style={{ boxShadow: "0 0 20px rgba(216, 111, 137, 0.3)" }}>
      <CardBody style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)" }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Vendor Material Return</h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>
                          {/* Project Filter */}
                          <Dropdown isOpen={returnProjectDropdownOpen} toggle={toggleReturnProjectDropdown}>
                            <DropdownToggle caret color="secondary">
                              {selectedReturnProject
                                ? (projects.find((p) => String(p.p_id) === String(selectedReturnProject))?.p_name || "Select Project")
                                : "Select Project"}
                            </DropdownToggle>
                            <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                              {/* Search Bar Inside Dropdown */}
                              <div className="mb-2">
                                <Input
                                  type="text"
                                  placeholder="Search projects..."
                                  value={returnProjectSearch || ''}
                                  onChange={(e) => setReturnProjectSearch(e.target.value)}
                                  style={{ fontSize: '13px', height: '32px' }}
                                />
                              </div>
                              <DropdownItem onClick={() => handleReturnFilterChange("", selectedReturnVendor)} style={{ padding: '6px 12px', fontSize: '13px' }}>
                                All Projects
                              </DropdownItem>
                              {projects
                                .filter(project => 
                                  !returnProjectSearch || 
                                  project.p_name.toLowerCase().includes(returnProjectSearch.toLowerCase())
                                )
                                .map((project) => (
                                  <DropdownItem 
                                    key={project.p_id} 
                                    onClick={() => handleReturnFilterChange(project.p_id, selectedReturnVendor)}
                                    style={{ padding: '6px 12px', fontSize: '13px' }}
                                  >
                                    {project.p_name}
                                  </DropdownItem>
                                ))}
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Vendor Filter */}
                          <Dropdown isOpen={returnVendorDropdownOpen} toggle={toggleReturnVendorDropdown}>
                            <DropdownToggle caret color="secondary">
                              {selectedReturnVendor
                                ? (vendors.find((v) => String(v.vendor_id) === String(selectedReturnVendor))?.vendor_name || "Select Vendor")
                                : "Select Vendor"}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleReturnFilterChange(selectedReturnProject, "")}>All Vendors</DropdownItem>
                              {vendors.map((vendor) => (
                                <DropdownItem key={vendor.vendor_id} onClick={() => handleReturnFilterChange(selectedReturnProject, vendor.vendor_id)}>
                                  {vendor.vendor_name}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Show Entries */}
                          <Dropdown isOpen={returnShowEntriesDropdownOpen} toggle={() => setReturnShowEntriesDropdownOpen(!returnShowEntriesDropdownOpen)}>
                            <DropdownToggle caret>
                              Show Entries: {returnEntriesToShow === safeFilteredVendorReturnData.length ? "All" : returnEntriesToShow}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleReturnEntriesChange(5)}>5</DropdownItem>
                              <DropdownItem onClick={() => handleReturnEntriesChange(10)}>10</DropdownItem>
                              <DropdownItem onClick={() => handleReturnEntriesChange(50)}>50</DropdownItem>
                              <DropdownItem onClick={() => handleReturnEntriesChange("All")}>All</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                          
                          {/* Download */}
                          <Button
                            className="btn btn-success"
                            onClick={handleDownloadReturn}
                            style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                          >
                            Download
                          </Button>
                          
                          {/* Add Return Materials */}
                          <Dropdown isOpen={returnMaterialDropdownOpen} toggle={toggleReturnMaterialDropdown}>
                            <DropdownToggle
                              style={{
                                backgroundColor: "#d86f89",
                                borderColor: "#d86f89",
                                color: "black",
                                fontWeight: 600,
                                borderRadius: '0.375rem',
                                boxShadow: 'none',
                                padding: '0.5rem 1.25rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5em'
                              }}
                              caret
                            >
                              Add Return Materials
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleReturnMaterialOption('single')}>
                                Add Single Return Material
                              </DropdownItem>
                              <DropdownItem onClick={() => handleReturnMaterialOption('multiple')}>
                                Add Multiple Return Materials
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  {/* Filters Section for Vendor Material Return */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="3">
                        <Label className="form-control-label">Product Name Filter:</Label>
                        <Dropdown isOpen={returnProductFilterDropdownOpen} toggle={toggleReturnProductFilterDropdown}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedReturnProduct || "Select Product"}
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search products..."
                                value={returnProductSearch || ''}
                                onChange={(e) => setReturnProductSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem onClick={() => handleReturnProductFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                              All Products
                            </DropdownItem>
                            {getUniqueReturnProducts()
                              .filter(product => 
                                !returnProductSearch || 
                                product.toLowerCase().includes(returnProductSearch.toLowerCase())
                              )
                              .map((product) => (
                                <DropdownItem 
                                  key={product} 
                                  onClick={() => handleReturnProductFilter(product)}
                                  style={{ padding: '6px 12px', fontSize: '13px' }}
                                >
                                  {product}
                                </DropdownItem>
                              ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">Start Date:</Label>
                        <Input
                          type="date"
                          value={returnStartDate}
                          onChange={(e) => handleReturnDateFilter(e.target.value, returnEndDate)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">End Date:</Label>
                        <Input
                          type="date"
                          value={returnEndDate}
                          onChange={(e) => handleReturnDateFilter(returnStartDate, e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="2">
                        <Label className="form-control-label">Total Items Returned:</Label>
                        <div className="form-control" style={{ 
                          backgroundColor: '#e9ecef', 
                          border: '1px solid #ced4da',
                          padding: '0.375rem 0.75rem',
                          borderRadius: '0.375rem',
                          fontWeight: 'bold',
                          color: '#495057'
                        }}>
                          {totalItemsReturned}
                        </div>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label">Total Yet to Return:</Label>
                        <div className="form-control" style={{ 
                          backgroundColor: '#e9ecef', 
                          border: '1px solid #ced4da',
                          padding: '0.375rem 0.75rem',
                          borderRadius: '0.375rem',
                          fontWeight: 'bold',
                          color: '#495057'
                        }}>
                          {totalYetToReturn}
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
              <th>Item Id</th>
              <th>Product Name</th>
              <th>Returned Quantity</th>
              <th>Yet To Return</th>
              <th>Return Date</th>
              <th>Vendor Name</th>
              <th>Project Name</th>
              <th>Material Tracking Number</th>
              <th>Returned By</th>
              <th>Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {safeReturnPaginatedData.map((item, index) => (
                        <tr key={item.return_id || index}>
                          <th scope="row">{(returnCurrentPage - 1) * returnEntriesToShow + index + 1}</th>
                          <td>{item.product_name}</td>
                          <td>{item.returned_quantity}</td>
                          <td>{item.yet_to_return}</td>
                          <td>{item.return_date}</td>
                          <td>{item.vendor_name}</td>
                          <td>{item.p_name}</td>
                          <td>{item.material_tracking_number}</td>
                <td>{item.returned_by}</td>
                          <td>
                            <i
                              className="fa fa-trash"
                    id={`delete-return-material-${item.return_id}`}
                    style={{ fontSize: "23px", color: "red", cursor: "pointer" }}
                              onClick={() => handleReturnDeleteIconClick(item.return_id)}
                  />
                  <UncontrolledTooltip placement="top" target={`delete-return-material-${item.return_id}`}>
                    Delete Return Material
                  </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

        {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((returnCurrentPage - 1) * returnEntriesToShow) + 1} to {Math.min(returnCurrentPage * returnEntriesToShow, safeFilteredVendorReturnData.length)} of {safeFilteredVendorReturnData.length} entries
                    </div>
                  </div>

        {/* Pagination */}
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
              <a href="#" className="page-link text-primary" onClick={returnPrevPage} disabled={returnCurrentPage === 1}>
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
              <a href="#" className="page-link text-primary" onClick={returnNextPage} disabled={returnCurrentPage === returnTotalPages}>
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          

          

          
          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>Are you sure you want to delete this vendor's material ?</ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteConfirmation}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>
          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
                <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Stock
                </h2>
            </ModalHeader>
            <ModalBody>

                <Form onSubmit={handleFormSubmit}>
                <Row className="mb-4">
                    <Col md={6}>
                    <label className="form-control-label" htmlFor="vendor_name">
                        Select Vendor Name
                    </label>
                    <select
                        name="vendor_name"
                        className="form-select form-control-alternative custom-select"
                        id="vendor_name"
                        value={addstock.vendor_name}
                        onChange={handleInputChange}
                        required
                        style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                        }}
                    >
                        <option value="" disabled>
                        Select Vendor
                        </option>
                        {vendors.map((item) => (
                        <option
                            key={item.vendor_id}
                            value={item.vendor_name}
                            style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                            }}
                        >
                            {item.vendor_name}
                        </option>
                        ))}
                    </select>
                    {fieldErrors.vendor_name && (
                      <div className="mt-1" style={{ 
                        fontSize: '0.875rem', 
                        color: '#dc3545',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                        {fieldErrors.vendor_name}
                      </div>
                    )}
                    </Col>
                    <Col md={6}>
                    <label className="form-control-label" htmlFor="product_name">
                        Enter Product Name
                    </label>
                    <Input
                        name="product_name"
                        className="form-control-alternative"
                        id="product_name"
                        type="text"
                        value={addstock.product_name}
                        onChange={handleInputChange}
                        placeholder="Enter Product Name"
                        required
                    />
                    {fieldErrors.product_name && (
                      <div className="mt-1" style={{ 
                        fontSize: '0.875rem', 
                        color: '#dc3545',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                        {fieldErrors.product_name}
                      </div>
                    )}
                    </Col>

                </Row>
                <Row className="mb-4">
                    <Col md={6}>
                    <label className="form-control-label" htmlFor="total_stock">
                        Enter Total Stock
                    </label>
                    <Input
                        className="form-control-alternative"
                        id="total_stock"
                        type="number"
                        name="total_stock"
                        value={addstock.total_stock}
                        onChange={handleInputChange}
                        placeholder="Enter Total Stock"
                        min="0"
                        step="1"
                        required
                    />
                    {fieldErrors.total_stock && (
                      <div className="mt-1" style={{ 
                        fontSize: '0.875rem', 
                        color: '#dc3545',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                        {fieldErrors.total_stock}
                      </div>
                    )}
                    </Col>
                    <Col md={6}>
                    <label className="form-control-label" htmlFor="available_stock">
                        Enter Current Stock
                    </label>
                    <Input
                        className="form-control-alternative"
                        id="available_stock"
                        type="number"
                        name="available_stock"
                        value={addstock.available_stock}
                        onChange={handleInputChange}
                        placeholder="Enter Current Stock"
                        min="0"
                        step="1"
                        required
                    />
                    {fieldErrors.available_stock && (
                      <div className="mt-1" style={{ 
                        fontSize: '0.875rem', 
                        color: '#dc3545',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                        {fieldErrors.available_stock}
                      </div>
                    )}
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col md={6}>
                    <label className="form-control-label" htmlFor="cost">
                        Enter Cost / Unit
                    </label>
                    <Input
                        className="form-control-alternative"
                        id="cost"
                        type="number"
                        name="cost"
                        value={addstock.cost}
                        onChange={handleInputChange}
                        placeholder="Enter Cost/Unit"
                        min="0"
                        step="0.01"
                        required
                    />
                    {fieldErrors.cost && (
                      <div className="mt-1" style={{ 
                        fontSize: '0.875rem', 
                        color: '#dc3545',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                        {fieldErrors.cost}
                      </div>
                    )}
                    </Col>
                    <Col md={6}>
                      <label className="form-control-label" htmlFor="delivery_date">
                        Select Delivery Date
                      </label>
                      <Input
                        className="form-control-alternative"
                        id="delivery_date"
                        type="date"
                        name="delivery_date"
                        value={addstock.delivery_date}
                        onChange={handleInputChange}
                        required
                      />
                      {fieldErrors.delivery_date && (
                        <div className="mt-1" style={{ 
                          fontSize: '0.875rem', 
                          color: '#dc3545',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
                          {fieldErrors.delivery_date}
                        </div>
                      )}
                    </Col>
                </Row>
                <Row>
                    <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      type="submit"
                      style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', borderRadius: '25px', padding: '10px 25px' }}>
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showRoleModal3} toggle={toggleRole3}>
            <ModalHeader toggle={toggleRole3}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Add Vendor
              </h2>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={handleVendorSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="vendor_name">
                      Enter Vendor Name
                    </label>
                    <Input
                      name="vendor_name"
                      className="form-control-alternative"
                      id="vendor_name"
                      type="text"
                      value={vendorData.vendor_name}
                      onChange={handleVendorInputChange}
                      placeholder="Enter Vendor Name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="vendor_address"
                    >
                      Enter Address
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="vendor_address"
                      type="text"
                      name="vendor_address"
                      value={vendorData.vendor_address}
                      onChange={handleVendorInputChange}
                      placeholder="Enter Address"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="vendor_number"
                    >
                      Enter Contact Number
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="vendor_number"
                      type="text"
                      name="vendor_number"
                      value={vendorData.vendor_number}
                      onChange={handleVendorInputChange}
                      placeholder="Enter Contact Number"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="vendor_email"
                    >
                      Enter Email
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="vendor_email"
                      type="email"
                      name="vendor_email"
                      value={vendorData.vendor_email}
                      onChange={handleVendorInputChange}
                      placeholder="Enter Email"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label
                      className="form-control-label"
                      htmlFor="vendor_website"
                    >
                      Enter Vendor's Website
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="vendor_website"
                      type="text"
                      name="vendor_website"
                      value={vendorData.vendor_website}
                      onChange={handleVendorInputChange}
                      placeholder="Enter Vendor's Website"
                    />
                    <h5
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        marginTop: "10px",
                        textAlign: "start",
                      }}
                    >
                      It's Optional
                    </h5>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={modalImport} toggle={toggleModalImport}>
  <ModalHeader toggle={toggleModalImport}>
    Import Multiple Stocks
  </ModalHeader>
  <ModalBody>
    {uploadMessage.text && (
      <Alert color={uploadMessage.type}>{uploadMessage.text}</Alert>
    )}
    
          <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
        <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
        <ul className="mb-0">
          <li>Upload an Excel or CSV file with columns: <strong>Product Name, Available Stock, Total Stock, Cost</strong></li>
          <li>First row should contain headers exactly as shown above</li>
          <li>Stock quantities and cost must be positive numbers</li>
          <li>Available stock cannot exceed total stock</li>
          <li>If product name already exists, stock will be added to existing product</li>
          <li><strong>Delivery date is required</strong> and will be recorded for all imported products</li>
          <li>Supported formats: .xlsx, .xls, .csv</li>
        </ul>
      </div>

    <Form onSubmit={handleImportSubmit}>
      <FormGroup>
        <Col md={12} className="mb-4">
          <label className="form-control-label" htmlFor="vendor_select">
            Select Vendor
          </label>
          <select
            name="vendor_id"
            className="form-select form-control-alternative custom-select"
            id="vendor_select"
            value={selectedVendor}
            onChange={(e) => {
              setSelectedVendor(e.target.value);
              // Clear upload message when vendor changes
              if (uploadMessage.text) {
                setUploadMessage({ type: "", text: "" });
              }
            }}
            required
            style={{
              padding: "0.75rem 1rem",
              fontSize: "0.875rem",
              fontWeight: "400",
              lineHeight: "1.5",
              color: "#495057",
              backgroundColor: "#fff",
              backgroundClip: "padding-box",
              border: "1px solid #ced4da",
              borderRadius: "0.375rem",
              transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
              height: "calc(2.75rem + 2px)",
              width: "100%",
            }}
          >
            <option value="">Select Vendor</option>
            {vendors.map((vendor) => (
              <option key={vendor.vendor_id} value={vendor.vendor_id}>
                {vendor.vendor_name}
              </option>
            ))}
          </select>
          {selectedVendor && (
            <div className="mt-2">
              <small>Selected Vendor: {vendors.find(v => v.vendor_id === selectedVendor)?.vendor_name}</small>
            </div>
          )}
        </Col>


        
        <Col md={12} className="mb-4">
          <label className="form-control-label" htmlFor="delivery_date">
            Select Delivery Date
          </label>
          <Input
            type="date"
            name="delivery_date"
            id="delivery_date"
            value={selectedDeliveryDateForImport || ''}
            onChange={(e) => setSelectedDeliveryDateForImport(e.target.value)}
            required
            style={{
              padding: "0.75rem 1rem",
              fontSize: "0.875rem",
              fontWeight: "400",
              lineHeight: "1.5",
              color: "#495057",
              backgroundColor: "#fff",
              backgroundClip: "padding-box",
              border: "1px solid #ced4da",
              borderRadius: "0.375rem",
              transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
              height: "calc(2.75rem + 2px)",
              width: "100%",
            }}
          />
          {!selectedDeliveryDateForImport && (
            <div className="mt-1" style={{ 
              fontSize: '0.875rem', 
              color: '#dc3545',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <i className="fas fa-exclamation-triangle" style={{ color: '#fd7e14' }}></i>
              Delivery date is required
            </div>
          )}
        </Col>
        
        <Col md={12}>
          <Label for="importFile">
            Upload File (.csv, .xls, .xlsx)
          </Label>
          <Input
            type="file"
            name="excel_file"
            id="importFile"
            accept=".csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
            onChange={handleImportFileUpload}
            disabled={isUploading}
            required
          />
          {importedFileDetails && !isUploading && (
            <div className="mt-2">
              <small>
                File: {importedFileDetails.fileName} | Selected at:{" "}
                {importedFileDetails.uploadTime}
              </small>
            </div>
          )}
        </Col>
      </FormGroup>
      <div className="text-center mt-4">
        <Button
          color="primary"
          type="submit"
          disabled={isUploading || !selectedFile || !selectedVendor || !selectedDeliveryDateForImport}
        >
          {isUploading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Importing...
            </>
          ) : (
            "Import"
          )}
        </Button>
      </div>
    </Form>
  </ModalBody>
</Modal>

<Modal isOpen={showMaterialDeliveryModal} toggle={toggleMaterialDeliveryModal}>
  <ModalHeader toggle={toggleMaterialDeliveryModal}>
    <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
      Material Delivery
    </h2>
  </ModalHeader>
  <ModalBody>
    <div className="alert alert-info mb-3" style={{ backgroundColor: '#e7f3ff', borderColor: '#b3d9ff', color: '#004085' }}>
      <i className="fas fa-info-circle me-2"></i>
      <strong>Tip:</strong> First select a product, then choose the vendor that has that product. The system will show only relevant vendors for your selected product.
    </div>
    <Form onSubmit={handleMaterialDeliverySubmit}>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="vendor_product_id">
            Enter Product Name
          </label>
          <Dropdown isOpen={materialDeliveryModalProductDropdownOpen} toggle={() => setMaterialDeliveryModalProductDropdownOpen(!materialDeliveryModalProductDropdownOpen)}>
            <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
              {materialDeliveryForm.vendor_product_id ? (
                <span style={{ color: '#495057' }}>
                  {originalData.find(item => item.vendor_product_id === materialDeliveryForm.vendor_product_id)?.product_name}
                </span>
              ) : (
                <span style={{ color: '#6c757d' }}>Select Product</span>
              )}
            </DropdownToggle>
            <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
              {/* Search Bar Inside Dropdown */}
              <div className="mb-2">
                <Input
                  type="text"
                  placeholder="Search products..."
                  value={materialDeliveryModalProductSearch || ''}
                  onChange={(e) => setMaterialDeliveryModalProductSearch(e.target.value)}
                  style={{ fontSize: '13px', height: '32px' }}
                />
              </div>
              <DropdownItem onClick={() => {
                setMaterialDeliveryForm(prev => ({ ...prev, vendor_product_id: "" }));
                setMaterialDeliveryModalProductDropdownOpen(false);
              }}>
                All Products
              </DropdownItem>
              {(() => {
                // Get unique product names first
                const uniqueProducts = [];
                const seenProducts = new Set();
                
                originalData.forEach(item => {
                  if (!seenProducts.has(item.product_name)) {
                    seenProducts.add(item.product_name);
                    uniqueProducts.push({
                      product_name: item.product_name,
                      vendors: originalData.filter(p => p.product_name === item.product_name)
                    });
                  }
                });
                
                // Filter by search term
                const filteredUniqueProducts = uniqueProducts.filter(product => {
                  return !materialDeliveryModalProductSearch || 
                    product.product_name.toLowerCase().includes(materialDeliveryModalProductSearch.toLowerCase());
                });
                
                if (filteredUniqueProducts.length === 0) {
                  return (
                    <DropdownItem disabled style={{ color: '#6c757d', fontStyle: 'italic' }}>
                      No products found matching "{materialDeliveryModalProductSearch}"
                    </DropdownItem>
                  );
                }
                
                return filteredUniqueProducts.map((product) => (
                  <DropdownItem 
                    key={product.product_name} 
                    onClick={() => {
                      // Don't set vendor_product_id yet, just store the product name
                      setMaterialDeliveryForm(prev => ({ 
                        ...prev, 
                        selectedProductName: product.product_name,
                        vendor_product_id: "" // Clear this to force vendor selection
                      }));
                      setMaterialDeliveryModalProductDropdownOpen(false);
                    }}
                    style={{ padding: '6px 12px', fontSize: '13px' }}
                  >
                    {product.product_name} ({product.vendors.length} vendor{product.vendors.length > 1 ? 's' : ''})
                  </DropdownItem>
                ));
              })()}
            </DropdownMenu>
          </Dropdown>
          {materialDeliveryForm.selectedProductName && (
            <div className="mt-2">
              <small className="text-muted">
                Selected Product: {materialDeliveryForm.selectedProductName}
                {materialDeliveryForm.vendor_id && (
                  <span> | Vendor: {vendors.find(v => v.vendor_id === materialDeliveryForm.vendor_id)?.vendor_name}</span>
                )}
              </small>
            </div>
          )}
        </Col>
        <Col md={6}>
          <label className="form-control-label" htmlFor="quantity_delivered">
            Enter Quantity Delivered
          </label>
          <Input
            className="form-control-alternative"
            id="quantity_delivered"
            type="number"
            name="quantity_delivered"
            value={materialDeliveryForm.quantity_delivered}
            onChange={handleMaterialDeliveryInputChange}
            placeholder="Enter Quantity Delivered"
            required
            max={selectedProductStock}
            disabled={!materialDeliveryForm.vendor_product_id || !materialDeliveryForm.vendor_id}
          />
          {materialDeliveryForm.vendor_product_id && materialDeliveryForm.vendor_id && (
            <small className="text-muted">
              Available Stock: {selectedProductStock}
            </small>
          )}
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="delivery_date">
            Enter Delivery Date
          </label>
          <Input
            className="form-control-alternative"
            id="delivery_date"
            type="date"
            name="delivery_date"
            value={materialDeliveryForm.delivery_date}
            onChange={handleMaterialDeliveryInputChange}
            required
          />
        </Col>
        <Col md={6}>
          <label className="form-control-label" htmlFor="vendor_id">
            Select Vendor
          </label>
          <select
            name="vendor_id"
            className="form-select form-control-alternative custom-select"
            id="vendor_id"
            value={materialDeliveryForm.vendor_id}
            onChange={handleMaterialDeliveryInputChange}
            required
            disabled={!materialDeliveryForm.selectedProductName}
          >
            <option value="">
              {materialDeliveryForm.selectedProductName ? "Select Vendor" : "Select Product First"}
            </option>
            {(() => {
              if (!materialDeliveryForm.selectedProductName) {
                return <option disabled>Please select a product first</option>;
              }
              
              // Get vendors that have the selected product
              const vendorsForProduct = originalData
                .filter(item => item.product_name === materialDeliveryForm.selectedProductName)
                .map(item => ({
                  vendor_id: item.vendor_id,
                  vendor_name: vendors.find(v => v.vendor_id === item.vendor_id)?.vendor_name || 'Unknown Vendor'
                }))
                .filter((vendor, index, self) => 
                  index === self.findIndex(v => v.vendor_id === vendor.vendor_id)
                );
              
              if (vendorsForProduct.length === 0) {
                return <option disabled>No vendors available for this product</option>;
              }
              
              return vendorsForProduct.map((vendor) => (
                <option key={vendor.vendor_id} value={vendor.vendor_id}>
                {vendor.vendor_name}
              </option>
              ));
            })()}
          </select>
          {materialDeliveryForm.vendor_id && (
            <div className="mt-2">
              <small className="text-muted">
                Selected Vendor: {vendors.find(v => v.vendor_id === materialDeliveryForm.vendor_id)?.vendor_name}
                {materialDeliveryForm.vendor_product_id && (
                  <span> | Product: {originalData.find(item => item.vendor_product_id === materialDeliveryForm.vendor_product_id)?.product_name}</span>
                )}
              </small>
            </div>
          )}

        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="p_id">
            Select Project
          </label>
          <Dropdown isOpen={materialDeliveryModalProjectDropdownOpen} toggle={() => setMaterialDeliveryModalProjectDropdownOpen(!materialDeliveryModalProjectDropdownOpen)}>
            <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
              {materialDeliveryForm.p_id ? projects.find(p => p.p_id === materialDeliveryForm.p_id)?.p_name : "Select Project"}
            </DropdownToggle>
            <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
              {/* Search Bar Inside Dropdown */}
              <div className="mb-2">
                <Input
                  type="text"
                  placeholder="Search projects..."
                  value={materialDeliveryModalProjectSearch || ''}
                  onChange={(e) => setMaterialDeliveryModalProjectSearch(e.target.value)}
                  style={{ fontSize: '13px', height: '32px' }}
                />
              </div>
              <DropdownItem onClick={() => {
                setMaterialDeliveryForm(prev => ({ ...prev, p_id: "" }));
                setMaterialDeliveryModalProjectDropdownOpen(false);
              }}>
                All Projects
              </DropdownItem>
              {projects
                .filter(project => 
                  !materialDeliveryModalProjectSearch || 
                  project.p_name.toLowerCase().includes(materialDeliveryModalProjectSearch.toLowerCase())
                )
                .map((project) => (
                  <DropdownItem 
                    key={project.p_id} 
                    onClick={() => {
                      setMaterialDeliveryForm(prev => ({ ...prev, p_id: project.p_id }));
                      setMaterialDeliveryModalProjectDropdownOpen(false);
                    }}
                    style={{ padding: '6px 12px', fontSize: '13px' }}
                  >
                    {project.p_name}
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col md={6}>
          <label className="form-control-label" htmlFor="material_tracking_number">
            Material Tracking ID
          </label>
          <Input
            name="material_tracking_number"
            className="form-control-alternative"
            id="material_tracking_number"
            type="text"
            value={materialDeliveryForm.material_tracking_number}
            onChange={handleMaterialDeliveryInputChange}
            placeholder="Enter 6 digit material tracking ID"
            required
          />
        </Col>
      </Row>
                {/* New Row for Delivered To and Cost */}
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="delivered_to">
                      Delivered To
                    </label>
                    <Input
                      name="delivered_to"
                      className="form-control-alternative"
                      id="delivered_to"
                      type="text"
                      value={materialDeliveryForm.delivered_to}
                      onChange={handleMaterialDeliveryInputChange}
                      placeholder="Enter Delivered To"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="cost">
                      Cost
                    </label>
                    <Input
                      name="cost"
                      className="form-control-alternative"
                      id="cost"
                      type="number"
                      value={materialDeliveryForm.cost}
                      onChange={handleMaterialDeliveryInputChange}
                      placeholder="Enter Cost"
                      required
                      min={0}
                      step="any"
                    />
                  </Col>
                </Row>
      <Row>
        <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      type="submit"
                      style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', borderRadius: '25px', padding: '10px 25px' }}
                    >
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  </ModalBody>
</Modal>

<Modal isOpen={showVendorReturnModal} toggle={toggleVendorReturnModal}>
  <ModalHeader toggle={toggleVendorReturnModal}>
    <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
      Add Return Materials
    </h2>
  </ModalHeader>
  <ModalBody>
    <div className="alert alert-info mb-3" style={{ backgroundColor: '#e7f3ff', borderColor: '#b3d9ff', color: '#004085' }}>
      <i className="fas fa-info-circle me-2"></i>
      <strong>Tip:</strong> First select a project, then choose a product that was delivered to that project. The vendor count shows how many different vendors delivered that product to the selected project. Select a vendor to see their tracking numbers.
    </div>
    <Form onSubmit={handleVendorReturnSubmit}>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="p_id">
            Select Project
          </label>
          <Dropdown isOpen={vendorReturnModalProjectDropdownOpen} toggle={toggleVendorReturnModalProjectDropdown}>
            <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
              {vendorReturnForm.p_id ? projects.find(p => p.p_id === vendorReturnForm.p_id)?.p_name : "Select Project"}
            </DropdownToggle>
            <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
              {/* Search Bar */}
              <div className="mb-2">
                <Input
                  type="text"
                  placeholder="Search projects..."
                  value={vendorReturnModalProjectSearch || ''}
                  onChange={(e) => setVendorReturnModalProjectSearch(e.target.value)}
                  style={{ fontSize: '13px', height: '32px' }}
                />
              </div>
              <DropdownItem onClick={() => handleVendorReturnInputChange({ target: { name: 'p_id', value: '' } })} style={{ padding: '6px 12px', fontSize: '13px' }}>
                All Projects
              </DropdownItem>
              {projects
                .filter(project => 
                  !vendorReturnModalProjectSearch || 
                  project.p_name.toLowerCase().includes(vendorReturnModalProjectSearch.toLowerCase())
                )
                .map((project) => (
                  <DropdownItem 
                    key={project.p_id} 
                    onClick={() => {
                      handleVendorReturnInputChange({ target: { name: 'p_id', value: project.p_id } });
                      setVendorReturnModalProjectSearch("");
                    }}
                    style={{ padding: '6px 12px', fontSize: '13px' }}
                  >
                    {project.p_name}
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col md={6}>
          <label className="form-control-label" htmlFor="vendor_product_id">
            Enter Product Name
          </label>
          {!vendorReturnForm.p_id && (
            <div className="mt-1">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                Please select a project first to see available products
              </small>
            </div>
          )}
          <Dropdown isOpen={vendorReturnModalProductDropdownOpen} toggle={() => setVendorReturnModalProductDropdownOpen(!vendorReturnModalProductDropdownOpen)}>
            <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
              {vendorReturnForm.selectedProductName ? (
                <span style={{ color: '#495057' }}>
                  {vendorReturnForm.selectedProductName}
                </span>
              ) : (
                <span style={{ color: '#6c757d' }}>Select Product</span>
              )}
            </DropdownToggle>
            <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
              {/* Search Bar Inside Dropdown */}
              <div className="mb-2">
                <Input
                  type="text"
                  placeholder="Search products..."
                  value={vendorReturnModalProductSearch || ''}
                  onChange={(e) => setVendorReturnModalProductSearch(e.target.value)}
                  style={{ fontSize: '13px', height: '32px' }}
                />
              </div>
              <DropdownItem onClick={() => {
                setVendorReturnForm(prev => ({ 
                  ...prev, 
                  selectedProductName: "",
                  vendor_product_id: "",
                  vendor_id: "",
                  material_tracking_number: ""
                }));
                setVendorReturnModalProductDropdownOpen(false);
              }}>
                All Products
              </DropdownItem>
              {(() => {
                // Get unique product names from deliveryStockData filtered by selected project
                const uniqueProducts = [];
                const seenProducts = new Set();
                
                // Only show products that were delivered to the selected project
                const projectDeliveries = vendorReturnForm.p_id 
                  ? deliveryStockData.filter(item => String(item.p_id) === String(vendorReturnForm.p_id))
                  : [];
                
                projectDeliveries.forEach(item => {
                  if (!seenProducts.has(item.product_name)) {
                    seenProducts.add(item.product_name);
                    // Count vendors for this product within this project only
                    const vendorsForProductInProject = projectDeliveries.filter(p => 
                      p.product_name === item.product_name
                    );
                    uniqueProducts.push({
                      product_name: item.product_name,
                      vendors: vendorsForProductInProject
                    });
                  }
                });
                
                // Debug logging for product dropdown
                console.log('Selected Project ID:', vendorReturnForm.p_id);
                console.log('Project Deliveries:', projectDeliveries);
                console.log('Unique Products for Project:', uniqueProducts);
                
                // Show what products are available for returns in this project
                if (uniqueProducts.length === 0) {
                  if (!vendorReturnForm.p_id) {
                    console.log('No project selected yet');
                  } else {
                    console.log('No products found in delivery data for this project');
                  }
                } else {
                  console.log('Available products for returns in this project:', uniqueProducts.map(p => `${p.product_name} (${p.vendors.length} vendor${p.vendors.length > 1 ? 's' : ''})`));
                }
                
                // Filter by search term
                const filteredUniqueProducts = uniqueProducts.filter(product => {
                  return !vendorReturnModalProductSearch || 
                    product.product_name.toLowerCase().includes(vendorReturnModalProductSearch.toLowerCase());
                });
                
                if (filteredUniqueProducts.length === 0) {
                  if (!vendorReturnForm.p_id) {
                    return (
                      <DropdownItem disabled style={{ color: '#6c757d', fontStyle: 'italic' }}>
                        Please select a project first
                      </DropdownItem>
                    );
                  } else {
                    return (
                      <DropdownItem disabled style={{ color: '#6c757d', fontStyle: 'italic' }}>
                        No products found matching "{vendorReturnModalProductSearch}"
                      </DropdownItem>
                    );
                  }
                }
                
                return filteredUniqueProducts.map((product) => (
                  <DropdownItem 
                    key={product.product_name} 
                    onClick={() => {
                      // Don't set vendor_product_id yet, just store the product name
                      setVendorReturnForm(prev => ({ 
                        ...prev, 
                        selectedProductName: product.product_name,
                        vendor_product_id: "", // Clear this to force vendor selection
                        vendor_id: "", // Clear vendor selection
                        material_tracking_number: "" // Clear tracking number
                      }));
                      setVendorReturnModalProductDropdownOpen(false);
                    }}
                    style={{ padding: '6px 12px', fontSize: '13px' }}
                  >
                    {product.product_name} ({product.vendors.length} vendor{product.vendors.length > 1 ? 's' : ''})
                  </DropdownItem>
                ));
              })()}
            </DropdownMenu>
          </Dropdown>
          {vendorReturnForm.selectedProductName && (
            <div className="mt-2">
              <small className="text-muted">
                Selected Product: {vendorReturnForm.selectedProductName}
                {vendorReturnForm.vendor_id && (
                  <span> | Vendor: {vendors.find(v => v.vendor_id === vendorReturnForm.vendor_id)?.vendor_name}</span>
                )}
              </small>
            </div>
          )}
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="vendor_id">
            Select Vendor
          </label>
          <select
            name="vendor_id"
            value={vendorReturnForm.vendor_id}
            className="form-select form-control-alternative custom-select"
            id="vendor_id"
            onChange={handleVendorReturnInputChange}
            required
            disabled={!vendorReturnForm.selectedProductName}
          >
            <option value="">
              {vendorReturnForm.selectedProductName ? "Select Vendor" : "Select Product First"}
              </option>
            {(() => {
              if (!vendorReturnForm.selectedProductName) {
                return <option disabled>Please select a product first</option>;
              }
              
              // Get vendors that have delivered the selected product to the selected project
              const vendorsForProduct = deliveryStockData
                .filter(item => 
                  item.product_name === vendorReturnForm.selectedProductName &&
                  String(item.p_id) === String(vendorReturnForm.p_id)
                )
                .map(item => ({
                  vendor_id: item.vendor_id,
                  vendor_name: vendors.find(v => v.vendor_id === item.vendor_id)?.vendor_name || 'Unknown Vendor'
                }))
                .filter((vendor, index, self) => 
                  index === self.findIndex(v => v.vendor_id === vendor.vendor_id)
                );
              
              // Debug logging
              console.log('Selected Product:', vendorReturnForm.selectedProductName);
              console.log('Selected Project ID:', vendorReturnForm.p_id);
              console.log('Delivery Data for Product+Project:', deliveryStockData.filter(item => 
                item.product_name === vendorReturnForm.selectedProductName &&
                String(item.p_id) === String(vendorReturnForm.p_id)
              ));
              console.log('Vendors for Product+Project:', vendorsForProduct);
              
              // Show detailed vendor information
              if (vendorsForProduct.length === 0) {
                console.log('No vendors found for this product in this project');
              } else {
                console.log('Available vendors for returns in this project:', vendorsForProduct.map(v => `${v.vendor_name} (ID: ${v.vendor_id})`));
              }
              
              if (vendorsForProduct.length === 0) {
                return <option disabled>No vendors available for this product</option>;
              }
              
              return vendorsForProduct.map((vendor) => (
                <option key={vendor.vendor_id} value={vendor.vendor_id}>
                {vendor.vendor_name}
              </option>
              ));
            })()}
          </select>
          {vendorReturnForm.vendor_id && (
            <div className="mt-2">
              <small className="text-muted">
                Selected Vendor: {vendors.find(v => v.vendor_id === vendorReturnForm.vendor_id)?.vendor_name}
                {vendorReturnForm.vendor_product_id && (
                  <span> | Product: {deliveryStockData.find(item => item.vendor_product_id === vendorReturnForm.vendor_product_id)?.product_name}</span>
                )}
              </small>
            </div>
          )}
        </Col>
        <Col md={6}>
          <label className="form-control-label" htmlFor="material_tracking_number">
            Material Tracking Number
          </label>
          <select
            name="material_tracking_number"
            value={vendorReturnForm.material_tracking_number}
            className="form-select form-control-alternative custom-select"
            id="material_tracking_number"
            onChange={handleVendorReturnInputChange}
            required
            disabled={!vendorReturnForm.vendor_id || !vendorReturnForm.selectedProductName}
          >
            <option value="">
              {vendorReturnForm.vendor_id && vendorReturnForm.selectedProductName ? "Select Tracking Number" : "Select Vendor and Product First"}
              </option>
            {(() => {
              if (!vendorReturnForm.vendor_id || !vendorReturnForm.selectedProductName) {
                return <option disabled>Please select vendor and product first</option>;
              }
              
              // Get tracking numbers for the selected vendor, product, and project from delivery records
              const trackingNumbers = deliveryStockData
                .filter(item => 
                  String(item.vendor_id) === String(vendorReturnForm.vendor_id) && 
                  item.product_name === vendorReturnForm.selectedProductName &&
                  String(item.p_id) === String(vendorReturnForm.p_id)
                )
                .map(item => item.material_tracking_number)
                .filter(trackingNumber => trackingNumber); // Remove empty/null values
              
              // Debug logging
              console.log('Selected Vendor ID:', vendorReturnForm.vendor_id);
              console.log('Selected Product:', vendorReturnForm.selectedProductName);
              console.log('Selected Project ID:', vendorReturnForm.p_id);
              console.log('Delivery Data for Vendor+Product+Project:', deliveryStockData.filter(item => 
                String(item.vendor_id) === String(vendorReturnForm.vendor_id) && 
                item.product_name === vendorReturnForm.selectedProductName &&
                String(item.p_id) === String(vendorReturnForm.p_id)
              ));
              console.log('Available Tracking Numbers:', trackingNumbers);
              
              if (trackingNumbers.length === 0) {
                return <option disabled>No tracking numbers available for this vendor and product</option>;
              }
              
              return trackingNumbers.map((trackingNumber) => (
                <option key={trackingNumber} value={trackingNumber}>
                  {trackingNumber}
                </option>
              ));
            })()}
          </select>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <label className="form-control-label" htmlFor="return_date">
            Return Date
          </label>
          <Input
            className="form-control-alternative"
            id="return_date"
            type="date"
            name="return_date"
            value={vendorReturnForm.return_date}
            onChange={handleVendorReturnInputChange}
            required
          />
                    <div className="mt-2">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Select any date for the return
                      </small>
                    </div>
        </Col>
        <Col md={6}>
                    <label className="form-control-label" htmlFor="returned_by">
                      Returned By
                    </label>
                    <select
                      name="returned_by"
                      value={vendorReturnForm.returned_by}
                      className="form-select form-control-alternative custom-select"
                      id="returned_by"
                      onChange={handleVendorReturnInputChange}
                      required
                    >
                      <option value="">Select Client</option>
                      {getSingleReturnClients().map((client, idx) => (
                        <option key={idx} value={client}>{client}</option>
                      ))}
                    </select>
                  </Col>
        
        
      </Row>
                <Row className="mb-4">
                <Col md={6}>
          <label className="form-control-label" htmlFor="returned_quantity">
            Returned Quantity
          </label>
          <Input
            className="form-control-alternative"
            id="returned_quantity"
            type="number"
            name="returned_quantity"
            value={vendorReturnForm.returned_quantity}
            onChange={handleVendorReturnInputChange}
            placeholder="Enter Returned Quantity"
            required
          />
          {vendorReturnForm.material_tracking_number && vendorReturnForm.vendor_id && vendorReturnForm.selectedProductName && vendorReturnForm.p_id && (
            <div className="mt-2">
              {(() => {
                // Find the vendor_product_id based on selected product, vendor, and project from delivery records
                const selectedVendorProduct = deliveryStockData.find(item => 
                  item.product_name === vendorReturnForm.selectedProductName &&
                  String(item.vendor_id) === String(vendorReturnForm.vendor_id) &&
                  String(item.p_id) === String(vendorReturnForm.p_id)
                );
                
                if (!selectedVendorProduct) return null;
                
                const deliveredQty = getDeliveredQuantity(
                  vendorReturnForm.material_tracking_number,
                  selectedVendorProduct.vendor_product_id,
                  vendorReturnForm.p_id
                );
                const previouslyReturned = vendorReturnData
                  .filter(item => item.material_tracking_number === vendorReturnForm.material_tracking_number)
                  .reduce((sum, item) => sum + parseInt(item.returned_quantity || 0), 0);
                const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
                const currentReturned = parseInt(vendorReturnForm.returned_quantity || 0);
                
                return (
                  <>
                    <small className="text-muted">
                      <strong>Total Delivered: {deliveredQty}</strong>
                    </small>
                    <br />
                    <small style={{ color: '#666' }}>
                      <strong>Previously Returned: {previouslyReturned}</strong>
                    </small>
                    <br />
                    <small style={{ color: '#888' }}>
                      <i className="fas fa-info-circle mr-1"></i>
                      Remaining to Return = {remainingQty} - Current Return
                    </small>
                    {currentReturned > remainingQty && (
                      <>
                        <br />
                        <small style={{ color: '#dc3545', fontWeight: 'bold' }}>
                          <i className="fas fa-exclamation-triangle mr-1"></i>
                          Warning: Returned quantity exceeds remaining quantity!
                        </small>
                      </>
                    )}
                  </>
                );
              })()}
            </div>
          )}
        </Col>
                  
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="yet_to_returned">
                      Yet To Return (Auto-calculated)
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="yet_to_returned"
                      type="number"
                      name="yet_to_returned"
                      value={vendorReturnForm.yet_to_returned}
                      readOnly
                      style={{ backgroundColor: '#f8f9fa', color: '#6c757d' }}
                      placeholder="Auto-calculated"
                    />
                    {vendorReturnForm.material_tracking_number && vendorReturnForm.vendor_id && vendorReturnForm.selectedProductName && vendorReturnForm.p_id && (
                      <div className="mt-2">
                        {(() => {
                          // Find the vendor_product_id based on selected product, vendor, and project from delivery records
                          const selectedVendorProduct = deliveryStockData.find(item => 
                            item.product_name === vendorReturnForm.selectedProductName &&
                            String(item.vendor_id) === String(vendorReturnForm.vendor_id) &&
                            String(item.p_id) === String(vendorReturnForm.p_id)
                          );
                          
                          if (!selectedVendorProduct) return null;
                          
                          const deliveredQty = getDeliveredQuantity(
                            vendorReturnForm.material_tracking_number,
                            selectedVendorProduct.vendor_product_id,
                            vendorReturnForm.p_id
                          );
                          const previouslyReturned = vendorReturnData
                            .filter(item => item.material_tracking_number === vendorReturnForm.material_tracking_number)
                            .reduce((sum, item) => sum + parseInt(item.returned_quantity || 0), 0);
                          const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
                          const currentReturned = parseInt(vendorReturnForm.returned_quantity || 0);
                          const finalYetToReturn = Math.max(0, remainingQty - currentReturned);
                          
                          return (
                            <small className="text-muted">
                              <strong>Auto-calculated:</strong> Yet to Return = {remainingQty} (Remaining) - {currentReturned} (Current Return) = {finalYetToReturn}
                            </small>
                          );
                        })()}
                      </div>
                    )}
                  </Col>
                </Row>
      <Row className="mb-4">
        {/* <Col md={6}>
          <label className="form-control-label" htmlFor="delivered_quantity">
            Delivered Quantity
          </label>
          <Input
            className="form-control-alternative"
            id="delivered_quantity"
            type="number"
            value={getDeliveredQuantity(
              vendorReturnForm.material_tracking_number,
              vendorReturnForm.vendor_product_id,
              vendorReturnForm.p_id
            )}
            readOnly
            style={{ backgroundColor: '#f8f9fa', color: '#6c757d' }}
          />
        </Col> */}
      </Row>
      <Row>
        <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      type="submit"
                      style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', borderRadius: '25px', padding: '10px 25px' }}
                    >
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  </ModalBody>
</Modal>

<Modal isOpen={showDeliveryDeleteConfirmation} toggle={() => setShowDeliveryDeleteConfirmation(false)}>
  <ModalHeader>Confirm Deletion</ModalHeader>
  <ModalBody>Are you sure you want to delete this delivery record?</ModalBody>
  <div className="modal-footer">
    <Button color="danger" onClick={handleDeliveryDeleteConfirmation}>
      Yes
    </Button>
    <Button color="secondary" onClick={() => setShowDeliveryDeleteConfirmation(false)}>
      No
    </Button>
  </div>
</Modal>

<Modal isOpen={showReturnDeleteConfirmation} toggle={() => setShowReturnDeleteConfirmation(false)}>
  <ModalHeader>Confirm Deletion</ModalHeader>
  <ModalBody>Are you sure you want to delete this return record?</ModalBody>
  <div className="modal-footer">
    <Button color="danger" onClick={handleReturnDeleteConfirmation}>
      Yes
    </Button>
    <Button color="secondary" onClick={() => setShowReturnDeleteConfirmation(false)}>
      No
    </Button>
  </div>
</Modal>


          {showMaterialDeliverySuccess && (
            <div style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
              justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
            }}>
              <div style={{
                backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
              }}>
                <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{materialDeliverySuccessMsg}</p>
                <Button
                  style={{
                    backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                    padding: '10px 25px', borderRadius: '25px'
                  }}
                  onClick={() => { 
                    setShowMaterialDeliverySuccess(false); 
                    // Reload after closing the success message
                    setTimeout(() => {
                      window.location.reload();
                    }, 100);
                  }}
                >OK</Button>
              </div>
            </div>
          )}
          {showMaterialReturnSuccess && (
            <div style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
              justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
            }}>
              <div style={{
                backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
              }}>
                <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{materialReturnSuccessMsg}</p>
                <Button
                  style={{
                    backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                    padding: '10px 25px', borderRadius: '25px'
                  }}
                  onClick={() => { 
                    setShowMaterialReturnSuccess(false); 
                    // Reload after closing the success message
                    setTimeout(() => {
                      window.location.reload();
                    }, 100);
                  }}
                >OK</Button>
              </div>
            </div>
          )}

          <Modal isOpen={showMultiMaterialDeliveryModal} toggle={() => setShowMultiMaterialDeliveryModal(false)}>
            <ModalHeader toggle={() => setShowMultiMaterialDeliveryModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Multiple Material Delivery
              </h2>
            </ModalHeader>
            <ModalBody>
              {multiMaterialDeliveryMessage.text && (
                <Alert color={multiMaterialDeliveryMessage.type}>{multiMaterialDeliveryMessage.text}</Alert>
              )}
              <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                <ul className="mb-0">
                  <li>Upload an Excel or CSV file with columns: <strong>product_name, quantity_delivered, cost, material_tracking_number</strong></li>
                  <li>First row should contain headers exactly as shown above</li>
                  <li>Material tracking number must be exactly 6 characters (letters/numbers)</li>
                  <li>Quantity and cost must be positive numbers</li>
                  <li>Supported formats: .xlsx, .xls, .csv</li>
                  <li>Maximum file size: 5MB</li>
                </ul>
                <Button
                  color="link"
                  style={{ color: '#d86f89', textDecoration: 'underline', padding: 0 }}
                  onClick={() => {
                    // Generate and download a template file
                    const wsData = [
                      ['product_name', 'quantity_delivered', 'cost', 'material_tracking_number'],
                                              ['SampleProduct', '10', 'ABC123']
                    ];
                    const ws = XLSX.utils.aoa_to_sheet(wsData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Template');
                    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                    const blob = new Blob([wbout], { type: 'application/octet-stream' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'Vendor_Material_Delivery_Template.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }, 100);
                  }}
                >
                  Download Template
                </Button>
              </div>
              <Form onSubmit={handleMultiMaterialDeliverySubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiProject">Select Project</Label>
                    <Dropdown isOpen={multiMaterialDeliveryProjectDropdownOpen} toggle={() => setMultiMaterialDeliveryProjectDropdownOpen(!multiMaterialDeliveryProjectDropdownOpen)}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {multiMaterialDelivery.p_id ? (
                          <span style={{ color: '#495057' }}>
                            {projects.find(p => p.p_id === multiMaterialDelivery.p_id)?.p_name}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Select Project</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar Inside Dropdown */}
                        <div className="mb-2">
                    <Input
                            type="text"
                            placeholder="Search projects..."
                            value={multiMaterialDeliveryProjectSearch || ''}
                            onChange={(e) => setMultiMaterialDeliveryProjectSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => {
                          setMultiMaterialDelivery(prev => ({ ...prev, p_id: "" }));
                          setMultiMaterialDeliveryProjectDropdownOpen(false);
                        }}>
                          All Projects
                        </DropdownItem>
                        {projects
                          .filter(project => 
                            !multiMaterialDeliveryProjectSearch || 
                            project.p_name.toLowerCase().includes(multiMaterialDeliveryProjectSearch.toLowerCase())
                          )
                          .map((project) => (
                            <DropdownItem 
                              key={project.p_id} 
                              onClick={() => {
                                setMultiMaterialDelivery(prev => ({ ...prev, p_id: project.p_id }));
                                setMultiMaterialDeliveryProjectDropdownOpen(false);
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {project.p_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                    {multiMaterialDelivery.p_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Project: {projects.find(p => p.p_id === multiMaterialDelivery.p_id)?.p_name}
                        </small>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Label for="multiVendor">Select Vendor</Label>
                    <Dropdown isOpen={multiMaterialDeliveryVendorDropdownOpen} toggle={() => setMultiMaterialDeliveryVendorDropdownOpen(!multiMaterialDeliveryVendorDropdownOpen)}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {multiMaterialDelivery.vendor_id ? (
                          <span style={{ color: '#495057' }}>
                            {vendors.find(v => v.vendor_id === multiMaterialDelivery.vendor_id)?.vendor_name}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Select Vendor</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar Inside Dropdown */}
                        <div className="mb-2">
                    <Input
                            type="text"
                            placeholder="Search vendors..."
                            value={multiMaterialDeliveryVendorSearch || ''}
                            onChange={(e) => setMultiMaterialDeliveryVendorSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => {
                          setMultiMaterialDelivery(prev => ({ ...prev, vendor_id: "" }));
                          setMultiMaterialDeliveryVendorDropdownOpen(false);
                        }}>
                          All Vendors
                        </DropdownItem>
                        {vendors
                          .filter(vendor => 
                            !multiMaterialDeliveryVendorSearch || 
                            vendor.vendor_name.toLowerCase().includes(multiMaterialDeliveryVendorSearch.toLowerCase())
                          )
                          .map((vendor) => (
                            <DropdownItem 
                              key={vendor.vendor_id} 
                              onClick={() => {
                                setMultiMaterialDelivery(prev => ({ ...prev, vendor_id: vendor.vendor_id }));
                                setMultiMaterialDeliveryVendorDropdownOpen(false);
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {vendor.vendor_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                    {multiMaterialDelivery.vendor_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Vendor: {vendors.find(v => v.vendor_id === multiMaterialDelivery.vendor_id)?.vendor_name}
                        </small>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiDeliveredTo">Delivered To</Label>
                    <Input
                      type="text"
                      id="multiDeliveredTo"
                      name="delivered_to"
                      value={multiMaterialDelivery.delivered_to}
                      onChange={handleMultiMaterialDeliveryChange}
                      placeholder="Enter recipient name"
                      required
                      disabled={isMultiMaterialDeliveryUploading}
                    />
                  </Col>
                  <Col md={6}>
                    <Label for="multiDeliveryDate">Enter Delivery Date</Label>
                    <Input
                      type="date"
                      id="multiDeliveryDate"
                      name="delivery_date"
                      value={multiMaterialDelivery.delivery_date}
                      onChange={handleMultiMaterialDeliveryChange}
                      required
                      disabled={isMultiMaterialDeliveryUploading}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiDeliveryFile">Upload File (.csv, .xlsx, .xls)</Label>
                    <Input
                      type="file"
                      id="multiDeliveryFile"
                      name="file"
                      accept=".csv, .xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                      onChange={handleMultiMaterialDeliveryChange}
                      required
                      disabled={isMultiMaterialDeliveryUploading}
                    />
                    {multiMaterialDelivery.file && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {multiMaterialDelivery.file.name}
                      </small>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                      type="submit"
                      disabled={isMultiMaterialDeliveryUploading || !multiMaterialDelivery.file}
                    >
                      {isMultiMaterialDeliveryUploading ? "Uploading..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showMultiReturnModal} toggle={() => setShowMultiReturnModal(false)}>
            <ModalHeader toggle={() => setShowMultiReturnModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Multiple Return Materials
              </h2>
            </ModalHeader>
            <ModalBody>
              {multiReturnMessage.text && (
                <Alert color={multiReturnMessage.type}>{multiReturnMessage.text}</Alert>
              )}
              <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                <ul className="mb-0">
                  <li>Upload an Excel or CSV file with columns: <strong>product_name, quantity_returned, material_tracking_number</strong></li>
                  <li><strong>Note:</strong> The "yet_to_returned" field will be automatically calculated based on delivery records</li>
                  <li>First row should contain headers exactly as shown above</li>
                  <li>Supported formats: .xlsx, .xls, .csv</li>
                  <li>Maximum file size: 5MB</li>
                </ul>
                <Button
                  color="link"
                  style={{ color: '#d86f89', textDecoration: 'underline', padding: 0 }}
                  onClick={() => {
                    // Generate and download a template file
                    const wsData = [
                      ['product_name', 'quantity_returned', 'material_tracking_number'],
                                              ['SampleProduct', '10', 'ABC123']
                    ];
                    const ws = XLSX.utils.aoa_to_sheet(wsData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Template');
                    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                    const blob = new Blob([wbout], { type: 'application/octet-stream' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'Vendor_Material_Return_Template.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    }, 100);
                  }}
                >
                  Download Template
                </Button>
              </div>
              <Form onSubmit={handleMultiReturnSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnProject">Select Project</Label>
                    <Dropdown isOpen={multiReturnProjectDropdownOpen} toggle={() => setMultiReturnProjectDropdownOpen(!multiReturnProjectDropdownOpen)}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {multiReturn.p_id ? (
                          <span style={{ color: '#495057' }}>
                            {projects.find(p => p.p_id === multiReturn.p_id)?.p_name}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Select Project</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar Inside Dropdown */}
                        <div className="mb-2">
                    <Input
                            type="text"
                            placeholder="Search projects..."
                            value={multiReturnProjectSearch || ''}
                            onChange={(e) => setMultiReturnProjectSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => {
                          setMultiReturn(prev => ({ ...prev, p_id: "" }));
                          setMultiReturnProjectDropdownOpen(false);
                        }}>
                          All Projects
                        </DropdownItem>
                        {projects
                          .filter(project => 
                            !multiReturnProjectSearch || 
                            project.p_name.toLowerCase().includes(multiReturnProjectSearch.toLowerCase())
                          )
                          .map((project) => (
                            <DropdownItem 
                              key={project.p_id} 
                              onClick={() => {
                                setMultiReturn(prev => ({ ...prev, p_id: project.p_id }));
                                setMultiReturnProjectDropdownOpen(false);
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {project.p_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                    {multiReturn.p_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Project: {projects.find(p => p.p_id === multiReturn.p_id)?.p_name}
                        </small>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Label for="multiReturnVendor">Select Vendor</Label>
                    <Dropdown isOpen={multiReturnVendorDropdownOpen} toggle={() => setMultiReturnVendorDropdownOpen(!multiReturnVendorDropdownOpen)}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {multiReturn.vendor_id ? (
                          <span style={{ color: '#495057' }}>
                            {vendors.find(v => v.vendor_id === multiReturn.vendor_id)?.vendor_name}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Select Vendor</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar Inside Dropdown */}
                        <div className="mb-2">
                    <Input
                            type="text"
                            placeholder="Search vendors..."
                            value={multiReturnVendorSearch || ''}
                            onChange={(e) => setMultiReturnVendorSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => {
                          setMultiReturn(prev => ({ ...prev, vendor_id: "" }));
                          setMultiReturnVendorDropdownOpen(false);
                        }}>
                          All Vendors
                        </DropdownItem>
                        {vendors
                          .filter(vendor => 
                            !multiReturnVendorSearch || 
                            vendor.vendor_name.toLowerCase().includes(multiReturnVendorSearch.toLowerCase())
                          )
                          .map((vendor) => (
                            <DropdownItem 
                              key={vendor.vendor_id} 
                              onClick={() => {
                                setMultiReturn(prev => ({ ...prev, vendor_id: vendor.vendor_id }));
                                setMultiReturnVendorDropdownOpen(false);
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {vendor.vendor_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                    {multiReturn.vendor_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Vendor: {vendors.find(v => v.vendor_id === multiReturn.vendor_id)?.vendor_name}
                        </small>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnBy">Enter Returned By</Label>
                    <Input
                      type="select"
                      id="multiReturnBy"
                      name="returned_by"
                      value={multiReturn.returned_by}
                      onChange={handleMultiReturnChange}
                      required
                      disabled={!multiReturn.p_id || !multiReturn.vendor_id || isMultiReturnUploading}
                    >
                      <option value="">Select Client</option>
                      {multiReturnClients.length > 0 ? (
                        multiReturnClients.map((client, idx) => (
                        <option key={idx} value={client}>{client}</option>
                        ))
                      ) : (
                        <option disabled>
                          {!multiReturn.p_id || !multiReturn.vendor_id 
                            ? 'Please select both project and vendor first' 
                            : 'No clients found for selected project and vendor'}
                        </option>
                      )}
                    </Input>
                    {multiReturnClients.length > 0 && (
                      <small className="text-muted mt-1">
                        Found {multiReturnClients.length} client(s): {multiReturnClients.join(', ')}
                      </small>
                    )}
                    {multiReturn.p_id && multiReturn.vendor_id && multiReturnClients.length === 0 && (
                      <small className="text-warning mt-1">
                        <i className="fas fa-exclamation-triangle me-1"></i>
                        No delivery records found for this project and vendor combination
                      </small>
                    )}
                  </Col>
                  <Col md={6}>
                    <Label for="multiReturnDate">Enter Return Date</Label>
                    <Input
                      type="date"
                      id="multiReturnDate"
                      name="return_date"
                      value={multiReturn.return_date}
                      onChange={handleMultiReturnChange}
                      required
                      disabled={isMultiReturnUploading}
                    />
                    <div className="mt-2">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Select any date for the return
                      </small>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnFile">Upload File (.csv, .xlsx, .xls)</Label>
                    <Input
                      type="file"
                      id="multiReturnFile"
                      name="file"
                      accept=".csv, .xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                      onChange={handleMultiReturnChange}
                      required
                      disabled={isMultiReturnUploading}
                    />
                    {multiReturn.file && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {multiReturn.file.name}
                      </small>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                      type="submit"
                      disabled={isMultiReturnUploading || !multiReturn.file}
                    >
                      {isMultiReturnUploading ? "Uploading..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          {/* Return to Vendor Modal */}
          <Modal isOpen={showReturnToVendorModal} toggle={() => {
            setShowReturnToVendorModal(false);
            // Reset form when modal is closed
            setReturnToVendorForm({
              vendor_id: "",
              product_id: "",
              project_id: "",
              quantity_returned: "",
              return_date: "",
              return_reason: ""
            });
          }}>
            <ModalHeader toggle={() => setShowReturnToVendorModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Return Stock to Vendor
              </h2>
            </ModalHeader>
            <ModalBody>
              <div className="alert alert-info mb-3" style={{ backgroundColor: '#e7f3ff', borderColor: '#b3d9ff', color: '#004085' }}>
                <i className="fas fa-info-circle me-2"></i>
                <strong>Instructions:</strong> 
                <ol className="mb-0 mt-2">
                  <li>Select a vendor first</li>
                  <li>Choose from available products (only products with stock &gt; 0)</li>
                  <li>Enter the quantity to return</li>
                  <li>Set the return date and reason</li>
                </ol>
              </div>
              <Form onSubmit={handleReturnToVendorSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="vendor_id">
                      Select Vendor
                    </label>
                    <select
                      name="vendor_id"
                      className="form-select form-control-alternative custom-select"
                      id="vendor_id"
                      value={returnToVendorForm.vendor_id}
                      onChange={handleReturnToVendorInputChange}
                      required
                      style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                      }}
                    >
                      <option value="">Select Vendor</option>
                      {vendors.map((vendor) => (
                        <option key={vendor.vendor_id} value={vendor.vendor_id}>
                          {vendor.vendor_name}
                        </option>
                      ))}
                    </select>
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="product_id">
                      Select Product
                    </label>
                    <select
                      name="product_id"
                      className="form-select form-control-alternative custom-select"
                      id="product_id"
                      value={returnToVendorForm.product_id}
                      onChange={handleReturnToVendorInputChange}
                      required
                      disabled={!returnToVendorForm.vendor_id}
                      style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                      }}
                    >
                      <option value="">Select Product</option>
                      {(() => {
                        const filteredProducts = originalData.filter((item) => {
                          // Filter by vendor
                          const matchesVendor = String(item.vendor_id) === String(returnToVendorForm.vendor_id);
                          
                          // Filter by available stock
                          const hasStock = parseInt(item.available_stock) > 0;
                          
                          return matchesVendor && hasStock;
                        });
                        
                        if (filteredProducts.length === 0) {
                          if (returnToVendorForm.vendor_id) {
                            return (
                              <option disabled style={{ color: '#6c757d', fontStyle: 'italic' }}>
                                No products available for {vendors.find(v => v.vendor_id === returnToVendorForm.vendor_id)?.vendor_name}. Try selecting a different vendor or check if products have stock.
                              </option>
                            );
                          } else {
                            return (
                              <option disabled style={{ color: '#6c757d', fontStyle: 'italic' }}>
                                Please select a vendor first
                              </option>
                            );
                          }
                        }
                        
                        return filteredProducts.map((item) => (
                          <option key={item.vendor_product_id} value={item.vendor_product_id}>
                            {item.product_name} (Available: {item.available_stock})
                          </option>
                        ));
                      })()}
                    </select>
                    {returnToVendorForm.vendor_id && (() => {
                      const availableProducts = originalData.filter((item) => {
                        const matchesVendor = String(item.vendor_id) === String(returnToVendorForm.vendor_id);
                        const hasStock = parseInt(item.available_stock) > 0;
                        return matchesVendor && hasStock;
                      });
                      
                      return (
                        <div className="mt-2">
                          <small className="text-muted">
                            Found {availableProducts.length} product(s) available for return
                          </small>
                        </div>
                      );
                    })()}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="quantity_returned">
                      Quantity to Return
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="quantity_returned"
                      type="number"
                      name="quantity_returned"
                      value={returnToVendorForm.quantity_returned}
                      onChange={handleReturnToVendorInputChange}
                      placeholder="Enter quantity"
                      disabled={!returnToVendorForm.product_id}
                      min="1"
                      step="1"
                      // Temporarily removed max attribute to fix validation issue
                      // max={(() => {
                      //   if (returnToVendorForm.product_id) {
                      //     const selectedProduct = originalData.find(item => item.vendor_product_id === returnToVendorForm.product_id);
                      //     return selectedProduct ? parseInt(selectedProduct.available_stock) : 999999;
                      //   }
                      //   return 999999;
                      // })()}
                      required
                    />
                    {!returnToVendorForm.product_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          <i className="fas fa-info-circle me-1"></i>
                          Please select a product first to enter quantity
                        </small>
                      </div>
                    )}
                    {returnToVendorForm.product_id && (() => {
                      const selectedProduct = originalData.find(item => item.vendor_product_id === returnToVendorForm.product_id);
                      if (selectedProduct) {
                        const maxValue = parseInt(selectedProduct.available_stock);
                        console.log('Quantity input debug:', {
                          product_id: returnToVendorForm.product_id,
                          available_stock: selectedProduct.available_stock,
                          maxValue: maxValue,
                          currentQuantity: returnToVendorForm.quantity_returned
                        });
                        return (
                          <div className="mt-2">
                            <small className="text-muted">
                              Maximum available stock: <strong>{selectedProduct.available_stock}</strong>
                            </small>
                            <br />
                            <small className="text-info">
                              <i className="fas fa-bug me-1"></i>
                              Input max attribute: {maxValue}
                            </small>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="return_date">
                      Return Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="return_date"
                      type="date"
                      name="return_date"
                      value={returnToVendorForm.return_date}
                      onChange={handleReturnToVendorInputChange}
                      required
                    />
                    <div className="mt-2">
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Select any date for the return
                      </small>
                    </div>
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="return_reason">
                      Return Reason (Optional)
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="return_reason"
                      type="text"
                      name="return_reason"
                      value={returnToVendorForm.return_reason}
                      onChange={handleReturnToVendorInputChange}
                      placeholder="Enter return reason"
                    />
                  </Col>
                </Row>
                {/* Summary Section */}
                {(returnToVendorForm.vendor_id || returnToVendorForm.product_id) && (
                  <Row className="mb-4">
                    <Col lg="12">
                      <div className="alert alert-light" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
                        <h6 className="mb-2"><i className="fas fa-info-circle me-2"></i>Selection Summary:</h6>
                        <div className="row text-black">
                          {returnToVendorForm.vendor_id && (
                            <div className="col-md-4">
                              <strong>Vendor:</strong> {vendors.find(v => v.vendor_id === returnToVendorForm.vendor_id)?.vendor_name}
                            </div>
                          )}

                          {returnToVendorForm.product_id && (
                            <div className="col-md-4">
                              <strong>Product:</strong> {originalData.find(item => item.vendor_product_id === returnToVendorForm.product_id)?.product_name}
                              {(() => {
                                const selectedProduct = originalData.find(item => item.vendor_product_id === returnToVendorForm.product_id);
                                return selectedProduct ? ` (Available: ${selectedProduct.available_stock})` : '';
                              })()}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      color="primary"
                      type="submit"
                      disabled={!returnToVendorForm.vendor_id || !returnToVendorForm.product_id || !returnToVendorForm.quantity_returned || !returnToVendorForm.return_date}
                      onClick={() => {
                        console.log('Submit button clicked');
                        console.log('Form data:', returnToVendorForm);
                        console.log('Validation check:', {
                          hasVendor: !!returnToVendorForm.vendor_id,
                          hasProduct: !!returnToVendorForm.product_id,
                          hasQuantity: !!returnToVendorForm.quantity_returned,
                          hasDate: !!returnToVendorForm.return_date,
                          quantityValue: returnToVendorForm.quantity_returned,
                          quantityType: typeof returnToVendorForm.quantity_returned
                        });
                      }}
                      style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', borderRadius: '25px', padding: '10px 25px' }}>
                      Return to Vendor
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          {/* Multiple Return to Vendor Modal */}
          <Modal isOpen={showMultiReturnToVendorModal} toggle={() => {
            setShowMultiReturnToVendorModal(false);
            // Reset form when closing modal
            setMultiReturnToVendor({
              vendor_id: '',
              return_date: '',
              file: null,
            });
            setMultiReturnToVendorMessage({ type: '', text: '' });
          }}>
            <ModalHeader toggle={() => setShowMultiReturnToVendorModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Multiple Returns to Vendor
              </h2>
            </ModalHeader>
            <ModalBody>
              {multiReturnToVendorMessage.text && (
                <Alert color={multiReturnToVendorMessage.type}>
                  {multiReturnToVendorMessage.text}
                </Alert>
              )}
              
              <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                <ul className="mb-0">
                  <li>Upload an Excel or CSV file with columns: <strong>product_name, quantity_returned, return_reason</strong></li>
                  <li>First row should contain headers exactly as shown above</li>
                  <li>Product name must match exactly with existing vendor products</li>
                  <li>Quantity must be positive and not exceed available stock</li>
                  <li>Return reason is optional but recommended</li>
                  <li>Supported formats: .xlsx, .xls, .csv</li>
                  <li>Maximum file size: 5MB</li>
                </ul>
                <div className="mt-2">
                  <Button
                    color="link"
                    style={{ color: '#d86f89', textDecoration: 'underline', padding: 0 }}
                    onClick={() => {
                      // Generate and download a template file
                      const wsData = [
                        ['product_name', 'quantity_returned', 'return_reason'],
                        ['SampleProduct', '10', 'Quality issue']
                      ];
                      const ws = XLSX.utils.aoa_to_sheet(wsData);
                      const wb = XLSX.utils.book_new();
                      XLSX.utils.book_append_sheet(wb, ws, 'Template');
                      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                      const blob = new Blob([wbout], { type: 'application/octet-stream' });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'Store_To_Vendor_Return_Template.xlsx';
                      document.body.appendChild(a);
                      a.click();
                      setTimeout(() => {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                      }, 100);
                    }}
                  >
                    Download Template
                  </Button>
                </div>
              </div>

              <Form onSubmit={handleMultiReturnToVendorSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnToVendorVendor">Select Vendor</Label>
                    <Input
                      type="select"
                      id="multiReturnToVendorVendor"
                      name="vendor_id"
                      value={multiReturnToVendor.vendor_id}
                      onChange={handleMultiReturnToVendorChange}
                      required
                      disabled={isMultiReturnToVendorUploading}
                    >
                      <option value="">Select Vendor</option>
                      {vendors.map((vendor) => (
                        <option key={vendor.vendor_id} value={vendor.vendor_id}>{vendor.vendor_name}</option>
                      ))}
                    </Input>
                    {multiReturnToVendor.vendor_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Vendor: {vendors.find(v => v.vendor_id === multiReturnToVendor.vendor_id)?.vendor_name}
                        </small>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Label for="multiReturnToVendorDate">Enter Return Date</Label>
                    <Input
                      type="date"
                      id="multiReturnToVendorDate"
                      name="return_date"
                      value={multiReturnToVendor.return_date}
                      onChange={handleMultiReturnToVendorChange}
                      required
                      disabled={isMultiReturnToVendorUploading}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={12}>
                    <Label for="multiReturnToVendorFile">Upload File (.csv, .xlsx, .xls)</Label>
                    <Input
                      type="file"
                      id="multiReturnToVendorFile"
                      name="file"
                      accept=".csv, .xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                      onChange={handleMultiReturnToVendorChange}
                      required
                      disabled={isMultiReturnToVendorUploading}
                    />
                    {multiReturnToVendor.file && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {multiReturnToVendor.file.name}
                      </small>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                      type="submit"
                      disabled={isMultiReturnToVendorUploading || !multiReturnToVendor.file}
                    >
                      {isMultiReturnToVendorUploading ? "Uploading..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          {/* Project Report Section */}
          <Row className="mt-4">
            <Col xl="12">
              <Card className="shadow">
                <CardBody style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)' }}>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Project Report</h3>
                        <div className="d-flex align-items-center gap-2" style={{ flexWrap: 'nowrap' }}>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={generateProjectReport}
                            disabled={projectReportGenerating || projectReportLoading}
                            style={{
                              backgroundColor: "#d86f89",
                              borderColor: "#d86f89",
                              color: "black",
                              fontWeight: 600,
                              borderRadius: '0.375rem',
                              boxShadow: 'none',
                              padding: '0.5rem 1.25rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5em'
                            }}
                          >
                            {projectReportGenerating ? (
                              <>
                                <i className="fas fa-spinner fa-spin mr-2"></i>
                                Generating...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-sync-alt mr-2"></i>
                                Generate Report
                              </>
                            )}
                          </Button>
                          <Button
                            color="success"
                            size="sm"
                            onClick={exportProjectReportToCSV}
                            disabled={filteredProjectReports.length === 0 || projectReportLoading}
                            style={{
                              backgroundColor: "#d86f89",
                              borderColor: "#d86f89",
                              color: "black",
                              fontWeight: 600,
                              borderRadius: '0.375rem',
                              boxShadow: 'none',
                              padding: '0.5rem 1.25rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5em'
                            }}
                          >
                            <i className="fas fa-download mr-2"></i>
                            Export CSV
                          </Button>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  {/* Message Alert */}
                  {projectReportMessage && (
                    <Alert color={projectReportMessageType} className="mb-4">
                      {projectReportMessage}
                    </Alert>
                  )}

                  {/* Filters Section */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="3">
                        <Label className="form-control-label" style={{ fontWeight: 'bold', marginBottom: '8px' }}>Project Filter:</Label>
                        <Dropdown isOpen={projectReportProjectDropdownOpen} toggle={() => setProjectReportProjectDropdownOpen(!projectReportProjectDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', border: '1px solid #ced4da' }}>
                            {selectedProjectReportProject ? 
                              projects.find(p => p.p_id == selectedProjectReportProject)?.p_name || 'Select Project' :
                              'All Projects'
                            }
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar Inside Dropdown */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search projects..."
                                value={projectReportProjectSearch || ''}
                                onChange={(e) => setProjectReportProjectSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem 
                              onClick={() => setSelectedProjectReportProject('')}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              All Projects
                            </DropdownItem>
                            {projects
                              .filter(project => 
                                !projectReportProjectSearch || 
                                project.p_name.toLowerCase().includes(projectReportProjectSearch.toLowerCase())
                              )
                              .map(project => (
                                <DropdownItem 
                                  key={project.p_id} 
                                  onClick={() => setSelectedProjectReportProject(project.p_id)}
                                  style={{ padding: '6px 12px', fontSize: '13px' }}
                                >
                                  {project.p_name}
                                </DropdownItem>
                              ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label" style={{ fontWeight: 'bold', marginBottom: '8px' }}>Vendor Filter:</Label>
                        <Dropdown isOpen={projectReportVendorDropdownOpen} toggle={() => setProjectReportVendorDropdownOpen(!projectReportVendorDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', border: '1px solid #ced4da' }}>
                            {selectedProjectReportVendor ? 
                              vendors.find(v => v.vendor_id === selectedProjectReportVendor)?.vendor_name || 'Select Vendor' :
                              'All Vendors'
                            }
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%' }}>
                            <DropdownItem onClick={() => setSelectedProjectReportVendor('')}>
                              All Vendors
                            </DropdownItem>
                            {vendors.map(vendor => (
                              <DropdownItem 
                                key={vendor.vendor_id} 
                                onClick={() => {
                                  console.log('🎯 Vendor selected:', vendor.vendor_id, vendor.vendor_name);
                                  console.log('🎯 Vendor ID type:', typeof vendor.vendor_id);
                                  console.log('🎯 Setting selectedProjectReportVendor to:', vendor.vendor_id);
                                  setSelectedProjectReportVendor(vendor.vendor_id);
                                }}
                              >
                                {vendor.vendor_name}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="3">
                        <Label className="form-control-label" style={{ fontWeight: 'bold', marginBottom: '8px' }}>Product Search:</Label>
                        <Input
                          type="text"
                          placeholder="Search products..."
                          value={projectReportProductSearch}
                          onChange={(e) => setProjectReportProductSearch(e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="3">
                        <div className="d-flex gap-2 align-items-end">
                          <Button
                            color="secondary"
                            size="sm"
                            onClick={clearProjectReportFilters}
                            style={{ marginTop: '25px' }}
                          >
                            Clear Filters
                          </Button>
                          
                          {/* Show Entries Dropdown */}
                          <div className="d-flex align-items-center gap-2" style={{ marginTop: '25px' }}>
                            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Show Entries:</span>
                            <Dropdown isOpen={projectReportEntriesDropdownOpen} toggle={() => setProjectReportEntriesDropdownOpen(!projectReportEntriesDropdownOpen)}>
                              <DropdownToggle caret size="sm" style={{ backgroundColor: 'white', border: '1px solid #ced4da' }}>
                                {projectReportEntriesPerPage === filteredProjectReports.length ? "All" : projectReportEntriesPerPage}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(5)}>5</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(10)}>10</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(25)}>25</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(50)}>50</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(100)}>100</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(filteredProjectReports.length)}>All</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>


                  {/* Project Report Table */}
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.NO</th>
                        <th scope="col">PROJECT NAME</th>
                        <th scope="col">PRODUCT NAME</th>
                        <th scope="col">VENDOR NAME</th>
                        <th scope="col" className="text-right">DELIVERED QTY</th>
                        <th scope="col" className="text-right">RETURNED QTY</th>
                        <th scope="col" className="text-right">YET TO RETURN</th>
                        <th scope="col" className="text-right">LAST UPDATED</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projectReportLoading ? (
                        <tr>
                          <td colSpan="8" style={{ color: '#888', fontWeight: 'bold' }}>
                            Loading project reports...
                          </td>
                        </tr>
                      ) : projectReportPaginatedData.length === 0 ? (
                        <tr>
                          <td colSpan="8" style={{ color: '#888', fontWeight: 'bold' }}>
                            No project reports found. Generate a report to see data.
                          </td>
                        </tr>
                      ) : (
                        projectReportPaginatedData.map((report, index) => (
                          <tr key={report.report_id}>
                            <td>{(projectReportCurrentPage - 1) * projectReportEntriesPerPage + index + 1}</td>
                            <td>
                              <span className="font-weight-bold">{report.project_name}</span>
                            </td>
                            <td>{report.product_name}</td>
                            <td>{report.vendor_name}</td>
                            <td className="text-right">
                              <span style={{ color: '#007bff', fontWeight: 'bold' }}>
                                {parseFloat(report.delivered_quantity).toFixed(2)}
                              </span>
                            </td>
                            <td className="text-right">
                              <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                {parseFloat(report.returned_quantity).toFixed(2)}
                              </span>
                            </td>
                            <td className="text-right">
                              <span style={{ 
                                color: parseFloat(report.yet_to_return) > 0 ? '#dc3545' : '#28a745',
                                fontWeight: 'bold'
                              }}>
                                {parseFloat(report.yet_to_return).toFixed(2)}
                              </span>
                            </td>
                            <td className="text-right">
                              <small className="text-muted">
                                {new Date(report.last_updated).toLocaleDateString()}
                              </small>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>

                  {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((projectReportCurrentPage - 1) * projectReportEntriesPerPage) + 1} to {Math.min(projectReportCurrentPage * projectReportEntriesPerPage, filteredProjectReports.length)} of {filteredProjectReports.length} entries
                    </div>
                  </div>

                  {/* Pagination */}
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={projectReportPrevPage}
                          disabled={projectReportCurrentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={projectReportNextPage}
                          disabled={projectReportCurrentPage === Math.ceil(filteredProjectReports.length / projectReportEntriesPerPage)}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Success/Error Alert Modal (similar to Storemanagement4.js) */}
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '600px', width: '90%', 
            border: alertType === 'success' ? '3px solid #d86f89' : '3px solid #dc3545'
          }}>
            <div style={{ 
              fontSize: '48px', 
              color: alertType === 'success' ? '#d86f89' : '#dc3545', 
              marginBottom: '20px' 
            }}>
              {alertType === 'success' ? '✓' : '✗'}
            </div>
            <h4 style={{ 
              color: alertType === 'success' ? '#28a745' : '#dc3545', 
              marginBottom: '15px' 
            }}>
              {alertType === 'success' ? 'Success!' : 'Error!'}
            </h4>
            <div style={{ 
              color: '#333', 
              fontSize: '14px', 
              marginBottom: '20px', 
              textAlign: 'left',
              whiteSpace: 'pre-line',
              maxHeight: '300px',
              overflowY: 'auto',
              padding: '10px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              {successMessage}
            </div>
            <Button
              style={{
                backgroundColor: alertType === 'success' ? '#d86f89' : '#dc3545', 
                borderColor: alertType === 'success' ? '#d86f89' : '#dc3545', 
                color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                if (alertType === 'success') {
                  window.location.reload();
                }
              }}
            >OK</Button>
          </div>
        </div>
      )}

    </>
  );
};

export default VendorManagement;